// ============================================
// NXT RESERVE — Bubble API Service
// ============================================

// s184 - LA UNICA DEFINICION DE LA BASE. Ticket api-base-hardcodeada-x6: esta
// misma URL estaba escrita SEIS veces (aca y cinco copias sueltas dentro de
// App.jsx, cada una declarada adentro de una funcion). Para mover el front a otra
// app de Bubble habia que acordarse de las seis, y olvidarse de una no rompe el
// build: deja unas pantallas apuntando a la app vieja y otras a la nueva, en
// silencio. Ahora se exporta y se importa.
//
// s201 · front-sin-entorno-dev: LA VERSION DE BUBBLE SALE DEL ENTORNO. Hasta aca
// esto decia `version-live` fijo y correr `npm start` escribia en la base que ven
// los usuarios (L#400/L#401: los ~21 comercios de prueba del catalogo). Ahora:
//   · `npm start`              -> test  (NODE_ENV development)
//   · `npm run build` / Netlify -> live  (NODE_ENV production)
//   · vistas previas de Netlify -> test  (netlify.toml fija REACT_APP_BUBBLE_VERSION)
//   · `npm run start:live`     -> live a proposito, en el puerto 3001 (scripts/start-live.js)
// Un valor que no sea `live` ni `test` cae al de su entorno: un typo en Netlify no
// puede dejar produccion apuntando a otro lado.
// 🛑 La variable tiene que estar DEFINIDA en todo build que se publique (netlify.toml la
// fija). Si falta, Create React App pega en el bundle el objeto con TODAS las REACT_APP_*
// del entorno en lugar de `undefined` — ver el comentario de netlify.toml.
const VERSION_POR_DEFECTO = process.env.NODE_ENV === "production" ? "live" : "test";
const VERSION_PEDIDA = process.env.REACT_APP_BUBBLE_VERSION;
export const BUBBLE_VERSION = VERSION_PEDIDA === "live" || VERSION_PEDIDA === "test"
  ? VERSION_PEDIDA : VERSION_POR_DEFECTO;
export const API_BASE = `https://novaaimarketing.bubbleapps.io/version-${BUBBLE_VERSION}/api/1.1`;
// s103: ADMIN_TOKEN ELIMINADO del bundle. Lecturas públicas → apiGetPublic (anónimo,
// privacy pública curada); lecturas admin → token del admin logueado; margen del asesor
// → WF get_margin_note (gateado a Merchant). Ver PLAN_migracion_apijs_token_s101.
// ---- AUTH HELPERS ----
// s187 - LA IDENTIDAD AVISA CUANDO CAMBIA. Antes `auth` era solo lectura y
// escritura de localStorage: nadie se enteraba de un login ni de un logout.
// React no puede reaccionar a algo que no emite, asi que el estado de sesion que
// vivia en memoria (el proveedor de cupones) sobrevivia al cambio de cuenta EN LA
// MISMA PESTANA — la segunda persona veia el ahorro de la primera.
//
// La suscripcion vive ACA y no en un contexto de React a proposito: `auth.save`
// lo llaman `loginUser` y `signupUser` desde este archivo, y `clear`/`logout` los
// llaman SIETE botones distintos en App.jsx. Poner la fuente de verdad en React
// obligaria a tocar los nueve sitios y a que ninguno se olvide; poniendola en el
// unico lugar por donde pasan todos, ninguno tiene que acordarse de nada.
//
// `sessionKey()` es lo que React observa: un STRING estable ("" = nadie). Tiene
// que ser un valor comparable con Object.is en cada render — por eso devuelve
// texto y no un objeto, que seria distinto cada vez y giraria para siempre.
const oyentesAuth = new Set();
function avisarCambioDeSesion() {
  oyentesAuth.forEach((fn) => { try { fn(); } catch (e) { /* un oyente roto no rompe el logout */ } });
}

export const auth = {
  getToken: () => localStorage.getItem("nxt_token"),
  getUserId: () => localStorage.getItem("nxt_user_id"),
  isLoggedIn: () => !!localStorage.getItem("nxt_token"),
  // Quien es el dueno de lo que hay en memoria. "" cuando no hay nadie.
  // El fallback "sin-id" cubre la sesion vieja que tenga token y no user_id:
  // sigue siendo UNA sesion distinta de "" y de cualquier id real.
  // Defensivo como todo `enganche.js`: en Safari privado y con las cookies de
  // sitio bloqueadas `getItem` TIRA, y esto lo lee React en CADA render. Una
  // excepcion aca seria la pantalla en blanco, no un dato faltante.
  sessionKey: () => {
    try {
      const t = localStorage.getItem("nxt_token");
      if (!t) return "";
      return localStorage.getItem("nxt_user_id") || "sin-id";
    } catch (e) { return ""; }
  },
  // Devuelve la funcion para desuscribirse (contrato de useSyncExternalStore).
  // El evento `storage` llega solo a las OTRAS pestanas: con esto, cerrar sesion
  // en una limpia la franja de la otra sin recargar.
  subscribe: (fn) => {
    oyentesAuth.add(fn);
    const alCambiarElAlmacen = (e) => {
      if (!e || e.key === null || e.key === "nxt_token" || e.key === "nxt_user_id") fn();
    };
    window.addEventListener("storage", alCambiarElAlmacen);
    return () => {
      oyentesAuth.delete(fn);
      window.removeEventListener("storage", alCambiarElAlmacen);
    };
  },
  save: (token, userId) => {
    localStorage.setItem("nxt_token", token);
    localStorage.setItem("nxt_user_id", userId);
    try { document.body.classList.add("is-authed"); } catch (e) {}
    avisarCambioDeSesion();
  },
  clear: () => {
    localStorage.removeItem("nxt_token");
    localStorage.removeItem("nxt_user_id");
    localStorage.removeItem("nxt_tier");
    localStorage.removeItem("nxt_role");
    try { document.body.classList.remove("is-authed"); } catch (e) {}
    avisarCambioDeSesion();
  },
  logout: () => {
    localStorage.removeItem("nxt_token");
    localStorage.removeItem("nxt_user_id");
    localStorage.removeItem("nxt_tier");
    localStorage.removeItem("nxt_role");
    try { document.body.classList.remove("is-authed"); } catch (e) {}
    avisarCambioDeSesion();
  },
};

// ---- HTTP HELPERS ----
function getHeaders(userToken) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${userToken || auth.getToken()}`,
  };
}

async function apiGet(endpoint, userToken) {
  try {
    const res = await fetch(`${API_BASE}${endpoint}`, {
      headers: getHeaders(userToken),
    });
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return await res.json();
  } catch (e) {
    console.error("GET", endpoint, e);
    return null;
  }
}

// GET público SIN Authorization (canal de lectura anónimo del catálogo, s101).
// La privacy pública curada (Offer "Public sees approved", MerchantPartner "Public
// sees approved") decide qué campos ve el visitante. NO manda token → nada de ADMIN_TOKEN
// en el bundle para estas lecturas.
// s227 · preinauguración: con el candado de privacy (las reglas públicas exigen rol Operator), el canal anónimo
// queda vacío. Si hay sesión, la lectura va CON EL TOKEN DEL USUARIO (nunca uno de admin): Admin lee todo, Operator
// pasa el candado y el dueño lee lo suyo («Owner sees own», «Merchant sees own offers»). Con el club abierto da lo
// mismo. Si el token venció (401/403), se reintenta anónimo, como antes.
async function apiGetPublic(endpoint) {
  try {
    const t = auth.getToken();
    let res = await fetch(`${API_BASE}${endpoint}`, {
      headers: t ? { "Content-Type": "application/json", Authorization: `Bearer ${t}` } : { "Content-Type": "application/json" },
    });
    if (t && (res.status === 401 || res.status === 403)) {
      res = await fetch(`${API_BASE}${endpoint}`, { headers: { "Content-Type": "application/json" } });
    }
    if (!res.ok) throw new Error(`Error ${res.status}`);
    return await res.json();
  } catch (e) {
    console.error("GET(public)", endpoint, e);
    return null;
  }
}

// s233 · la versión PAGINADA de apiGetPublic (el apiGetTodo del canal público): la Data API devuelve 100 como mucho
// por pedido, y con más de 100 comercios u ofertas lo que quedaba afuera perdía logo, galería y zona en el catálogo.
// Mismo tope de seguridad que apiGetTodo: 50 páginas. Devuelve la lista, o null si la PRIMERA página falla (como
// apiGetPublic: los llamadores ya tratan null como «sin datos»). Si falla una página intermedia, se queda con lo leído.
async function apiGetTodoPublic(path) {
  const out = [];
  let cursor = 0;
  for (let pagina = 0; pagina < 50; pagina++) {
    const sep = path.includes("?") ? "&" : "?";
    const data = await apiGetPublic(`${path}${sep}limit=100&cursor=${cursor}`);
    const r = data?.response;
    if (!r || !Array.isArray(r.results)) return pagina === 0 ? null : out;
    out.push(...r.results);
    if (!r.remaining || !r.results.length) break;
    cursor += r.results.length;
  }
  return out;
}

async function apiPost(endpoint, body, userToken, signal) {
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: "POST",
    headers: getHeaders(userToken),
    body: JSON.stringify(body),
    ...(signal ? { signal } : {}),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(
      data?.body?.message || data?.message || `Error ${res.status}`
    );
  }
  return data;
}

// Like apiPost but also throws if the WF returned HTTP 200 with an explicit
// failure signal in `response`. Pattern L#83: Bubble WFs return HTTP 200 with
// `{success: false}` / `{success: "no"}` / `{error_code}` on logical failure.
// Tolerant (deny-list): allows `{}`, `{success: true}`, `{success: "yes"}`,
// or the thing itself — only throws on explicit fail. Avoids regressing WFs
// that return `{}` on success (e.g. block_user no-op, D53).
async function apiPostGuarded(endpoint, body, userToken, signal) {
  const data = await apiPost(endpoint, body, userToken, signal);
  const resp = data?.response;
  if (resp?.success === false || resp?.success === "no" || resp?.error_code) {
    // s176 FIX 5: los WFs no se pusieron de acuerdo en como se llama la clave del error.
    // 42 devuelven `error_code`; offer_advisor e ingest_offer_ideas devuelven `code` a
    // secas (offer_advisor usa LAS DOS: error_code para NOT_MERCHANT, code para
    // GENERATION_LIMIT). Sin `code` en la cadena, un GENERATION_LIMIT del carril rapido
    // llegaba como "/wf/offer_advisor failed" y con err.code = "OPERATION_FAILED", o sea
    // invisible para el mapeo de mensajes de la UI.
    const err = new Error(
      resp?.error_message || resp?.error_code || resp?.code || resp?.error || `${endpoint} failed`
    );
    err.code = resp?.error_code || resp?.code || "OPERATION_FAILED";
    throw err;
  }
  return resp;
}
// 🔴 s176 FIX 5 — POR QUE `code` NO SE AGREGA A LA CONDICION DEL IF DE ARRIBA:
// seis WFs devuelven `code` en su rama de EXITO — create_access_code y
// create_one_batch_code (el codigo generado), create_discount_code, get_my_influencer_stats,
// redeem_coupon y set_outcome. Sumar `resp?.code` al disparador haria que toda alta de
// codigo exitosa tirara una excepcion. El disparador ya cubre estos casos por
// `success === "no"`, que es lo que offer_advisor e ingest_offer_ideas SI setean.
// La clave `code` se lee para el MENSAJE y el err.code, nunca para decidir si fallo.

// ---- NORMALIZE OFFER ----
// s214 · una imagen es una URL o no es nada. `seed_merchant` (export 98, step 8) escribe en `Offer.image`
// el TEXTO «photo» en vez del parámetro — medido en Live el 03/10 con y sin foto: la foto llega a la galería
// del comercio y la oferta queda con "photo". La tarjeta intentaba cargar «photo», fallaba y mostraba
// «Fotos en camino» en vez de caer al logo; la ficha arrancaba con esa imagen rota. Lo que no es una URL
// se trata como vacío: la tarjeta cae al logo y la ficha a la galería. El arreglo de fondo es de Bubble.
const esUrlImagen = (v) => typeof v === "string" && /^(https?:)?\/\//i.test(v.trim());
// ---- s253 · FOTOS POR OFERTA (`gallery_pick`, pase Cowork s253; Bubble en Live) ----------------------------------------
// Cada oferta guarda qué fotos de la galería del negocio muestra. `Offer.gallery_pick` (text), URLs separadas por "\n":
//   línea 1 = la foto de la galería que se usó como principal (Offer.image es su copia encuadrada, con OTRA URL), o "-"
//             si la principal se subió desde el equipo. Va siempre: así el campo nunca queda vacío con una elección parcial.
//   líneas 2+ = las otras fotos de la galería que se muestran, en el orden del dueño.
// Vacío = la galería entera (las ofertas de antes y las de Otto). «Ninguna» = solo "-" (o la principal): solo Offer.image.
// «Todas» no guarda lista: create_offer no manda nada; update_offer manda clear_gallery_pick (Ali, s253), así la oferta
// sigue a la galería si el comercio sube fotos nuevas.
export const urlFoto = (u) => { const s = String(u || "").trim(); return s.startsWith("//") ? "https:" + s : s; };
export function leerGalleryPick(texto) {
  const lineas = String(texto || "").split("\n").map(s => s.trim());
  if (!lineas.some(Boolean)) return null;
  const principal = lineas[0] && lineas[0] !== "-" ? urlFoto(lineas[0]) : "";
  return { principal, extras: lineas.slice(1).filter(Boolean).map(urlFoto) };
}
// Lo que viaja a create_offer / update_offer. `marcadas` = null → el dueño no tocó la selección: no viaja nada.
export function paramsGalleryPick({ marcadas, principal = "", galeria = [], isEdit = false }) {
  if (!Array.isArray(marcadas)) return {};
  const enGaleria = galeria.map(urlFoto);
  const p = urlFoto(principal);
  const extras = marcadas.map(urlFoto).filter(u => u && u !== p && enGaleria.includes(u));
  const todas = enGaleria.length > 0 && enGaleria.every(u => u === p || extras.includes(u));
  if (todas) return isEdit ? { clear_gallery_pick: true } : {};
  return { gallery_pick: [p || "-", ...extras].join("\n") };
}
// Las fotos que dibujan la tarjeta y la ficha: la de la oferta y, detrás, la galería entera o la elegida (solo las que
// sigan en la galería: si el comercio borró una, no se dibuja).
export function fotosDeLaOferta(image, galeria = [], galleryPick = "") {
  const enGaleria = galeria.map(urlFoto).filter(Boolean);
  const pick = leerGalleryPick(galleryPick);
  const detras = pick ? pick.extras.filter(u => enGaleria.includes(u)) : enGaleria;
  return [...new Set([urlFoto(image), ...detras].filter(Boolean))];
}

function normalizeOffer(o, merchant = null) {
  const imgRaw = [o.image, ...(Array.isArray(o.images) ? o.images : [])].find(esUrlImagen) || "";
  const image = imgRaw.startsWith("//") ? "https:" + imgRaw : imgRaw;
  // El zip/city/zone/whatsapp viven en el MerchantPartner (una sola fuente de verdad).
  // El feed los inyecta vía join por o.merchant (id) -> merchant. NO se copian a la oferta.
  const mer = (merchant && typeof merchant === "object") ? merchant : (typeof o.merchant === "object" ? o.merchant : null);
  const merchantName = mer?.business_name || o.merchant_name || "";
  const neighborhood = o.neighborhood || mer?.neighborhood || "";
  const validDaysList = Array.isArray(o.valid_days_list)
    ? o.valid_days_list
    : (typeof o.valid_days === "string" && o.valid_days ? o.valid_days.split(",").map(s => s.trim()).filter(Boolean) : []);
  return {
    ...o,
    image,
    merchant_name: merchantName,
    neighborhood,
    benefit_value_usd: o.benefit_value_usd || o.benefit_value || 0,
    valid_days_list: validDaysList,
    valid_days: o.valid_days || validDaysList.join(", "),
    featured: o.featured === true || o.featured === "yes",
    zip: o.zip || mer?.zip || "",
    city: o.city || mer?.city || "",
    zone: o.zone || mer?.zone || "",
    whatsapp: o.whatsapp || mer?.whatsapp || "",
    merchant_logo: (() => { const l = mer?.logo || ""; return (l && String(l).startsWith("//")) ? "https:" + l : l; })(),
    merchant_id: (mer && mer._id) ? mer._id : (typeof o.merchant === "string" ? o.merchant : ""),
    // s233 · catalogo-carrusel: la galería del comercio ya venía en el registro (getOffers trae los merchantpartner por
    // el mismo canal que la ficha) y se perdía aquí. La tarjeta del catálogo la usa para el carrusel; la ficha la lee de
    // `merchant_public`, como antes.
    merchant_gallery: (Array.isArray(mer?.gallery) ? mer.gallery : [])
      .map(u => { const s = String(u || "").trim(); return s.startsWith("//") ? "https:" + s : s; })
      .filter(esUrlImagen),
  };
}

// ---- FEE CALCULATION (SOLO DISPLAY) ----
// Modelo invertir-cobro-tiers (s142/s143):
// - Miembro/VIP vigente → $0 por cupón (create_payment_intent responde NO_FEE_REQUIRED).
// - LITE: activaciones gratis según config (max_coupons); agotadas, paga
//   min(max(FEE_RATE × benefit_value_usd, FEE_FLOOR), FEE_CAP).
// El fee REAL lo computa el SERVER (PricingConfig 10/499/999 centavos) dentro de
// create_payment_intent; create_coupon_and_cooldown re-verifica el PI y voidea si no
// coincide. Estas constantes son solo display — mantener espejadas a PricingConfig.
// s155-D3: en percent el benefit YA NO es el ahorro típico — el form lo deriva de la cuenta
// típica × el porcentaje, igual que fixed deriva de regular−coupon. Sin benefit →
// max(0, FLOOR) = FLOOR. PENDIENTE s155-D1: hasta que se deploye fee-percent-sin-excepcion,
// el server sigue clavando percent al piso por discount_pct > 0, así que para ese tipo el
// display y el cobro real pueden no coincidir mientras D1 no esté en Live.
export const FEE_RATE = 0.10;   // = PricingConfig.default_fee_percent / 100 (10)
export const FEE_FLOOR = 4.99;  // = PricingConfig.min_fee (499 centavos)
export const FEE_CAP = 9.99;    // = PricingConfig.max_fee (999 centavos)
export function getFee(offer) {
  if (!offer) return 0;
  const benefitValue = offer.benefit_value_usd || offer.benefit_value || 0;
  return Math.min(Math.max(benefitValue * FEE_RATE, FEE_FLOOR), FEE_CAP);
}

// ============================================
// AUTH ENDPOINTS
// ============================================

export async function loginUser(email, password) {
  const data = await apiPost("/wf/login", { email, password });
  const token = data?.response?.token;
  const userId = data?.response?.user_id;
  if (!token) throw new Error("Credenciales incorrectas");
  auth.save(token, userId);

  // BUGFIX 25/04/2026: el workflow `login` en Bubble actualmente NO devuelve `tier`
  // en su Return data. Antes el código usaba `data?.response?.tier || "LITE"` que
  // resultaba en "LITE" para TODOS los users (incluso VIP), causando que VIP nunca
  // pasara por Stripe. Workaround: si el response no trae tier, leerlo del perfil
  // del user vía get_user_profile (que sí lo devuelve correctamente desde la DB).
  // Post-demo: agregar campo tier al Return data del workflow `login` en Bubble.
  let tier = data?.response?.tier;
  if (!tier) {
    try {
      const profile = await getUserProfile();
      tier = profile?.tier;
    } catch (e) {
      // si falla, caemos al fallback de abajo
    }
  }
  if (!tier) tier = "LITE"; // safe fallback final
  // Normalizar VIP/LITE a uppercase para comparación strict-equal en App.jsx.
  // Para "Merchant" preservamos el casing original (signupMerchant lo guarda como "Merchant").
  const tierUpper = String(tier).toUpperCase();
  if (tierUpper === "VIP" || tierUpper === "LITE") tier = tierUpper;

  localStorage.setItem("nxt_tier", tier);
  return { token, userId, tier };
}

export async function signupUser({ email, password, name }) {
  // ETAPA-0 (s97): el signup ya NO lleva código — el código se pide DESPUÉS del
  // login, en la puerta /onboarding (applyAccessCode). `access_code` sigue siendo
  // param REQUIRED del WF signup_api → se manda vacío explícito ("" = rama
  // prospecto; con el edit de Step 21 nace con max_coupons 0).
  // 1. Signup via Bubble API workflow
  const data = await apiPost("/wf/signup_api", {
    email, password, name, access_code: "",
  });
  // s176 FIX 1 (familia): leer error_message/error_code antes de `error`. El contrato de
  // este WF no está documentado del lado del front; la cadena tolerante cubre las tres
  // formas sin romper ninguna.
  if (data?.response?.success === "no" || data?.response?.error_code) {
    const r = data?.response;
    const err = new Error(r?.error_message || r?.error_code || r?.error || "Código de acceso inválido");
    err.code = r?.error_code || "SIGNUP_FAILED";
    // s203 (auditoría A3-08): el step 6 del WF devuelve el correo repetido como TEXTO en
    // voseo («Ese email ya está registrado. Iniciá sesión.»), sin código. Se le pone uno
    // y la pantalla dice su propio mensaje; si Bubble cambia la frase, se cae al texto crudo.
    if (!r?.error_code && /registrad|already registered/i.test(String(r?.error || ""))) err.code = "EMAIL_TAKEN";
    throw err;
  }
  // 2. Immediately login with the same credentials to get a valid Bubble auth token
  //    (signup's token is Current User's unique_id which is NOT accepted by Bubble's
  //    User & admin endpoints. The `login` workflow uses "Log the user in" action which
  //    returns a proper Bubble session token. Same pattern as signupMerchant below.)
  try {
    return await loginUser(email, password);
  } catch (e) {
    throw new Error("Cuenta creada, pero error al iniciar sesión. Intenta login manualmente.");
  }
}

// ---- AUTH-1 (s57): login con Google vía WF backend social_login ----
// React obtiene el ID token de Google (Google Identity Services) y lo manda acá.
// El WF social_login verifica el token (aud + email_verified), find-or-create por email,
// y devuelve el MISMO contrato que login (token = unique id, user_id, tier, role).
// `provider` queda parametrizado para Apple/FB (AUTH-2 fast-follow) por el mismo WF.
export async function socialLogin(idToken, provider = "google") {
  const data = await apiPost("/wf/social_login", { id_token: idToken, provider });
  const resp = data?.response;
  // s176 FIX 1 (familia): idem signupUser — error_message/error_code antes que `error`.
  if (resp?.success === "no" || resp?.error_code) {
    const err = new Error(resp?.error_message || resp?.error_code || resp?.error || "No se pudo iniciar sesión con Google");
    err.code = resp?.error_code || "SOCIAL_LOGIN_FAILED";
    throw err;
  }
  const token = resp?.token;
  const userId = resp?.user_id;
  if (!token) throw new Error("No se recibió token de social_login");
  auth.save(token, userId);

  // Mismo manejo de tier que loginUser: si el Return no trae tier, leerlo del perfil.
  let tier = resp?.tier;
  if (!tier) {
    try {
      const profile = await getUserProfile();
      tier = profile?.tier;
    } catch (e) { /* fallback abajo */ }
  }
  if (!tier) tier = "LITE";
  const tierUpper = String(tier).toUpperCase();
  if (tierUpper === "VIP" || tierUpper === "LITE") tier = tierUpper;
  localStorage.setItem("nxt_tier", tier);
  if (resp?.role) localStorage.setItem("nxt_role", resp.role);
  return { token, userId, tier };
}

// ============================================
// OFFERS
// ============================================

export async function getOffers(category = null) {
  // Join: ofertas + merchants (una sola fuente de verdad del zip/city/zone/whatsapp = el merchant).
  // s233 · paginado: con limit=100 a secas, el comercio 101 en adelante no viajaba y sus ofertas salían sin logo,
  // galería, zona ni WhatsApp (y la oferta 101 en adelante, ni siquiera salía).
  const [ofertas, comercios] = await Promise.all([
    apiGetTodoPublic("/obj/offer"),
    apiGetTodoPublic("/obj/merchantpartner"),
  ]);
  const results = ofertas || [];
  const merchants = comercios || [];
  const merMap = {};
  merchants.forEach((m) => { if (m && m._id) merMap[m._id] = m; });
  return results
    .filter((o) => {
      const statusOk = o.status?.toLowerCase() === "approved";
      const catOk = !category || o.category === category;
      return statusOk && catOk;
    })
    .map((o) => normalizeOffer(o, merMap[o.merchant] || null));
}

// s233 · catalogo-sembradas-admin (Ali: «yo como admin los debería poder ver todos»): Admin y Operator ven en el
// catálogo también las ofertas Pending, con su sesión («Admin sees all»): el canal público solo trae las Approved.
// Cada una lleva `sin_confirmar`: "sembrada" si el comercio sigue en Lead/Invitado y lo sembró un operador (el dueño
// todavía no confirmó) o "pendiente" (alta normal esperando aprobación, que también nace en Lead). Comercios Rejected fuera. Si falla, [].
export async function getOfertasSinConfirmar() {
  const token = auth.getToken();
  if (!token) return [];
  try {
    const cons = encodeURIComponent(JSON.stringify([{ key: "status", constraint_type: "equals", value: "Pending" }]));
    const [ofertas, comercios] = await Promise.all([
      apiGetTodo(`/obj/offer?constraints=${cons}`, token),
      apiGetTodo("/obj/merchantpartner", token),
    ]);
    const merMap = {};
    (comercios || []).forEach((m) => { if (m && m._id) merMap[m._id] = m; });
    return (ofertas || [])
      .filter((o) => o && String(o.status || "").toLowerCase() === "pending")
      .map((o) => ({ o, m: merMap[o.merchant] || null }))
      .filter(({ m }) => String(m?.status || "") !== "Rejected")
      .map(({ o, m }) => ({
        ...normalizeOffer(o, m),
        // s234 · banda-alta-normal: signup_merchant también crea el comercio en Lead, así que el estado solo no alcanza.
        // «Sembrada» = lo creó un operador: tiene seeded_at / beta_token / seeded_by (el alta propia no escribe ninguno).
        sin_confirmar: ["Lead", "Invitado"].includes(String(m?.status || "")) && !!(m?.seeded_at || m?.beta_token || m?.seeded_by)
          ? "sembrada" : "pendiente",
      }));
  } catch (e) {
    return [];
  }
}

// s233 · la ficha de una oferta Pending (sembrada sin confirmar) para Admin/Operator: el canal público no la devuelve.
export async function getOfferByIdConSesion(id) {
  const token = auth.getToken();
  if (!token || !id) return null;
  const data = await apiGet(`/obj/offer/${id}`, token);
  const o = data?.response;
  if (!o) return null;
  let merchant = null;
  if (o.merchant && typeof o.merchant === "string") {
    try {
      const md = await apiGet(`/obj/merchantpartner/${o.merchant}`, token);
      merchant = md?.response || null;
    } catch (e) { /* sin merchant: normalizeOffer usa fallbacks */ }
  }
  return { ...normalizeOffer(o, merchant), merchant_public: merchant || null };
}

export async function getOfferById(id) {
  const data = await apiGetPublic(`/obj/offer/${id}`);
  if (!data?.response) return null;
  const o = data.response;
  let merchant = typeof o.merchant === "object" ? o.merchant : null;
  if (!merchant && o.merchant) {
    try {
      const md = await apiGetPublic(`/obj/merchantpartner/${o.merchant}`);
      merchant = md?.response || null;
    } catch (e) { /* sin merchant: normalizeOffer usa fallbacks */ }
  }
  // s181 ficha v2: el registro PÚBLICO del comercio viaja adjunto. Antes solo se usaba
  // para derivar zip/city/zone/logo y se tiraba; la ficha leía `offer.merchant?.website`
  // de un string (el id) y el bloque del comercio nunca se dibujó. `merchant` sigue
  // siendo el id: nadie que lo lea como id se entera.
  return { ...normalizeOffer(o, merchant), merchant_public: merchant || null };
}

// s148 P1 (punto 1): lectura AUTENTICADA de una oferta propia, para hidratar el edit del
// merchant. El canal público (getOfferById) nunca expone typical_savings y no devuelve nada
// de ofertas Pending; la privacy rule "Merchant sees own offers" sí entrega los ~49 campos,
// incluidos typical_savings, unit_price e image — los tres que el edit necesita para no
// corromper la oferta al guardar (update_offer reescribe todo y el submit recomputa
// benefit_value_usd desde esos campos).
// Validación de canal: la Data API incluye las claves PERMITIDAS aunque estén vacías (null)
// y omite las bloqueadas por privacy (verificado en prod s148). Si falta alguna de las tres
// claves, la lectura cayó a un canal capado (sin token, token de otro user, o privacy
// cambiada) → devolvemos null para que el edit falle CERRADO (editHydrated queda false y el
// save sigue bloqueado) en vez de hidratar a medias.
export async function getMyOfferById(id) {
  if (!id || typeof id !== "string") return null;
  const data = await apiGet(`/obj/offer/${id}`, auth.getToken());
  const o = data?.response;
  if (!o) return null;
  const complete = ("typical_savings" in o) && ("unit_price" in o) && ("image" in o);
  if (!complete) {
    console.warn("[getMyOfferById] canal capado — faltan campos de la regla merchant:", Object.keys(o));
    return null;
  }
  return normalizeOffer(o);
}

// ============================================
// MERCHANTS
// ============================================

export async function getMerchantById(id) {
  if (!id || typeof id !== "string") return null;
  const data = await apiGetPublic(`/obj/merchantpartner/${id}`);
  return data?.response || null;
}

// F1 s101: ofertas aprobadas de un merchant, para la página pública /m/:id.
// Lectura anónima (canal público). Filtra por merchant + status Approved.
// s161 F-2: se retira el filtro cliente is_active. Era un fantasma: is_active NACE en
// `yes` por default del tipo Offer, ningún workflow lo escribe deliberadamente, y el
// pausado real usa status = "Paused" (App.jsx:4904). Como gate de visibilidad no
// protegía de nada y hacía que el feed (getOffers, solo status) y este storefront
// contestaran distinto a la misma pregunta. status queda como ÚNICA autoridad.
// El constraint server-side de abajo es sensible a mayúsculas: "Approved" con A.
export async function getMerchantOffers(merchantId) {
  if (!merchantId || typeof merchantId !== "string") return [];
  const constraints = JSON.stringify([
    { key: "merchant", constraint_type: "equals", value: merchantId },
    { key: "status", constraint_type: "equals", value: "Approved" },
  ]);
  const data = await apiGetPublic(`/obj/offer?constraints=${encodeURIComponent(constraints)}&limit=100`);
  return (data?.response?.results || []).map(o => normalizeOffer(o));
}

// F1 s119 (storefront): directorio consumer de negocios — lista publica de merchants
// Approved por el canal anonimo (misma privacy curada que /m/:id, s101). El constraint
// de status es cinturon: la regla "Public sees approved" ya filtra server-side.
export async function getPublicMerchants() {
  const constraints = JSON.stringify([
    { key: "status", constraint_type: "equals", value: "Approved" },
  ]);
  const data = await apiGetPublic(`/obj/merchantpartner?constraints=${encodeURIComponent(constraints)}&limit=100`);
  return data?.response?.results || [];
}

// ============================================
// STRIPE PAYMENT
// ============================================

// s143 (invertir-cobro-tiers): el server decide quién paga — ya NO se manda `amount`
// (create_payment_intent lo ignoraba desde s142; el monto se computa server-side).
// Respuestas posibles:
//   - NO_FEE_REQUIRED (miembro vigente o LITE con gratis disponibles): el WF lo devuelve
//     coalescido en el Return — puede venir como error_code con success:"no" o como clave
//     propia; se detectan ambas formas. NO es un error del usuario: se normaliza a
//     { no_fee_required: true } y el caller activa gratis sin payment_intent_id.
//   - client_secret (LITE con gratis agotadas): el caller abre el modal Stripe.
//   - error_code real (MEMBERSHIP_EXPIRED, etc.): Error con .code → activationErrorMessage.
export async function createPaymentIntent({ offer_id, offer_title, user_email }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const res = await fetch(`${API_BASE}/wf/create_payment_intent`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify({
      offer_id,
      description: offer_title ? `NXT Reserve - ${offer_title} - ${user_email || 'member'}` : "NXT Reserve Coupon Activation",
    }),
  });
  const data = await res.json().catch(() => ({}));
  console.log("BUBBLE RESPONSE create_payment_intent:", JSON.stringify(data));
  if (!res.ok) {
    throw new Error(data?.body?.message || data?.response?.error_message || `Error ${res.status}`);
  }
  const resp = data?.response || {};
  const noFee =
    resp.no_fee_required === true || resp.no_fee_required === "yes" ||
    Object.values(resp).some((v) => v === "NO_FEE_REQUIRED");
  if (noFee) return { ...resp, no_fee_required: true };
  if (resp.client_secret) return resp;
  // Ni NO_FEE_REQUIRED ni client_secret → fallo real (guard u otro).
  // s227 · CLUB_CERRADO (export 139): la venta está cerrada hasta la inauguración.
  const err = new Error(resp.error_code === "CLUB_CERRADO" ? "El club abre pronto: todavía no estamos vendiendo."
    : (resp.error_message || resp.error || "No client_secret from Stripe"));
  err.code = resp.error_code || "PAYMENT_INTENT_FAILED";
  throw err;
}

// ============================================
// MEMBERSHIP PURCHASE (FIX-9a — prepaid, in-app)
// ============================================

// Crea el PaymentIntent de la membresía. El monto lo computa el WF SERVER-SIDE
// (precio del plan − descuento del código); React NO manda amount (lección 8.4).
// `discount_code` es opcional (omitido del JSON si viene vacío → el WF lo trata como sin código).
// WF `create_membership_payment_intent`. Devuelve { client_secret, ... }.
export async function createMembershipPaymentIntent({ plan_id, discount_code }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const body = { plan_id };
  const dc = (discount_code || "").trim();
  if (dc) body.discount_code = dc;   // omitido si vacío (Bubble: sin código → precio del plan)
  const res = await fetch(`${API_BASE}/wf/create_membership_payment_intent`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.body?.message || data?.response?.error_message || "Error al crear el pago de membresía");
  if (data?.response?.success === "no" || data?.response?.error_code) {
    const err = new Error(data?.response?.error_code === "CLUB_CERRADO" ? "El club abre pronto: todavía no vendemos membresías."
      : (data?.response?.error_message || data?.response?.error || "No se pudo iniciar la compra"));
    err.code = data?.response?.error_code || null;
    throw err;
  }
  if (!data?.response?.client_secret) throw new Error("No client_secret from Stripe");
  return data.response;
}

// Confirma la compra tras el pago (otorga VIP + marca el código usado server-side, Step 10).
// `discount_code` se RE-pasa para que el WF lo marque is_used=yes (single-use). WF `confirm_membership_purchase`.
// s186 · `nxt_tier` QUEDABA VIEJO DESPUÉS DE COMPRAR. Ningún `confirm_*` lo reescribía:
// la persona pagaba su membresía, el servidor la pasaba a VIP, y el navegador seguía
// diciendo LITE **hasta el próximo login**. En la mayoría de las pantallas se notaba poco
// porque el servidor manda igual; se nota donde el front decide con ese valor — y en el
// camino del enganche, donde la persona sigue navegando en el mismo segundo.
//
// Va acá y no en cada pantalla a propósito: son cuatro llamadores (planes VIP, el
// enganche, la página de join, el modal de wallet) y ponerlo en cada uno garantiza que
// alguno quede sin hacerlo. El valor NO se adivina desde el cliente: se vuelve a
// preguntar al servidor, que es el único que sabe qué otorgó el WF.
//
// NUNCA rompe la compra: el dinero ya se movió y el `confirm` ya respondió que sí. Si
// esta lectura falla, el tier se corrige solo en el próximo login.
async function sincronizarTier() {
  try {
    const prof = await getUserProfile();
    const t = String(prof?.tier || "").toUpperCase();
    if (t === "VIP" || t === "LITE") localStorage.setItem("nxt_tier", t);
  } catch (e) { /* el tier viejo se corrige en el próximo login */ }
}

export async function confirmMembershipPurchase({ payment_intent, plan_id, discount_code }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  // Hedge de nombre (recon s61): el guard del Step 1 chequea `payment_intent_id`, pero el flujo
  // listó el param como `payment_intent`. Mandamos AMBAS con el mismo valor; el WF usa la que
  // tenga definida y la otra es inocua (igual que el flujo de cupones manda keys ignoradas).
  const body = { payment_intent, payment_intent_id: payment_intent, plan_id };
  const dc = (discount_code || "").trim();
  if (dc) body.discount_code = dc;   // necesario para que el Step 10 marque is_used=yes
  const res = await fetch(`${API_BASE}/wf/confirm_membership_purchase`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.body?.message || data?.response?.error_message || "Error al confirmar la membresía");
  if (data?.response?.success === "no" || data?.response?.error_code) {
    const err = new Error(data?.response?.error_message || data?.response?.error || "No se pudo confirmar la membresía");
    err.code = data?.response?.error_code || null;
    throw err;
  }
  await sincronizarTier();   // s186 · ver la nota de sincronizarTier
  return data?.response;
}

// Igual que confirmMembershipPurchase pero para descuentos de PRECIO FIJO (discount_mode = fixed_price).
// WF aparte `confirm_fixed_price_purchase` (clone + anti-tamper fixed_price x100). El front rutea por discount_mode.
export async function confirmFixedPricePurchase({ payment_intent, plan_id, discount_code }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const body = { payment_intent, payment_intent_id: payment_intent, plan_id };
  const dc = (discount_code || "").trim();
  if (dc) body.discount_code = dc;
  const res = await fetch(`${API_BASE}/wf/confirm_fixed_price_purchase`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.body?.message || data?.response?.error_message || "Error al confirmar la membresía");
  if (data?.response?.success === "no" || data?.response?.error_code) {
    const err = new Error(data?.response?.error_message || data?.response?.error || "No se pudo confirmar la membresía");
    err.code = data?.response?.error_code || null;
    throw err;
  }
  await sincronizarTier();   // s186 · ver la nota de sincronizarTier
  return data?.response;
}

// ============================================
// COUPONS
// ============================================

export async function activateCoupon({ offer_id, payment_intent_id }) {
  const userToken = auth.getToken();
  const userId = auth.getUserId();
  if (!userToken) throw new Error("No token");
  if (!userId) throw new Error("No user_id en localStorage");

  // Backend `create_coupon_and_cooldown`: deriva fee server-side e ignora `user` (inocuo).
  // s143: `fee` ya no se manda (el server lo ignoraba desde que deriva activation_fee).
  // `payment_intent_id` se manda cuando hubo cobro: A1 hace Retrieve PaymentIntent y verifica
  // status+monto (Void si falla). Activación gratis (NO_FEE_REQUIRED) → payment_intent_id
  // undefined → se omite del JSON; si el server esperaba cobro responde el guard PAYMENT_REQUIRED.
  const code = "NXT-" + Math.floor(100000 + Math.random() * 900000);

  const res = await fetch(`${API_BASE}/wf/create_coupon_and_cooldown`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify({
      user: userId,          // ya no se usa server-side (IDOR 8.25 → Current User); inocuo, no lo borres aún
      offer: offer_id,
      code,
      payment_intent_id,   // X.19 s28: key alineada al WF (antes mandaba `payment_intent` → MISSING_DATA). A1 lo verifica contra Stripe (Void si status≠succeeded o monto mismatch). Gratis → undefined → se omite del JSON.
    }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data?.body?.message || "Error al activar cupón");
  // s31: los guards de create_coupon rechazan con HTTP 200 + { success:"no", error_code, error_message }.
  // Sin este chequeo, un rechazo (cap VIP / replay PI / cooldown / pago) se mostraba como ÉXITO
  // y navegaba a Mis Cupones sin cupón. Tiramos error con .code para que la UI muestre el mensaje correcto.
  if (data?.response?.success === "no" || data?.response?.error_code) {
    const err = new Error(data?.response?.error_message || data?.response?.error || "No se pudo activar el cupón");
    err.code = data?.response?.error_code || null;
    throw err;
  }
  // Tras EXT-B1-STEP6, response trae { success, coupon_id, coupon_code, expires_at }
  return data?.response;
}

export async function getMyCoupons() {
  const userToken = auth.getToken();
  if (!userToken) return [];
  const data = await apiGet("/obj/couponinstance?limit=100", userToken);
  // s215 · «Mis cupones» son los MÍOS. Un miembro solo ve los suyos (privacy), pero el admin ve los de
  // todos (medido: 42 cupones de 13 usuarios en su pantalla). Se filtra por end_user = yo.
  const yo = auth.getUserId();
  const coupons = (data?.response?.results || []).filter(c => !yo || c.end_user === yo);

  // Enrich coupons with offer title and merchant name
  const offerIds = [...new Set(coupons.map(c => c.offer).filter(Boolean))];
  const offerMap = {};
  if (offerIds.length > 0) {
    try {
      // Fetch offers in batches (Bubble limit)
      const constraints = JSON.stringify([{ key: "_id", constraint_type: "in", value: offerIds }]);
      const offersData = await apiGet(`/obj/offer?constraints=${encodeURIComponent(constraints)}&limit=100`, userToken);
      (offersData?.response?.results || []).forEach(o => {
        offerMap[o._id] = { title: o.title_es || o.title_en || "", title_en: o.title_en || "", merchant_name: o.merchant_name || "" };
      });
    } catch (e) { /* silently fail — coupons still work without titles */ }
  }

  // F1 s101: enriquecer con datos del negocio para mostrar dirección/mapa/teléfono EN EL CUPÓN.
  // Campos públicos de MerchantPartner ("Public sees approved"): address/google_maps_url/phone_public.
  const merchantIds = [...new Set(coupons.map(c => c.merchant).filter(Boolean))];
  const merchantMap = {};
  if (merchantIds.length > 0) {
    try {
      const mc = JSON.stringify([{ key: "_id", constraint_type: "in", value: merchantIds }]);
      const merData = await apiGet(`/obj/merchantpartner?constraints=${encodeURIComponent(mc)}&limit=100`, userToken);
      (merData?.response?.results || []).forEach(m => { if (m && m._id) merchantMap[m._id] = m; });
    } catch (e) { /* sin datos de negocio: el cupón igual funciona con el código */ }
  }

  return coupons.map(c => completarCupon(c, offerMap[c.offer], merchantMap[c.merchant]));
}

// s247 · `mis-cupones-sin-titulo-ni-comercio` (pase s247 §7.4 bis y §8.3). En Live el socio no lee `offer` ni `merchantpartner`
// por la Data API (las reglas públicas siguen cerradas para quien no es operador), así que el cupón trae desde su creación lo que
// la tarjeta necesita (`create_coupon_and_cooldown`, 7 campos de texto). Lo del cupón manda; si viene vacío (cupones de antes),
// lo de la oferta y el comercio, como hasta ahora. Nada se pisa con "".
export function completarCupon(c, oferta, comercio) {
  const o = oferta || {};
  const m = comercio || null;
  return {
    ...c,
    offer_title: c.offer_title || o.title || "",
    offer_title_en: c.offer_title_en || o.title_en || "",
    merchant_name: c.merchant_name || o.merchant_name || (m?.business_name || ""),
    merchant_address: c.merchant_address || m?.address_full || m?.address || m?.address_text || "",
    merchant_maps_url: c.merchant_maps_url || m?.google_maps_url || "",
    merchant_phone: c.merchant_phone || m?.phone_public || "",
    merchant_neighborhood: c.merchant_neighborhood || m?.neighborhood || "",
  };
}
// ---- s202 · GUARDAR («Mi lista») — ticket favoritos-miembro (s156, F1-F3) ----
// El backend existe desde antes y ningun boton lo llamaba: tipo SavedItem con privacy
// rules (solo el dueño y el admin), `set_saved_item(action, item_type, item_id)` con
// action = save | remove e item_type = offer | merchant, y `get_saved_items`, que corre
// con «ignora privacy» pero filtra por `user = Current User` (registro, l.28-29).
// set_saved_item responde success como TEXTO («yes» / «no» + code).
export async function guardarItem({ tipo, id, guardar }) {
  const userToken = auth.getToken();
  if (!userToken) { const e = new Error("NO_SESSION"); e.code = "NO_SESSION"; throw e; }
  const data = await apiPost("/wf/set_saved_item",
    { action: guardar ? "save" : "remove", item_type: tipo, item_id: String(id) }, userToken);
  const r = data?.response || data || {};
  if (String(r.success) !== "yes") {
    const e = new Error(r.code || "SAVE_FAILED"); e.code = r.code || "SAVE_FAILED"; throw e;
  }
  return true;
}

// s252-D1 · la política de contraseñas de Bubble (Settings > General): mínimo 8, sin reglas de composición. El front corta
// antes de llamar. Si igual llega a Bubble: HTTP 400, reason PASSWORD_INVALID, «This password is not valid» (medido en
// version-test el 02/11, claude/RESULTADO_s252_clave_corta.txt; apiPost solo pasa el mensaje).
export const MIN_CLAVE = 8;
export const esClaveRechazada = (mensaje) => /password|contrase/i.test(String(mensaje || ""))
  && /not valid|too short|too weak|policy|at least|characters|no es v[aá]lida|caracteres/i.test(String(mensaje || ""))
  || /PASSWORD_INVALID/.test(String(mensaje || ""));

// ---- s202 · CAMBIAR LA CONTRASEÑA CON SESION (`cambiar-clave-en-la-app`) ----
// `change_password(current_password, new_password)` existia sin ningun boton: Step 0 corta
// con WEAK_PASSWORD si la nueva tiene menos de 6 (el WF todavía dice 6; el front ya pide MIN_CLAVE); Step 2 es «Update
// credentials» con la actual, y si la actual NO es la correcta Bubble corta el workflow con error (HTTP 400):
// apiPost lanza con su mensaje. Ninguna de las dos contraseñas se guarda ni se registra.
export async function cambiarClave(actual, nueva) {
  const userToken = auth.getToken();
  if (!userToken) { const e = new Error("NO_SESSION"); e.code = "NO_SESSION"; throw e; }
  let data;
  try {
    data = await apiPost("/wf/change_password", { current_password: actual, new_password: nueva }, userToken);
  } catch (e) {
    const m = String(e?.message || "");
    // s252-D1 · la clave nueva rechazada por la política se miraba como «la actual no es correcta».
    const code = /authenticat/i.test(m) ? "NO_SESSION"
      : esClaveRechazada(m) ? "WEAK_PASSWORD"
      : /password|contrase|credential|incorrect|wrong/i.test(m) ? "WRONG_PASSWORD" : "CHANGE_FAILED";
    const err = new Error(code); err.code = code; throw err;
  }
  const r = data?.response || {};
  if (r.success === false || r.success === "no" || r.error_code) {
    const code = r.error_code || "CHANGE_FAILED";
    const err = new Error(code); err.code = code; throw err;
  }
  return true;
}

// get_saved_items devuelve cada lista como UN texto: "[" + ids unidos por Bubble + "]".
// Se parte por comas; un id de Bubble no lleva comas ni espacios.
// s203 · En Live los ids vienen ENTRE COMILLAS (`["1783…","1781…"]`, medido con sesión real
// el 23/09); la maqueta de s202 los daba sin comillas. Se quitan las comillas de cada id:
// sin eso ninguno cruzaba con el catálogo y «Mi lista» decía «no disponible» a todo.
export async function misGuardados() {
  const userToken = auth.getToken();
  if (!userToken) return { ofertas: [], comercios: [] };
  const data = await apiPost("/wf/get_saved_items", {}, userToken);
  const r = data?.response || data || {};
  const lista = (t) => (Array.isArray(t) ? t : String(t || "").replace(/^\s*\[|\]\s*$/g, "").split(","))
    .map(s => String(s).trim().replace(/^["']+|["']+$/g, "").trim()).filter(Boolean);
  return { ofertas: lista(r.saved_offer_ids), comercios: lista(r.saved_merchant_ids) };
}

// `idempotency_key`: identificador ALEATORIO POR INTENTO DE CANJE, generado por el componente
// del formulario (MerchantDashboard) y estable mientras dure ese intento. NO se genera acá:
// api.js no tiene forma de saber si esta llamada es un reintento del mismo click o un canje nuevo.
// s217 · export 114 (T02/T03): `bill_usd` opcional = el monto real de la cuenta (decisión de Ali, para el
// panel «lo que te trajo NXT»). Solo viaja si es > 0: sin él, el canje es idéntico al de siempre.
export async function redeemCoupon(coupon_code, idempotency_key, bill_usd) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  // El WF redeem_coupon exige AMBOS params presentes (coupon_code + coupon_id);
  // el merchant solo conoce el código → mandamos coupon_id vacío, el WF resuelve por coupon_code.
  //
  // s175 FIX 3 — idempotency_key (param 3 del WF, Optional, export 66):
  // los steps 0-1 del WF buscan un CouponInstance con redeem_idempotency_key_text = la clave;
  // si lo encuentran devuelven ese canje y terminan. Como el front nunca mandaba el param, esos
  // steps no disparaban NUNCA y lo único que corría era el step 2.
  //
  // 🔴 La clave es ALEATORIA POR INTENTO. **NO puede derivarse del coupon_code** — se probó y
  // el mecanismo de Bubble no lo soporta, por dos razones verificadas en el export 66:
  //
  //   1. El Search del step 0 es GLOBAL: `Search(couponinstance where
  //      redeem_idempotency_key_text = <param>)`, sin filtro por merchant ni por fecha.
  //   2. El code_text del cupón lo genera REACT, no Bubble: create_coupon_and_cooldown step 14
  //      hace `code_text ← param:code` y su Only-when solo chequea que `param:code` no esté
  //      vacío — NO hay guard de unicidad. Son 6 dígitos de `Math.random()` (ver activateCoupon
  //      más abajo), o sea colisiones perfectamente alcanzables.
  //
  //   Juntas: si dos cupones de comercios distintos comparten código, una clave derivada del
  //   código haría que el 2º canje encuentre la clave del 1º, devuelva success:true con EL CUPÓN
  //   AJENO y no canjee nada. El comercio ve el check verde y su cupón sigue Active. Peor que no
  //   tener idempotencia.
  //
  // Que un cupón se canjee UNA SOLA VEZ ya lo garantiza el constraint `status = Active` dentro
  // del Search del step 2 — ese no es trabajo de la idempotency_key. Lo único que esta clave
  // protege es el doble-click / el reintento de red DEL MISMO INTENTO: las dos llamadas mandan
  // la misma clave, la 2ª cae en el step 0 y devuelve lo que hizo la 1ª en vez de re-ejecutar.
  //
  // Si viene vacía (llamador que no la pasa), el Only-when del step 0 exige `is_not_empty` → la
  // idempotencia queda apagada y el WF se comporta como antes de s175. Degradación segura.
  const res = await fetch(`${API_BASE}/wf/redeem_coupon`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify({ coupon_code, coupon_id: "", idempotency_key: idempotency_key || "",
      ...(numero(bill_usd) > 0 ? { bill_usd: numero(bill_usd) } : {}) }),
  });
  const data = await res.json();
  // Error HTTP (ej. MISSING_DATA si faltara un param)
  if (!res.ok) {
    const err = new Error(data?.body?.message || "Redeem failed");
    err.code = data?.body?.status || data?.status || "REDEEM_FAILED";
    throw err;
  }
  // OJO: el WF devuelve HTTP 200 incluso en fallo lógico → hay que chequear success
  const resp = data?.response;
  if (!resp || resp.success !== true) {
    const err = new Error(resp?.error_message || "Redeem failed");
    err.code = resp?.error_code || "REDEEM_FAILED";
    throw err;
  }
  return resp;
}

// ---- MERCHANT: gestionar ofertas (X.43) ----
// WF set_offer_status: el merchant pausa/reanuda/archiva SU oferta.
// op ∈ "pause" (Approved→Paused) | "resume" (Paused→Approved) | "delete" (→Archived).
// Guards en el WF (Bubble): dueño (Offer's merchant = Current User's merchant_profile) +
// transiciones (pause solo desde Approved, resume solo desde Paused) → un merchant NUNCA
// puede llevar una oferta Pending a Approved (sin self-approve). Patrón L#83: el WF devuelve
// HTTP 200 con success:false + error_code en fallo lógico → chequear success, no el status.
export async function setOfferStatus(offer_id, op) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const res = await fetch(`${API_BASE}/wf/set_offer_status`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify({ offer_id, op }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.body?.message || "Offer update failed");
    err.code = data?.body?.status || data?.status || "OFFER_UPDATE_FAILED";
    throw err;
  }
  const resp = data?.response;
  if (!resp || resp.success !== true) {
    const err = new Error(resp?.error_message || "Offer update failed");
    err.code = resp?.error_code || "OFFER_UPDATE_FAILED";
    throw err;
  }
  return resp;
}

// ---- MERCHANT: editar contenido de oferta (X.43-bis) ----
// WF update_offer: el merchant edita SU oferta (precio/título/descripción/fotos/highlights).
// Espejo de create_offer + offer_id. NO toca status (editar NO re-aprueba — SOR §2): una
// oferta Approved sigue Approved. Guard de dueño en el WF (Offer's merchant = Current User's
// merchant_profile) → NOT_OWNER, igual que set_offer_status. Patrón L#83: HTTP 200 con
// success:false + error_code en fallo lógico → chequear success, no el status.
// payload = mismo objeto que arma el wizard para create_offer (la imagen va solo si se sube una nueva).
export async function updateOffer(offer_id, payload) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const res = await fetch(`${API_BASE}/wf/update_offer`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${userToken}` },
    body: JSON.stringify({ offer_id, ...payload }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.body?.message || "Offer update failed");
    err.code = data?.body?.status || data?.status || "OFFER_UPDATE_FAILED";
    throw err;
  }
  const resp = data?.response;
  if (!resp || resp.success !== true) {
    const err = new Error(resp?.error_message || "Offer update failed");
    err.code = resp?.error_code || "OFFER_UPDATE_FAILED";
    throw err;
  }
  return resp;
}

// ---- MERCHANT: asistente IA de ofertas (B5.1, s55) ----
// WF read-only suggest_offer_improvements: recibe un borrador y devuelve 5 campos de mejora.
// NO crea ni edita la oferta (solo sugiere). Guard NOT_MERCHANT en el WF.
// Devuelve { success, improved_title, improved_description, suggested_highlights, whats_missing, tips }.
export async function suggestOfferImprovements({ title, description, lang = "es" }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const data = await apiPost(
    "/wf/suggest_offer_improvements",
    { title, description, lang },
    userToken
  );
  const resp = data?.response;
  // s176 FIX 1: el WF devuelve `error_code` (NOT_MERCHANT, GENERATION_LIMIT, ...), NUNCA
  // `error`. Leer resp.error caia SIEMPRE al texto generico y hacia indistinguibles todos
  // los fallos del asesor — tres sesiones diagnosticando a ciegas por este renglon.
  // Mismo contrato que redeemCoupon: mensaje del WF si viene, y el codigo en err.code.
  if (!resp || resp.success === "no" || resp.error_code) {
    const err = new Error(
      resp?.error_message || resp?.error_code || resp?.error || "No se pudieron generar sugerencias"
    );
    err.code = resp?.error_code || "ADVISOR_FAILED";
    throw err;
  }
  return resp;
}

// ============================================
// B5.1 — ASISTENTE IA ESTRATÉGICO DE OFERTAS (carril rápido del wizard)
// ============================================
// offer_advisor (WF read-only) sugiere 3-4 ofertas a partir de:
//   - el rubro del merchant (business_type) → margen rubro-específico (B5.1-D15)
//   - el contexto del wizard (3-4 respuestas) o el texto ingerido de la URL/menú
// El WF NO crea la oferta: devuelve advisor_json (string JSON de Sonnet) + disclaimer.
// El front parsea, muestra tarjetas, y "Usar esta oferta" pre-llena create_offer.

// Sonnet puede devolver el JSON envuelto en ```json ... ``` o con texto alrededor;
// esto extrae el primer bloque {...} o [...] parseable.
function extractJson(raw) {
  if (raw == null) return null;
  if (typeof raw === "object") return raw;
  let s = String(raw).trim();
  // quitar fences markdown ```json ... ```
  const fence = s.match(/```(?:json)?\s*([\s\S]*?)```/i);
  if (fence) s = fence[1].trim();
  try { return JSON.parse(s); } catch (_) {}
  // fallback: primer array u objeto balanceado del texto
  const start = s.search(/[[{]/);
  if (start >= 0) {
    const open = s[start];
    const close = open === "[" ? "]" : "}";
    const end = s.lastIndexOf(close);
    if (end > start) {
      try { return JSON.parse(s.slice(start, end + 1)); } catch (_) {}
    }
  }
  return null;
}

const NUM = (v) => {
  if (v === 0 || v) { const n = parseFloat(String(v).replace(/[^0-9.\-]/g, "")); return Number.isFinite(n) ? n : 0; }
  return 0;
};

// Normaliza una "oferta" propuesta por la IA (campos flexibles) al shape del form
// de MerchantCreateOffer. Tolera nombres en es/en y estructuras anidadas.
// s148 P2 (caso Taikin): el mapeo viejo caía a "percent" por la sola presencia de
// discount_pct (un 2x1 con discount_pct:50 quedaba percent + typical_savings 0 →
// benefit_value_usd 0 → cuota al piso), y solo aceptaba highlights como array.
// ---- s179 L7 · DISPONIBILIDAD DEL ASESOR --------------------------------------
// El shape devolvía 15 campos y NINGUNO de disponibilidad. Consecuencia verificada el
// 25/08: el asesor escribió en la descripción «solo mar-mié antes del mediodía» y la
// oferta llegó al form con DÍAS sin tildar y horarios vacíos. Si el comercio guarda —y
// guarda, porque todo lo demás vino lleno— publica una oferta que DICE mar-mié y está
// disponible los siete días. El miembro llega un sábado y el comercio no puede negarse.
//
// ⚠️ Se normaliza a FEED_DAY_TOKENS ("Lun","Mar","Mie","Jue","Vie","Sab","Dom"), que es
// el vocabulario que usa `form.valid_days` y con el que comparan los checkboxes del
// wizard. NO a las keys mon…sun de MERCHANT_DAYS: ese es el vocabulario de los horarios
// del PERFIL, otra cosa. Normalizar a mon…sun daría días que no tildan nada — el mismo
// fallo mudo que este lote viene a cerrar.
const DIAS_ORDEN = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"];
const DIAS_ALIAS = {
  lun: "Lun", lunes: "Lun", mon: "Lun", monday: "Lun",
  mar: "Mar", martes: "Mar", tue: "Mar", tues: "Mar", tuesday: "Mar",
  mie: "Mie", miercoles: "Mie", wed: "Mie", weds: "Mie", wednesday: "Mie",
  jue: "Jue", jueves: "Jue", thu: "Jue", thur: "Jue", thurs: "Jue", thursday: "Jue",
  vie: "Vie", viernes: "Vie", fri: "Vie", friday: "Vie",
  sab: "Sab", sabado: "Sab", sat: "Sab", saturday: "Sab",
  dom: "Dom", domingo: "Dom", sun: "Dom", sunday: "Dom",
};

// minúsculas + sin tildes + sin puntos, para que "Mié." y "miercoles" caigan en la misma llave.
const sinTilde = (s) => String(s).toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\./g, "").trim();

function diaToken(x) {
  const k = sinTilde(x);
  if (DIAS_ALIAS[k]) return DIAS_ALIAS[k];
  const k3 = k.slice(0, 3);
  return DIAS_ALIAS[k3] || null;
}

/**
 * Acepta array o string, con comas, "y"/"and", o rangos con guion ("mar-mie").
 * Devuelve el string que espera form.valid_days, o "" si no se reconoció nada.
 * Ante la duda NO inventa: un día de más publica una promesa que el comercio no quiere.
 */
export function normalizarDiasAsesor(entrada) {
  if (entrada == null) return "";
  let crudo = Array.isArray(entrada) ? entrada.join(",") : String(entrada);
  if (!crudo.trim()) return "";
  // s179 L9: se quitan las horas ANTES de buscar días. Un valor mixto como
  // "mar-mié 12-3pm" traía DOS guiones y el partidor de rangos veía tres pedazos
  // ("mar", "mié 12", "3pm"), no dos, así que descartaba el rango y devolvía solo "Mar".
  // Los nombres de día no tienen dígitos, así que borrarlos no puede perder información.
  crudo = crudo.replace(/\d{1,2}(?::\d{2})?\s*(?:am|pm)?/gi, " ");
  const encontrados = new Set();
  for (const parte of crudo.split(/[,;/|]| y | and |\+/i)) {
    const p = parte.trim();
    if (!p) continue;
    // ⚠️ La "a" de "lunes a viernes" tiene que ir como PALABRA suelta (\s+a\s+), nunca
    // dentro de la clase de caracteres: `[-–—a]` partía "mar-mié" por la a de "mar" y
    // devolvía solo "Mar". Justo el caso del incidente del 25/08.
    const rango = p.split(/\s*[-–—]\s*|\s+a\s+/).map((x) => x.trim()).filter(Boolean);
    if (rango.length === 2) {
      const a = diaToken(rango[0]), b = diaToken(rango[1]);
      if (a && b) {
        let i = DIAS_ORDEN.indexOf(a);
        const fin = DIAS_ORDEN.indexOf(b);
        // se recorre la semana hacia adelante; cubre rangos que cruzan el domingo
        for (let n = 0; n < 7; n++) {
          encontrados.add(DIAS_ORDEN[i]);
          if (i === fin) break;
          i = (i + 1) % 7;
        }
        continue;
      }
    }
    const t = diaToken(p);
    if (t) encontrados.add(t);
  }
  return DIAS_ORDEN.filter((d) => encontrados.has(d)).join(",");
}

/** "9", "9:30", "9am", "9:30 PM", "21:30" → "HH:MM" 24h, que es lo que pide <input type="time">. */
export function normalizarHoraAsesor(v) {
  if (v == null) return "";
  const m = String(v).trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?$/i);
  if (!m) return "";
  let h = parseInt(m[1], 10);
  const min = m[2] || "00";
  const ap = (m[3] || "").toLowerCase();
  if (ap.startsWith("p") && h < 12) h += 12;
  if (ap.startsWith("a") && h === 12) h = 0;
  if (h > 23 || parseInt(min, 10) > 59) return "";
  return `${String(h).padStart(2, "0")}:${min}`;
}

// ---- s179 L9 · ENCONTRAR LA DISPONIBILIDAD VENGA COMO VENGA ---------------------
// El L7 mapeó una lista fija de nombres y en runtime no alcanzó: el 25/08 una tarjeta
// mostraba "🕑 mar-mié 12-3pm" y los días llegaron sin tildar. La tarjeta lo pintaba por
// `_adv.when`, o sea que el modelo manda la disponibilidad en `when` — una clave que NO
// contiene "dia" ni "day" ni "availab", así que ningún barrido por nombre la encuentra.
// Por eso el orden es: nombres conocidos → `when`/`cuando` → barrido genérico.

const CLAVE_DISPONIBILIDAD = /(dia|day|horario|schedule|window|franja|disponib|availab|hora|time)/;

/** Extrae un rango horario de texto libre: "12-3pm", "9am-5pm", "18:00 a 22:00". */
export function extraerRangoHorario(texto) {
  if (!texto) return null;
  // ⚠️ la "a" separadora va como PALABRA (\s+a\s+), nunca en una clase de caracteres:
  // esa fue la trampa que rompió "mar-mié" en el L7.
  const re = /(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*(?:[-–—]|\s+a\s+|\s+to\s+|\s+hasta\s+)\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i;
  const m = String(texto).match(re);
  if (!m) return null;
  const h24 = (h, min, ap) => {
    let hh = parseInt(h, 10);
    if (ap === "pm" && hh < 12) hh += 12;
    if (ap === "am" && hh === 12) hh = 0;
    if (hh > 23 || parseInt(min || "0", 10) > 59) return null;
    return hh * 60 + parseInt(min || "0", 10);
  };
  const apIni = (m[3] || "").toLowerCase() || null;
  const apFin = (m[6] || "").toLowerCase() || null;
  // "12-3pm": el meridiano del final se aplica al principio. Si eso deja el inicio DESPUES
  // del fin ("9-3pm" -> 21:00-15:00, imposible), se usa el opuesto. Es determinista, no
  // una adivinanza: solo hay dos opciones y una de las dos es invalida.
  let iniAp = apIni || apFin;
  let ini = h24(m[1], m[2], iniAp);
  const fin = h24(m[4], m[5], apFin || apIni);
  if (ini === null || fin === null) return null;
  if (!apIni && apFin && ini >= fin) {
    ini = h24(m[1], m[2], apFin === "pm" ? "am" : "pm");
    if (ini === null || ini >= fin) return null;
  }
  if (ini >= fin) return null;
  const fmt = (t) => `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
  return { from: fmt(ini), until: fmt(fin) };
}

/** ¿Este texto habla de días u horarios? Lo usa la red de seguridad de 3b. */
export function mencionaDisponibilidad(texto) {
  const t = sinTilde(texto || "");
  if (!t) return false;
  // ⚠️ PALABRA COMPLETA, con plural opcional. Buscar el alias como PREFIJO daba falsos
  // positivos caros: `\bmar` engancha "maridaje", y "Menú de 4 tiempos con maridaje"
  // disparaba el aviso ámbar. Un aviso que salta donde no corresponde entrena al comercio
  // a ignorarlo, y entonces no sirve para el caso en que sí importa.
  const dias = Object.keys(DIAS_ALIAS).some((k) => new RegExp(`\\b${k}s?\\b`).test(t));
  const horas = /\d{1,2}\s*(am|pm)|\d{1,2}\s*:\s*\d{2}/.test(t);
  return dias || horas;
}

/**
 * Resuelve días y horarios del objeto crudo del asesor. Devuelve además de qué clave
 * salió cada cosa, para que quede a la vista en consola si el modelo vuelve a cambiar.
 */
export function resolverDisponibilidad(o = {}) {
  const res = { days: "", from: "", until: "", fuenteDias: null, fuenteHoras: null };

  const tryDias = (v, fuente) => {
    if (res.days) return;
    const d = normalizarDiasAsesor(v);
    if (d) { res.days = d; res.fuenteDias = fuente; }
  };
  const tryHoras = (v, fuente) => {
    if (res.from) return;
    const r = extraerRangoHorario(v);
    if (r) { res.from = r.from; res.until = r.until; res.fuenteHoras = fuente; }
  };

  // 1) nombres conocidos
  for (const k of ["available_days", "valid_days", "days", "dias", "dias_disponibles"]) tryDias(o[k], k);
  const desde = normalizarHoraAsesor(o.available_from ?? o.valid_time_start ?? o.from ?? o.desde ?? o.hora_inicio);
  const hasta = normalizarHoraAsesor(o.available_until ?? o.valid_time_end ?? o.until ?? o.to ?? o.hasta ?? o.hora_fin);
  if (desde && hasta) { res.from = desde; res.until = hasta; res.fuenteHoras = "campos explicitos"; }

  // 2) `when` / `cuando` — la via que usa la tarjeta, y la que fallaba
  for (const k of ["when", "cuando"]) { tryDias(o[k], k); tryHoras(o[k], k); }

  // 3) barrido generico por nombre de clave, sobre lo que quede
  for (const k of Object.keys(o)) {
    if (res.days && res.from) break;
    if (!CLAVE_DISPONIBILIDAD.test(sinTilde(k))) continue;
    const v = o[k];
    if (typeof v !== "string" && !Array.isArray(v)) continue;
    tryDias(v, k);
    tryHoras(v, k);
  }
  return res;
}

export function advisorOfferToForm(o = {}, fallbackLang = "es") {
  // P2c: mapeo EXPLÍCITO del vocabulario del asesor (descuento/combo/2x1/happy_hour/
  // upsell/…) → tipos del form. percent SOLO si el asesor lo dice explícito (la
  // clasificación percent además clava la cuota al piso en create_payment_intent);
  // fallback final SIEMPRE fixed, NUNCA percent. El título es señal válida para 2x1.
  const rawType = String(o.offer_type || o.type || "").toLowerCase().trim();
  const titleStr = String(o.title || o.title_es || o.title_en || o.name || "").toLowerCase();
  let offer_type;
  // s244 · asesor-umbral-v4-al-form: v4.0 propone «Recibe $X si gastas $2X» como `umbral`, el formato estándar del club
  // (UMBRAL_TIPO en App.jsx). Antes caía al `fixed` del final y el form lo trataba como precio fijo.
  if (rawType === "umbral") offer_type = "umbral";
  else if (["fixed", "bogo", "free", "percent"].includes(rawType)) offer_type = rawType;
  else if (/2\s*[x×]\s*1|dos\s*por\s*uno|two\s*for\s*one/.test(rawType) || /2\s*[x×]\s*1/.test(titleStr)) offer_type = "bogo";
  else if (/gratis|free|cortes[ií]a|regalo|complimentary/.test(rawType)) offer_type = "free";
  else if (/percent|porcentaje|%/.test(rawType)) offer_type = "percent";
  else offer_type = "fixed"; // descuento, combo, happy_hour, upsell, vacío, etc.

  const rp = NUM(o.regular_price ?? o.price);
  const cp = NUM(o.coupon_price ?? o.special_price);
  const upRaw = NUM(o.unit_price);
  // P2: bogo sin unit_price — el precio de 1 unidad es lo que se paga con el cupón,
  // o la mitad del precio regular de las 2 (matemática del 2x1). No inventa: deriva.
  // s244 · tarjeta-bogo-v4-precio-cero: v4.0 no manda unit/coupon/regular en el 2x1; manda el precio del ítem en
  // benefit_value_usd («benefit_value_usd = el precio de ese item», prompt v4.0). Sin esto la tarjeta decía «2×1 ($0)».
  // Va al final: el formato viejo (precios explícitos) sigue mandando igual.
  const unit_price = offer_type === "bogo"
    ? (upRaw || cp || (rp ? rp / 2 : 0) || NUM(o.benefit_value_usd ?? o.benefit_value))
    : upRaw;

  // P2d: si el asesor no calculó benefit_value_usd explícito, derivarlo de los precios
  // que sí mandó (caso Taikin: regular 100 − coupon 50 = el "ahorras $50" del título).
  let benefit = NUM(o.benefit_value_usd ?? o.benefit_value);
  if (!benefit) {
    if (offer_type === "bogo") benefit = unit_price;
    else if (offer_type === "free") benefit = rp;
    else if (rp && cp) benefit = Math.max(0, rp - cp);
  }

  // P2e: highlights — aceptar array, string con separadores, y nombres alternativos.
  let hl = o.highlights ?? o.destacados ?? o.bullets ?? o.puntos ?? null;
  if (typeof hl === "string") hl = hl.split(/\n|;|\||•/).map(s => s.trim()).filter(Boolean);
  if (!Array.isArray(hl)) hl = [o.highlight_1, o.highlight_2, o.highlight_3];

  const ts = NUM(o.typical_savings ?? o.savings);

  // s156-D3: percent sin precios explícitos — la cuenta típica se deriva del ahorro y el
  // porcentaje que sí mandó el asesor. Desde s155-D3 el form calcula el benefit de percent
  // como cuenta × porcentaje, así que sin regular_price toda percent del asesor quedaría en
  // beneficio 0: no se podría guardar (D6) ni aprobar (approve_offer exige regular_price > 0).
  const disp = resolverDisponibilidad(o);

  // s244 · el umbral lleva el mínimo también en regular_price (approve_offer exige regular_price > 0; mismo criterio que
  // elegir() del form y ofertaDeIntro).
  const minimoUmbral = NUM(o.min_consumption ?? o.minimum_spend ?? o.consumo_minimo ?? o.min_spend);
  let regular_price_out = offer_type === "umbral" ? (minimoUmbral || rp) : rp;
  if (offer_type === "percent" && !regular_price_out) {
    const dpOut = NUM(o.discount_pct ?? o.percent);
    if (ts > 0 && dpOut > 0) regular_price_out = Math.round((ts / (dpOut / 100)) * 100) / 100;
  }

  return {
    offer_type,
    title: o.title || o.title_es || o.title_en || o.name || "",
    description: o.description || o.description_es || o.description_en || "",
    rules_text: o.rules_text || o.rules || "",
    source_lang: o.source_lang || o.lang || fallbackLang,
    // benefit 0/no-derivable → "" para que el form caiga al cálculo por precios si el
    // merchant los completa después (un 0 numérico fijaría la cuota al piso por error).
    benefit_value_usd: benefit || "",
    category: o.category || "",
    regular_price: regular_price_out,
    coupon_price: cp,
    unit_price,
    // discount_pct SOLO acompaña a percent: create_payment_intent clava la cuota al piso
    // si discount_pct > 0, sin mirar el tipo — un bogo con discount_pct residual pagaría mal.
    discount_pct: offer_type === "percent" ? NUM(o.discount_pct ?? o.percent) : 0,
    // percent sin typical_savings explícito: usar el benefit derivado para que el
    // form quede coherente (el input Ahorro Típico es lo único que ve el merchant).
    typical_savings: ts || (offer_type === "percent" ? benefit : 0),
    highlight_1: hl[0] || "",
    highlight_2: hl[1] || "",
    highlight_3: hl[2] || "",
    // s179 L7 + L9: disponibilidad. El L7 usaba una lista fija de nombres y en runtime no
    // alcanzo — el modelo la manda en `when`. resolverDisponibilidad prueba nombres
    // conocidos, despues `when`/`cuando`, y despues barre las claves por patron.
    // Si no encuentra nada quedan "" y el form se comporta como antes; la red de
    // seguridad de 3b avisa cuando el TEXTO menciona dias/horas y los campos estan vacios.
    valid_days: disp.days,
    valid_time_start: disp.from,
    valid_time_end: disp.until,
    min_consumption: NUM(o.min_consumption ?? o.minimum_spend ?? o.consumo_minimo ?? o.min_spend),
  };
}

// s244 · schema v2.1 del conector (pase s244 §8.5): la raíz es un OBJETO con `tarjeta_1`…`tarjeta_4` obligatorias, porque la
// gramática de Anthropic no hace cumplir `minItems` > 1 en un array (corrida 1 parcial: 2 de 6 respuestas con 1 tarjeta).
// Se devuelve la lista en ese orden; `incompleta` = falta alguna de las cuatro. El array viejo se sigue aceptando: Live
// todavía responde así.
export const TARJETAS_ASESOR = ["tarjeta_1", "tarjeta_2", "tarjeta_3", "tarjeta_4"];
export function tarjetasDelAsesor(parsed) {
  if (!parsed || Array.isArray(parsed) || typeof parsed !== "object") return null;
  if (!TARJETAS_ASESOR.some(k => k in parsed)) return null;
  const lista = TARJETAS_ASESOR.map(k => parsed[k]).filter(o => o && typeof o === "object" && !Array.isArray(o));
  return { lista, incompleta: lista.length < TARJETAS_ASESOR.length };
}

// Saca el array de ofertas del JSON del advisor, soportando varias formas:
// [...]  |  {tarjeta_1..tarjeta_4}  |  {offers:[...]}  |  {suggestions:[...]}  |  {ofertas:[...]}
function offersFromAdvisorJson(parsed) {
  if (!parsed) return [];
  if (Array.isArray(parsed)) return parsed;
  const t = tarjetasDelAsesor(parsed);
  if (t) return t.lista;
  return parsed.offers || parsed.suggestions || parsed.ofertas || parsed.ideas || [];
}

// Campos v2 del asesor (para mostrar en la tarjeta; NO van al form de create_offer).
function pickAdv(o = {}) {
  return {
    when: o.when || o.cuando || "",
    offer_type: String(o.offer_type || o.type || "").toLowerCase(),
    regular_price: NUM(o.regular_price ?? o.price),
    coupon_price: NUM(o.coupon_price ?? o.special_price),
    discount_pct: NUM(o.discount_pct ?? o.percent),
    est_cost: NUM(o.est_cost),
    margin_kept_usd: NUM(o.margin_kept_usd ?? o.margin_kept),
    margin_kept_pct: NUM(o.margin_kept_pct),
    why_it_works: o.why_it_works || o.why || "",
    risk_level: String(o.risk_level || "").toLowerCase(),
    item: String(o.item || ""),   // s244 · v4.0: el ítem del 2x1, tal como lo escribió el asesor (lo mira marcarItemsSinFuente)
  };
}

// Parsea un advisor_json CRUDO (el string que devuelve el modelo) al shape del form.
// s169: se exporta porque la rehidratación de propuestas guardadas lo necesita —
// `last_advisor_json` puede venir escrito server-side por offer_advisor/ingest_offer_ideas,
// y en ese caso es exactamente este formato crudo, no el sobre que arma el front.
export function parseAdvisorRaw(raw, lang = "es") {
  const parsed = extractJson(raw);
  const crudas = offersFromAdvisorJson(parsed);

  // s179 L7 — SONDA: el mapeo de disponibilidad no sirve de nada si el modelo no manda
  // esos campos, y eso vive en el system prompt (AssistantConfig, Bubble, zona de Ali).
  // Se loguean las CLAVES que trae cada propuesta, nunca su contenido: alcanza para
  // decidir si hay que tocar el prompt, y no vuelca datos del comercio a la consola.
  try {
    // s192 — EL CANAL QUE FALTABA, y que tenía trabada la Fase 2.a. El cierre de s191 lo
    // dejó dicho: la apertura pedía «Ali pega el JSON de las propuestas que salió en su
    // consola», y esta sonda no imprime el JSON — imprime CLAVES, a propósito y con razón
    // (la línea de abajo no vuelca datos del comercio al buffer de la consola). O sea que
    // la Fase 2.a no esperaba a Ali: esperaba un canal que no existía.
    //
    // La distinción que resuelve las dos cosas a la vez: no IMPRIMIR por defecto, pero
    // dejar el dato ALCANZABLE a pedido. El crudo ya viajaba hasta acá —
    // `shapeAdvisorResponse` incluso lo devuelve como `raw`— y no había forma de sacarlo.
    // Guardarlo en `window` no es loguearlo: no entra en el buffer de la consola, y solo
    // lo alcanza quien ya está sentado frente a esa sesión mirando las propuestas.
    //
    // Para llevarlo entero, desde la consola de esa misma pestaña:  copy(NXT_ADVISOR_RAW)
    // Sirve para la Fase 2.a (ver la pantalla con los datos que el asesor produce HOY) y
    // para cerrar `asesor-inventa-claim-de-competencia`, que necesita leer un
    // `why_it_works` nuevo y comprobar que el claim «pagas 5%» ya no aparece.
    // Va PRIMERO dentro del try: si algo de la sonda falla más abajo, el crudo ya quedó.
    if (typeof window !== "undefined") window.NXT_ADVISOR_RAW = raw;

    const claves = [...new Set(crudas.flatMap((o) => Object.keys(o || {})))].sort();
    const DISPONIBILIDAD = ["available_days", "valid_days", "days", "dias", "dias_disponibles",
      "available_from", "valid_time_start", "from", "desde", "hora_inicio",
      "available_until", "valid_time_end", "until", "to", "hasta", "hora_fin",
      "min_consumption", "minimum_spend", "consumo_minimo", "min_spend"];
    const trajo = claves.filter((k) => DISPONIBILIDAD.includes(k));
    console.info("[asesor] %d propuesta(s) · claves: %s", crudas.length, claves.join(", "));
    console.info("[asesor] JSON crudo en memoria — para copiarlo entero:  copy(NXT_ADVISOR_RAW)");
    console.info("[asesor] disponibilidad por nombre conocido: %s", trajo.length ? trajo.join(", ") : "ninguna");
    // s179 L9: lo que importa no es que clave EXISTE sino de cual salio el dato. Se
    // loguea la clave ganadora y su valor crudo para que, si el modelo vuelve a cambiar
    // de nombre, se vea en la consola sin tener que reproducir el bug entero.
    crudas.forEach((o, i) => {
      const d = resolverDisponibilidad(o || {});
      const dv = d.fuenteDias ? `${d.fuenteDias}="${(o || {})[d.fuenteDias]}" -> ${d.days}` : "NO ENCONTRADA";
      const hv = d.fuenteHoras ? `${d.fuenteHoras} -> ${d.from}-${d.until}` : "NO ENCONTRADA";
      console.info("[asesor] #%d dias: %s | horas: %s", i + 1, dv, hv);
    });
  } catch (_) { /* una sonda de diagnostico jamas puede romper el parseo */ }

  return crudas.map((o) => ({ ...advisorOfferToForm(o, lang), _adv: pickAdv(o) }));
}

// Resultado común de ambos carriles: { offers: [formShape + _adv], disclaimer, raw, incompleta }
// s244 · `incompleta`: el asesor respondió con el objeto de 4 tarjetas y faltó alguna (en el array viejo no se puede saber: false).
// s244 · `tarjetas`: la respuesta vino como `tarjeta_1…4` (prompt v4.x). Con el array viejo (v3.3.2, Live hasta el deploy de
// v4.1) es false y TAMAÑOS no se aplica: v3.3.2 no lee esa línea y sus textos hablan de su propia mecánica (2x1, regalo, %).
export function shapeAdvisorResponse(resp, lang) {
  const t = tarjetasDelAsesor(extractJson(resp?.advisor_json));
  return {
    offers: parseAdvisorRaw(resp?.advisor_json, lang),
    disclaimer: resp?.disclaimer || "",
    raw: resp?.advisor_json || "",
    incompleta: !!(t && t.incompleta),
    tarjetas: !!t,
  };
}

// Mapea la categoría del merchant (option set del wizard) al rubro de MarginProfile (seed s94).
// s103 FIX: el mapa viejo ("Restaurante", "Spa / Belleza", …) era del seed pre-s94 y no matcheaba
// NINGÚN perfil snake_case → el bloque de margen venía vacío silencioso en ambos carriles.
// Defaults por categoría (diccionario DISENO_merchant_onboarding_front_s103 §4b); cuando exista
// MerchantPartner.business_type (alta v2) este mapa pasa a ser solo fallback.
//
// s186 — este mapa es el FALLBACK: traduce la categoría gruesa del catálogo (6 slugs) al
// rubro fino de MarginProfile cuando el comercio no tiene `business_type` cargado. Desde
// s186 el llamador manda el rubro fino cuando existe, y entonces este mapa no lo toca
// (la clave no está en el mapa → pasa de largo). Ver App.jsx `advisorRubro`.
const ADVISOR_RUBRO_MAP = {
  Restaurant: "restaurante_casual",
  Salon_Spa: "spa_masajes",
  Nail_Lash: "unas_pelu_barberia",
  Bar_Rooftop: "bar_cocktails",
  Gift_Moments: "tortas_reposteria",   // s241 · Celebraciones (SPEC_s240 §3.4)
  Experience: "tours_experiencias",
  // s186 `advisor-rubro-map-sin-sweets`: faltaba la séptima categoría del option set, y
  // heladerías y pastelerías caían al else con "Sweets" crudo — que no es fila de ningún
  // MarginProfile. ⚠️ `heladeria_pasteleria` TAMPOCO existe todavía como fila en Live: esto
  // arregla la mitad de React, la otra mitad es crear la fila (mismo ticket).
  Sweets: "heladeria_pasteleria",
  // s186 `margen-hotel-clave-no-matchea`: alias de compatibilidad, NO una categoría. El
  // alta escribía la clave "Hotel" y la fila de margen se llama `hotel_alojamiento`. La
  // tabla de App.jsx ya no la produce; esto cubre a los comercios que la tengan guardada.
  Hotel: "hotel_alojamiento",
};

// s244 · advisor-contexto-horario (pase s244 §6). El asesor proponía ofertas en días cerrados (corrida 0 del banco del dueño:
// Willy cierra los lunes y 12 de 16 ofertas cayeron en lunes) porque nunca recibía el horario. Va una línea por día con los
// MISMOS tokens que `valid_days` (Lun…Dom, sin tilde: así los pide el contrato), para que el asesor copie el día tal cual.
// Un día cerrado se DICE («Lun cerrado»); un día sin dato se omite (no se inventa). Sin ningún día con dato → "" y el bloque no va.
const DIAS_ASESOR = [["mon", "Lun"], ["tue", "Mar"], ["wed", "Mie"], ["thu", "Jue"], ["fri", "Vie"], ["sat", "Sab"], ["sun", "Dom"]];
export function horarioParaAsesor(raw) {
  let arr = raw;
  if (typeof raw === "string") { try { arr = raw.trim() ? JSON.parse(raw) : []; } catch (e) { return ""; } }
  if (!Array.isArray(arr)) return "";
  const rango = (o, c) => (o && c ? `${o}–${c}` : "");   // U+2013, como horarioDesdeJson (App.jsx)
  return DIAS_ASESOR.map(([key, tok]) => {
    const d = arr.find(x => x && x.day === key);
    if (!d) return "";
    if (d.closed === true) return `${tok} cerrado`;
    const r = [rango(d.r1o, d.r1c), rango(d.r2o, d.r2c)].filter(Boolean).join(", ");
    return r ? `${tok} ${r}` : "";
  }).filter(Boolean).join(" · ");
}

// s244-D7 · LOS NÚMEROS LOS PONE REACT. `tamanos` = { linea, tarjetas: [4] } (App.jsx tamanosDelAsesor, con las funciones de
// la consola). La IA copia la línea TAMAÑOS; si igual cambia un número, se vuelve a poner el de la regla y la propuesta queda
// con `_adv.numeros_corregidos` (y la respuesta con `numeros_corregidos`, el conteo, para el banco). La tarjeta 3 puede ser
// 2x1 cuando la fuente trae ítem con precio: ahí se respeta el bogo; si no, pasa al umbral (s253, bogoDeLaFuente).
// COSTO% / MARGEN% / DESCMAX% ya no viajan (s244-D7: el asesor no estima costo ni margen).
const FRASE_UMBRAL_TITULO = /(recibe|get) \$\d+(?:[.,]\d+)? (si gastas|when you spend) \$\d+(?:[.,]\d+)?/i;
const FRASE_PCT_TITULO = /\d+ ?% (en tu cuenta|off your bill)(, (hasta|up to) \$\d+(?:[.,]\d+)?|, (sin tope|no cap))?/i;
function tituloConTamano(title, t, en) {
  const s = String(title || "");
  if (t.offer_type === "bogo") {   // s245 · el 2x1 que eligió React: «2x1 en [ítem]», con los días delante si los había
    const fraseB = en ? `2-for-1 on ${t.item}` : `2x1 en ${t.item}`;
    const preB = prefijoDeDias(s);
    return preB ? `${preB}: ${fraseB}` : fraseB;
  }
  const frase = t.offer_type === "percent"
    ? (en ? `${t.discount_pct}% off your bill, no cap` : `${t.discount_pct} % en tu cuenta, sin tope`)
    : (en ? `Get $${t.benefit_value_usd} when you spend $${t.min_consumption}` : `Recibe $${t.benefit_value_usd} si gastas $${t.min_consumption}`);
  // Con función: un reemplazo en texto tomaría «$15» como el grupo $1 seguido de un 5.
  if (FRASE_UMBRAL_TITULO.test(s)) return s.replace(FRASE_UMBRAL_TITULO, () => frase);
  if (FRASE_PCT_TITULO.test(s)) return s.replace(FRASE_PCT_TITULO, () => frase);
  // s245 · un 2x1 que pasa a umbral conserva los días delante («Martes a jueves de 2 a 5 pm: 2x1 en café» → «Martes a jueves
  // de 2 a 5 pm: Recibe $10 si gastas $20»); antes se perdían (corrida 5, #1r1).
  const pre = prefijoDeDias(s);
  return pre ? `${pre}: ${frase}` : frase;
}

// s245 · el prefijo de días del título de la tarjeta 4 («Mar a jue de 2 a 5 pm: …», «Mon to Thu: …»): lo que va antes del
// primer «: » cuando nombra al menos un día. Sin días delante → "" (un «:» de una hora o de otra frase no cuenta).
const DIA_EN_PREFIJO = /(^|[^a-záéíóúñ])(lun|mar|mi[eé]|jue|vie|s[aá]b|dom|mon|tue|wed|thu|fri|sat|sun)/i;
function prefijoDeDias(title) {
  const m = /^([^:]{2,60}?):\s+/.exec(String(title || ""));
  return m && DIA_EN_PREFIJO.test(m[1]) ? m[1].trim() : "";
}
function sinPrefijoDeDias(title) {
  const s = String(title || "");
  const pre = prefijoDeDias(s);
  return pre ? s.slice(s.indexOf(":") + 1).trim() : s;
}
const DIA_LARGO = { es: { Lun: "Lunes", Mar: "Martes", Mie: "Miércoles", Jue: "Jueves", Vie: "Viernes", Sab: "Sábado", Dom: "Domingo" },
  en: { Lun: "Monday", Mar: "Tuesday", Mie: "Wednesday", Jue: "Thursday", Vie: "Friday", Sab: "Saturday", Dom: "Sunday" } };
const DIA_CORTO = { es: { Lun: "Lun", Mar: "Mar", Mie: "Mié", Jue: "Jue", Vie: "Vie", Sab: "Sáb", Dom: "Dom" },
  en: { Lun: "Mon", Mar: "Tue", Mie: "Wed", Jue: "Thu", Vie: "Fri", Sab: "Sat", Dom: "Sun" } };
// Los días de `valid_days` dichos como en el título del prompt: uno → su nombre; seguidos → rango; sueltos → lista.
export function diasParaTitulo(validDays, en) {
  const L = en ? "en" : "es";
  const ds = DIAS_ORDEN.filter(d => String(validDays || "").split(",").includes(d));
  if (!ds.length) return "";
  if (ds.length === 1) return DIA_LARGO[L][ds[0]];
  const seguidos = ds.every((d, k) => k === 0 || DIAS_ORDEN.indexOf(d) === DIAS_ORDEN.indexOf(ds[k - 1]) + 1);
  if (seguidos) return `${DIA_CORTO[L][ds[0]]} ${en ? "to" : "a"} ${DIA_CORTO[L][ds[ds.length - 1]]}`;
  const c = ds.map(d => DIA_CORTO[L][d]);
  return `${c.slice(0, -1).join(", ")} ${en ? "&" : "y"} ${c[c.length - 1]}`;
}
const diasDelPrefijo = (pre) => normalizarDiasAsesor(String(pre || "").replace(/\s+to\s+/gi, "-"));

// s245 · `t4-texto-dias-de-valid-days` (prueba en Live, §4.38: la t4 de martes y miércoles decía «de lunes a miércoles» en la
// description y el why, y el lunes cierra; React ya arreglaba el título, no el texto). Un rango o una lista de días (dos o más) en
// el texto de la t4 que no coincide con `valid_days` se reemplaza por los días que quedaron, dichos en prosa. Un día suelto no se
// toca: puede ser otra cosa («los lunes cerramos»).
const DIA_PROSA = { es: { Lun: "lunes", Mar: "martes", Mie: "miércoles", Jue: "jueves", Vie: "viernes", Sab: "sábado", Dom: "domingo" },
  en: { Lun: "Monday", Mar: "Tuesday", Mie: "Wednesday", Jue: "Thursday", Vie: "Friday", Sab: "Saturday", Dom: "Sunday" } };
export function diasEnProsa(validDays, en) {
  const L = en ? "en" : "es";
  const ds = DIAS_ORDEN.filter(d => String(validDays || "").split(",").includes(d)).map(d => d);
  if (!ds.length) return "";
  const n = ds.map(d => DIA_PROSA[L][d]);
  if (ds.length === 1) return n[0];
  const seguidos = ds.every((d, k) => k === 0 || DIAS_ORDEN.indexOf(d) === DIAS_ORDEN.indexOf(ds[k - 1]) + 1);
  if (seguidos && ds.length >= 3) return en ? `${n[0]} to ${n[n.length - 1]}` : `de ${n[0]} a ${n[n.length - 1]}`;
  return `${n.slice(0, -1).join(", ")} ${en ? "and" : "y"} ${n[n.length - 1]}`;
}
const NOMBRE_DIA = "lunes|martes|mi[eé]rcoles|jueves|viernes|s[aá]bados?|domingos?|mondays?|tuesdays?|wednesdays?|thursdays?|fridays?|saturdays?|sundays?";
const RANGO_DIAS = new RegExp(`(?<![\\p{L}])(?:(?:de|from)\\s+)?(?:${NOMBRE_DIA})(?:\\s*,\\s*(?:${NOMBRE_DIA}))*(?:\\s+(?:a|al|y|e|to|through|and)\\s+|\\s*[-–]\\s*)(?:${NOMBRE_DIA})(?![\\p{L}])`, "giu");
export function corregirDiasEnTexto(texto, validDays, en) {
  return String(texto || "").replace(RANGO_DIAS, (m) => {
    const dias = normalizarDiasAsesor(m.replace(/^(de|from)\s+/i, "").replace(/\s+(to|through|al)\s+/gi, " a ").replace(/\s+(and|e)\s+/gi, " y "));
    if (!dias || dias === validDays) return m;
    const p = diasEnProsa(validDays, en);
    return /^[A-ZÁÉÍÓÚÑ]/.test(m) ? p.charAt(0).toUpperCase() + p.slice(1) : p;
  });
}

// s246 · `t123-texto-sin-franja` (pase s246 §13: en una t1 en inglés la description decía «Weekday midday slots, Monday to Wednesday,
// 11am to 2pm» —con el lunes cerrado— y React solo limpiaba los campos). En una tarjeta permanente, se quita del texto la oración o
// el inciso que nombra un RANGO de días (dos o más, RANGO_DIAS) o un RANGO de horas; si la oración tenía uno, se van también los
// incisos con palabras de franja («midday», «entre semana»…). Un día suelto se respeta, como en s245 («los lunes cerramos»). Por
// renglón (las reglas van una por renglón), oración e inciso. Dentro del inciso se quita solo el rango («Reserva tu cita de martes
// a jueves y recibe 20 %» → «Reserva tu cita y recibe 20 %»); si queda una cáscara (menos de 3 palabras, o una palabra de franja), se
// va el inciso entero. Lo que queda se vuelve a armar con su mayúscula y su punto.
const HORA = String.raw`\d{1,2}(?::\d{2})?\s*(?:am|pm|a\.\s?m\.|p\.\s?m\.)`;
const RANGO_HORAS_SRC = String.raw`(?<![\d$\p{L}])(?:(?:de|from|between|entre)\s+)?(?:` + HORA + String.raw`|\d{1,2}(?::\d{2})?)\s*(?:a|to|and|y|-|–|hasta)\s*` + HORA + String.raw`(?![\p{L}])`
  + String.raw`|(?<![\d$])(?:(?:de|from)\s+)?\d{1,2}:\d{2}\s*(?:a|to|-|–|hasta)\s*\d{1,2}:\d{2}`
  + String.raw`|(?<![\p{L}])de\s+\d{1,2}\s+a\s+\d{1,2}(?!\s*(?:personas|people|%|\$|d[ií]as|days|a[nñ]os|years))(?![\d\p{L}])`;
const RANGO_HORAS = new RegExp(RANGO_HORAS_SRC, "iu");
const PALABRA_FRANJA = /(?<![\p{L}])(?:weekdays?|weeknights?|midday|lunch ?hour|afternoons?|evenings?|weekends?|entre semana|mediod[ií]a|hora del almuerzo|almuerzo|tardes?|noches?|fin(?:es)? de semana)(?![\p{L}])/iu;
const tieneFranja = (s) => new RegExp(RANGO_DIAS.source, "iu").test(s) || RANGO_HORAS.test(s);
const incisoSinFranja = (inc) => {
  if (!tieneFranja(inc)) return PALABRA_FRANJA.test(inc) ? "" : inc;
  const r = inc.replace(new RegExp(RANGO_DIAS.source, "giu"), " ").replace(new RegExp(RANGO_HORAS_SRC, "giu"), " ")
    .replace(/\s{2,}/g, " ").replace(/^\s*(?:y|and|e)\s+|\s+(?:y|and|e)\s*$/i, "").trim();
  return r.split(/\s+/).filter(Boolean).length < 3 || PALABRA_FRANJA.test(r) ? "" : r;
};
// Recorre el texto por renglón, oración e inciso: donde `tiene` da sí, cada inciso pasa por `inciso` (que lo limpia o lo devuelve
// vacío) y la oración se vuelve a armar con su mayúscula y su punto. Lo usan sinFranjaEnTexto, sinPromesasFalsas y sinMargenEnTexto.
function quitarPorIncisos(texto, tiene, inciso) {
  const s = String(texto || "");
  if (!tiene(s)) return s;
  return s.split("\n").map((renglon) => {
    if (!tiene(renglon)) return renglon;
    return renglon.split(/(?<=[.!?])\s+/).map((o) => {
      if (!tiene(o)) return o;
      const fin = (o.match(/[.!?]$/) || [""])[0];
      const quedan = o.replace(/[.!?]$/, "").split(/\s*[,;]\s+|\s+[—–]\s+/).map(inciso).filter(Boolean);
      if (!quedan.length) return "";
      const r = quedan.join(", ");
      return r.charAt(0).toUpperCase() + r.slice(1) + fin;   // sin punto si no lo tenía: los highlights no llevan
    }).filter(Boolean).join(" ");
  }).filter(r => r.trim()).join("\n").trim();
}
export function sinFranjaEnTexto(texto, en) {
  return quitarPorIncisos(texto, tieneFranja, incisoSinFranja);
}

// s246 · `umbral-texto-proxima-visita` (recorrido «Tu negocio» en test, pase s246 §15: el detalle de «Recibe $25 si gastas $50» decía
// «recibe $25 de vuelta en la próxima visita» y un highlight «Sin cupón especial ni registro»). En el club el umbral es un descuento EN
// ESA MISMA cuenta («Ahorra $25 cuando gastas $50», fraseUmbral) y el miembro activa un cupón en la app: las dos frases son promesas
// falsas. De lo que lee el miembro (description, reglas, highlights) se quita «(de vuelta) en tu próxima visita» y sus variantes, y el
// inciso que dice «sin cupón» o «sin registro». El why (para el dueño) no se toca.
const PROXIMA_VISITA = /\s*(?:(?:de vuelta|back)\s+)?(?:en|para|on|for|at|toward|towards)\s+(?:tu|la|su|el|your|the|their)\s+(?:pr[oó]xim[ao]|siguiente|next)\s+(?:visita|compra|cita|pedido|reserva|visit|purchase|appointment|order|booking)(?![\p{L}])/giu;
const SIN_CUPON = /(?<![\p{L}])(?:(?:sin|without)\s+(?:(?:un|necesidad de|need for|a)\s+)?(?:cup[oó]n(?:es)?|coupons?|registros?|registrarte|inscripci[oó]n|sign[- ]?ups?|registration)|no\s+(?:coupon|sign[- ]?up|registration)s?(?:\s+(?:needed|required))?)(?![\p{L}])/iu;
const tienePromesa = (s) => new RegExp(PROXIMA_VISITA.source, "iu").test(s) || SIN_CUPON.test(s);
const incisoSinPromesa = (inc) => {
  if (SIN_CUPON.test(inc)) return "";
  const r = inc.replace(new RegExp(PROXIMA_VISITA.source, "giu"), "").replace(/\s{2,}/g, " ").trim();
  if (r === inc.trim()) return inc;
  return r.split(/\s+/).filter(Boolean).length < 2 ? "" : r;
};
export function sinPromesasFalsas(texto) {
  return quitarPorIncisos(texto, tienePromesa, incisoSinPromesa);
}
// Las cuatro tarjetas. Devuelve cuántas tocó; cada una queda con `_adv.promesa_corregida`.
export function corregirPromesas(offers = [], lang = "es") {
  const en = lang === "en";
  let n = 0;
  offers.forEach((o) => {
    if (!o) return;
    let toco = false;
    const poner = (k, respaldo) => {
      if (typeof o[k] !== "string" || !o[k]) return;
      const nuevo = sinPromesasFalsas(o[k]) || respaldo;
      if (nuevo !== o[k]) { o[k] = nuevo; toco = true; }
    };
    poner("description", en ? "Show your coupon when you pay." : "Muestra tu cupón al pagar.");
    poner("rules_text", "");
    // Un highlight que queda vacío toma la primera frase de respaldo que no esté ya en otro highlight (no dos iguales).
    const respaldos = en ? ["Activate it in the app", "Show your coupon when you pay", "One coupon per visit"]
      : ["Lo activas en la app", "Muestra tu cupón al pagar", "Un cupón por visita"];
    ["highlight_1", "highlight_2", "highlight_3"].forEach(k => {
      const usados = ["highlight_1", "highlight_2", "highlight_3"].filter(j => j !== k).map(j => o[j]);
      poner(k, respaldos.find(f => !usados.includes(f)) || respaldos[0]);
    });
    if (toco) { if (o._adv) o._adv.promesa_corregida = true; n += 1; }
  });
  return n;
}

// s245 · LAS FRANJAS LAS ORDENA REACT (corrida 5): las tarjetas 1–3 son permanentes siempre; sin HORARIO en el perfil la 4
// también; con HORARIO, la 4 pierde los días que el comercio marca cerrados (si no queda ninguno, queda permanente). Si los
// días cambian, o el título nombra otros días que `valid_days`, el prefijo del título se rehace con los días que quedan.
// Solo con la respuesta `tarjeta_1…4` (como TAMAÑOS). Devuelve cuántas tarjetas tocó; cada una queda con `_adv.franja_corregida`.
export function ajustarFranjas(offers = [], horarioRaw, lang = "es") {
  const en = lang === "en";
  let cerrados = [];
  const hayHorario = !!horarioParaAsesor(horarioRaw);
  if (hayHorario) {
    let arr = horarioRaw;
    if (typeof arr === "string") { try { arr = JSON.parse(arr); } catch (e) { arr = []; } }
    cerrados = DIAS_ASESOR.filter(([key]) => (arr || []).some(x => x && x.day === key && x.closed === true)).map(([, tok]) => tok);
  }
  const permanente = (o) => {
    o.valid_days = ""; o.valid_time_start = ""; o.valid_time_end = "";
    if (o._adv) o._adv.when = "";
    o.title = sinPrefijoDeDias(o.title);
  };
  // s246 · t123-texto-sin-franja: lo que lee el miembro en una tarjeta permanente tampoco nombra días ni horas.
  const textoPermanente = (o) => {
    let cambio = false;
    ["description", "rules_text"].forEach(k => {
      if (typeof o[k] !== "string" || !o[k]) return;
      // La description no queda vacía; las reglas sí pueden perder su único renglón de franja.
      const nuevo = sinFranjaEnTexto(o[k], en) || (k === "description" ? (en ? "Valid any day we're open." : "Vale cualquier día que abrimos.") : "");
      if (nuevo !== o[k]) { o[k] = nuevo; cambio = true; }
    });
    ["highlight_1", "highlight_2", "highlight_3"].forEach(k => {
      if (typeof o[k] !== "string" || !o[k]) return;
      const nuevo = sinFranjaEnTexto(o[k], en) || (en ? "Valid any day we're open" : "Vale cualquier día que abrimos");
      if (nuevo !== o[k]) { o[k] = nuevo; cambio = true; }
    });
    return cambio;
  };
  let n = 0;
  offers.forEach((o, i) => {
    if (!o) return;
    const conFranja = !!(o.valid_days || o.valid_time_start || o.valid_time_end || (o._adv && o._adv.when));
    let toco = false;
    if (i < 3 || !hayHorario) {
      if (conFranja || prefijoDeDias(o.title)) { permanente(o); toco = true; }
      if (textoPermanente(o)) toco = true;
    } else if (o.valid_days) {
      const quedan = String(o.valid_days).split(",").filter(d => d && !cerrados.includes(d)).join(",");
      if (!quedan) { permanente(o); textoPermanente(o); toco = true; }
      else {
        const pre = prefijoDeDias(o.title);
        if (quedan !== o.valid_days || (pre && diasDelPrefijo(pre) !== quedan)) {
          o.valid_days = quedan;
          o.title = `${diasParaTitulo(quedan, en)}: ${sinPrefijoDeDias(o.title)}`;
          toco = true;
        }
        // s245 · los rangos de días del texto también salen de valid_days (description, reglas, highlights y why)
        const campos = [[o, "description"], [o, "rules_text"], [o, "highlight_1"], [o, "highlight_2"], [o, "highlight_3"], [o._adv, "why_it_works"]];
        campos.forEach(([obj, k]) => {
          if (!obj || typeof obj[k] !== "string") return;
          const nuevo = corregirDiasEnTexto(obj[k], quedan, en);
          if (nuevo !== obj[k]) { obj[k] = nuevo; toco = true; }
        });
      }
    }
    if (toco) { if (o._adv) o._adv.franja_corregida = true; n += 1; }
  });
  return n;
}
// s245 · EL 2x1 TAMBIÉN LO DECIDE REACT (bloque 1, §4.31 del pase: con precios en la fuente la IA propuso 2x1 en 2 de 7 casos,
// 0 de 3 en salones). Si el texto del negocio o lo que escribió el dueño traen «nombre $precio», React elige el producto y la
// tarjeta 3 viaja ya decidida («tarjeta_3 = bogo: 2x1 en Arroz con pollo ($19)»); aplicarTamanos la vuelve a poner si la IA la
// cambia. El producto: el más caro que no pase el tope del rubro sobre el ticket por persona (el prompt pedía «ni la proteína
// premium ni el servicio insignia de precio alto»), sin alcohol, desde $5. Sin producto que cumpla, la tarjeta 3 sigue como
// antes (el umbral, con el 2x1 a criterio de la IA). La web la lee Bubble: en ese camino React no ve los precios.
const TOPE_BOGO = { Restaurant: 0.6, Bar_Rooftop: 0.6, Sweets: 0.6, Salon_Spa: 0.8, Nail_Lash: 0.8, Experience: 0.8, Gift_Moments: 0.8 };
const BOGO_MINIMO_USD = 5;
// s247 · `alcohol-sake-y-otros` (recorrido del pase s247 §7: «Sake caliente — 9.00» llegó a la IA): + sake, soju, cava, vermut,
// aperol, spritz, michelada, mezcal, pisco, cachaça y familia. «Sake» seguido de nigiri, sashimi, maki… es salmón, no la bebida.
const ALCOHOL_EN_ITEM = /(?<![\p{L}])(c[oó]ctel(?:es)?|cocktails?|cervezas?|beers?|vinos?|wines?|tragos?|licor(?:es)?|shots?|mimosas?|sangr[ií]as?|margaritas?|mojitos?|tequila|ron|rum|whisky|vodka|gin|champ[aá]n|champagne|prosecco|sake(?!\s+(?:nigiri|sashimi|maki|temaki|roll|don|onigiri|teriyaki|poke))|soju|cava|verm[uú]t|vermouth|aperol|spritz(?:es)?|micheladas?|mezcal|pisco|cacha[cç]a|caipirinhas?|daiquir[ií]s?|bourbon|brandy|co[nñ]ac|cognac|aguardiente|sidra|ciders?)(?![\p{L}])/iu;
// Lo que lleva un «$N» y no es un producto: el ticket, el objetivo, una oferta, un rango, un «desde».
const NO_ES_PRODUCTO = /(?<![\p{L}])(ticket|promedio|gast[ao]s?|gasta[sn]?|recibe|cuenta|ofertas?|descuentos?|m[ií]nimo|propinas?|objetivo|tope|hasta|desde|combos?|paquetes?|packs?|men[uú]|precios?|total|avg|spend|goal|from)(?![\p{L}])/iu;
// «Nombre $12» · «Nombre: $12» · «Nombre – $12» · «Nombre ($12)». No toma un rango («$10–$15», «$10 a $15»).
// s247 · par-producto-sin-signo: también «Nombre — 19.00», el formato que sugiere el campo de «Tu negocio» (sin «$»). Sin signo
// pide la raya separada por espacios y los dos decimales, para no leer «lun-mié 5-9pm» ni «2 - 4 personas» como un precio.
const PAR_PRODUCTO = /([A-Za-zÁÉÍÓÚÑÜáéíóúñü][^$\n·•;|:()]{1,60}?)\s*(?:(?:[:\-–—]\s*|\(\s*)?\$\s?(\d{1,4}(?:[.,]\d{1,2})?)|(?<=\s)[—–-]\s+(\d{1,4}[.,]\d{2}))(?![\d.,]*\s*(?:[-–—]|a|to)\s*\$?\d)/gu;
// s245 · LO QUE LLEVA ALCOHOL NO LLEGA A LA IA (bloque 2, §4.35: copió «…y mojito de la casa» de la lista del dueño a una
// description; el prompt ya lo prohíbe y aun así pasa). Del texto que viaja como TEXTO DEL NEGOCIO e INFO DEL COMERCIO se saca
// cada pedazo que nombra una bebida con alcohol: primero por renglón o separador (·, •, ;, |), y dentro de ese pedazo por coma
// o «y», para no perder «Pizzas, pastas» por un «vinos y cervezas» al lado. «Bebidas sin alcohol» no cuenta: no nombra ninguna.
// El texto guardado no cambia (esto es solo lo que lee la IA). La web la lee Bubble: ahí no llega.
// Parte un pedazo por coma o «y», pero no adentro de un paréntesis: «Mojito $14 (ron, hierbabuena y limón)» es UN producto.
function partesDeLista(trozo) {
  const out = []; let hondo = 0; let actual = "";
  const s = String(trozo);
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (ch === "(") hondo += 1;
    if (ch === ")") hondo = Math.max(0, hondo - 1);
    const corteY = hondo === 0 && /^\s+(y|and)\s+/i.exec(s.slice(i));
    if (hondo === 0 && (ch === "," || corteY)) {
      out.push(actual); actual = "";
      if (corteY) i += corteY[0].length - 1;
      continue;
    }
    actual += ch;
  }
  out.push(actual);
  return out.map(p => p.trim()).filter(Boolean);
}
export function sinAlcoholParaAsesor(texto) {
  const s = String(texto || "");
  if (!ALCOHOL_EN_ITEM.test(s)) return s;
  // Pedazos y separadores alternados: si un pedazo se va entero, se va con él el separador que lo seguía (o el de antes, si es
  // el último), para no dejar «· ·» ni un renglón en blanco.
  const t = s.split(/(\s*[·•;|\n]\s*)/);
  const out = [];
  for (let i = 0; i < t.length; i += 2) {
    let trozo = t[i];
    if (ALCOHOL_EN_ITEM.test(trozo)) {
      const fin = /[.]\s*$/.test(trozo) ? "." : "";
      const partes = partesDeLista(trozo.replace(/[.]\s*$/, "")).filter(p => !ALCOHOL_EN_ITEM.test(p));
      trozo = partes.length ? partes.join(", ") + fin : "";
    }
    if (!trozo.trim()) { if (i + 2 >= t.length && out.length) out.pop(); continue; }
    out.push(trozo);
    if (i + 1 < t.length) out.push(t[i + 1]);
  }
  return out.join("").trim();
}
export function productosConPrecio(fuente) {
  const out = [];
  for (const m of String(fuente || "").matchAll(PAR_PRODUCTO)) {
    const item = m[1].replace(/\s+(a|en|por|at|for)$/i, "").trim();
    const precio = Number(String(m[2] || m[3]).replace(",", "."));
    // Lo que sigue al precio cuenta para el alcohol («$12 (incluye cerveza)») hasta el próximo separador: s247, la «Copa de vino»
    // del ítem de al lado tachaba el «Arroz con pollo — 19.00 · …».
    const resto = String(fuente).slice(m.index + m[0].length, m.index + m[0].length + 60);
    const cerca = m[0] + resto.split(/[·•;|\n]/)[0];
    if (!item || item.length < 3 || NO_ES_PRODUCTO.test(item) || ALCOHOL_EN_ITEM.test(cerca)) continue;
    if (m[3] && /\d[.,]\d{2}$/.test(item)) continue;   // s247 · «20.00 — 35.00» es un rango sin signo, no un producto
    if (!(precio > 0)) continue;
    out.push({ item, precio });
  }
  return out;
}
export function elegirBogo(fuente, { categoria, porPersona } = {}) {
  const tope = (TOPE_BOGO[categoria] || 0.6) * (Number(porPersona) || 0);
  const ok = productosConPrecio(fuente).filter(p => p.precio >= BOGO_MINIMO_USD && p.precio <= tope);
  return ok.reduce((mejor, p) => (!mejor || p.precio > mejor.precio ? p : mejor), null);
}
const fmtPrecioBogo = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(2));
export function conBogoDeLaFuente(tamanos, fuente) {
  const t3 = tamanos && tamanos.tarjetas && tamanos.tarjetas[2];
  if (!t3 || !t3.bogoOpcional) return tamanos;
  const p = elegirBogo(fuente, tamanos);
  if (!p) return tamanos;
  const en = tamanos.lang === "en";
  const frase = en ? `2-for-1 on ${p.item} ($${fmtPrecioBogo(p.precio)})` : `2x1 en ${p.item} ($${fmtPrecioBogo(p.precio)})`;
  const bogo = { offer_type: "bogo", benefit_value_usd: p.precio, min_consumption: 0, discount_pct: 0, item: p.item, bogoFijo: true,
    texto: `bogo: ${frase}` };
  const tarjetas = tamanos.tarjetas.map((t, k) => (k === 2 ? bogo : t));
  return { ...tamanos, tarjetas, linea: "TAMAÑOS: " + tarjetas.map((t, k) => `tarjeta_${k + 1} = ${t.texto}`).join(" · ") };
}

// s253 · asesor-bogo-solo-de-la-fuente (decisión de Ali, pase Cowork s253). La IA nunca decide el precio de un 2x1: en
// version-test, con la web de La Esquina sin precios, armó «Arroz con pollo ($14)», «Pernil ($15.99)» y «Arroz con pollo» a $0
// (claude/RESULTADO_s253_ingest_v2_3a/b, v2_4a/b), y cuatro versiones del prompt no lo cortaron. Un 2x1 de la IA vale solo si
// su ítem y su precio (> 0, ±$0.01) están juntos en la fuente; si no, la tarjeta es el umbral de TAMAÑOS. En ingest la web la
// lee Bubble y React no la ve, así que ahí la fuente es solo el texto del negocio y lo que escribió el dueño: un 2x1 que salió
// de la web pasa a umbral (Ali lo aceptó: si quiere el 2x1, lo elige él y escribe el precio en el formulario).
export function bogoDeLaFuente(o, fuente) {
  const item = sinMarcas(((o && o._adv) || {}).item);
  const precio = NUM(o && o.benefit_value_usd);
  if (!item || !(precio > 0)) return false;
  return productosConPrecio(fuente).some(p => sinMarcas(p.item).includes(item) && Math.abs(p.precio - precio) <= 0.01);
}

export function aplicarTamanos(offers = [], tamanos, lang = "es", fuente = "") {
  const ts = (tamanos && tamanos.tarjetas) || [];
  let n = 0;
  offers.forEach((o, i) => {
    const t = ts[i];
    if (!o || !t) return;
    if (t.bogoOpcional && o.offer_type === "bogo") {
      if (bogoDeLaFuente(o, fuente)) return;
      if (o._adv) { o._adv.bogo_sin_fuente = true; o._adv.item = ""; }   // y sigue: abajo pasa al umbral de la tarjeta
    }
    if (t.offer_type === "bogo") {   // s245 · el 2x1 que eligió React
      const adv = o._adv || {};
      if (o.offer_type === "bogo" && NUM(o.benefit_value_usd) === t.benefit_value_usd && sinMarcas(adv.item) === sinMarcas(t.item)) return;
      o.offer_type = "bogo";
      o.benefit_value_usd = t.benefit_value_usd;
      o.unit_price = t.benefit_value_usd;   // como advisorOfferToForm con un 2x1 de v4 (unit = benefit = el precio del ítem)
      o.min_consumption = 0;
      o.discount_pct = 0;
      o.regular_price = 0;
      o.coupon_price = 0;
      o.typical_savings = 0;
      o.title = tituloConTamano(o.title, t, lang === "en");
      if (o._adv) { o._adv.offer_type = "bogo"; o._adv.item = t.item; o._adv.discount_pct = 0; o._adv.numeros_corregidos = true; }
      n += 1;
      return;
    }
    const igual = o.offer_type === t.offer_type && NUM(o.benefit_value_usd) === t.benefit_value_usd
      && NUM(o.min_consumption) === t.min_consumption && NUM(o.discount_pct) === t.discount_pct;
    if (igual) return;
    o.offer_type = t.offer_type;
    o.benefit_value_usd = t.benefit_value_usd;
    o.min_consumption = t.min_consumption;
    o.discount_pct = t.discount_pct;
    o.regular_price = t.offer_type === "umbral" ? t.min_consumption : 0;   // approve_offer: el umbral lleva el mínimo
    o.unit_price = 0;
    o.coupon_price = 0;
    o.typical_savings = 0;
    o.title = tituloConTamano(o.title, t, lang === "en");
    if (o._adv) { o._adv.offer_type = t.offer_type; o._adv.discount_pct = t.discount_pct; o._adv.numeros_corregidos = true; }
    n += 1;
  });
  try { if (n) console.info("[asesor] números corregidos por TAMAÑOS: %d", n); } catch (_) { /* la sonda no rompe nada */ }
  return n;
}

// s246 · why-cifras-sin-control (prueba en Live del salón, pase s246 §2: «~5 citas más por semana → ~$875/mes» con un 2x1 de
// $35, y la fórmula da $700). La proyección del why la cuenta React: lo que le QUEDA al comercio después del beneficio × N × 4
// (decisión de Ali, pase Cowork s246 §3, 19:21 UTC): umbral «$X si gastas $2X» → X · percent → el ticket menos el descuento
// (con su tope, si tiene) · bogo → el precio + el mínimo, que ya es lo que cobra. La frase dice «podría dejarte ~$X/mes
// después del beneficio» (en: «could bring in ~$X/month after the benefit»). La N y el resto del texto son de la IA. Sin la
// frase completa (N por semana y $X al mes en la misma oración), o sin ticket en un percent, no se toca. El prompt (v4.1.2)
// sigue pidiendo el bruto: se alinea después, con corrida (`prompt-why-neto`). Va después de aplicarTamanos.
// «~» o la palabra que la IA usa en su lugar: en inglés escribe «about 8 more tables» y «could add about/roughly $1,280/month»
// (llamada en test, 28/10 20:08 UTC: 0 de 8 tarjetas en inglés se reconocían con «~» solo).
const PROY_N = /(?:~\s?|(?:about|roughly|around|approximately)\s+)(\d{1,3})\s+[^.~$\d]{1,40}?(?:por semana|a la semana|a week|per week|each week)/i;
const PROY_X = /((?:~\s?|(?:about|roughly|around|approximately)\s+)\$\s?)(\d{1,3}(?:[ ,.  ]\d{3})+|\d+)(?=\s?(?:\/\s?mes|al mes|por mes|\/\s?month|a month|per month|\/\s?mo\b))/i;
// El monto con su «al mes», para poner la coletilla detrás (una sola vez).
const PROY_X_MES = /((?:~\s?|(?:about|roughly|around|approximately)\s+)\$\s?(?:\d{1,3}(?:[ ,.  ]\d{3})+|\d+)\s?(?:\/\s?mes|al mes|por mes|\/\s?month|a month|per month|\/\s?mo\b))/i;
const PROY_VERBO = { es: [/podr[ií]a sumar/i, "podría dejarte"], en: [/could (?:add|bring in|mean)/i, "could bring in"] };
const PROY_COLETILLA = { es: " después del beneficio", en: " after the benefit" };
function netoDelComercio(o, porPersona) {
  if (o.offer_type === "umbral") return NUM(o.min_consumption) - NUM(o.benefit_value_usd);
  if (o.offer_type === "percent") {
    const ticket = NUM(porPersona);
    const tope = NUM(o.benefit_value_usd) || Infinity;   // 1000 = sin tope (TOPE_SIN_LIMITE)
    return ticket - Math.min(ticket * NUM(o.discount_pct) / 100, tope);
  }
  if (o.offer_type === "bogo") return (NUM(o.benefit_value_usd) || NUM(o.unit_price)) + NUM(o.min_consumption);
  return 0;
}
const montoConMiles = (x, en) => String(Math.round(x)).replace(/\B(?=(\d{3})+(?!\d))/g, en ? "," : " ");
export function corregirProyecciones(offers = [], tamanos, lang = "es") {
  const en = lang === "en";
  const [verbo, verboNuevo] = PROY_VERBO[en ? "en" : "es"];
  const coletilla = PROY_COLETILLA[en ? "en" : "es"];
  const porPersona = tamanos && tamanos.porPersona;
  let n = 0;
  offers.forEach((o) => {
    if (!o || !o._adv || typeof o._adv.why_it_works !== "string") return;
    const neto = netoDelComercio(o, porPersona);
    if (!(neto > 0)) return;
    const frases = o._adv.why_it_works.split(/(?<=[.!?])(\s+)/);
    let toco = false;
    for (let k = 0; k < frases.length; k += 2) {
      const mN = PROY_N.exec(frases[k]); const mX = PROY_X.exec(frases[k]);
      if (!mN || !mX) continue;
      let f = frases[k].replace(PROY_X, `$1${montoConMiles(neto * Number(mN[1]) * 4, en)}`).replace(verbo, verboNuevo);
      if (!f.toLowerCase().includes(coletilla.trim())) f = f.replace(PROY_X_MES, `$1${coletilla}`);
      if (f !== frases[k]) { frases[k] = f; toco = true; }
    }
    if (toco) { o._adv.why_it_works = frases.join(""); o._adv.proyeccion_corregida = true; n += 1; }
  });
  try { if (n) console.info("[asesor] proyecciones netas: %d", n); } catch (_) { /* la sonda no rompe nada */ }
  return n;
}

// s247 · `why-margen-residual` (pase s247 §5.1 y §7.2: «deja margen» volvió en el why de la t3 del restaurante, 2 de 2 corridas en
// español). El why no habla del margen del comercio: de la oración que lo nombra se quita el pedazo coordinado («… y deja margen al
// negocio») o el inciso entero; si lo que queda es una cáscara («rinde bien», menos de 3 palabras), se va también. Solo el why.
const MARGEN = /(?<![\p{L}])(?:m[aá]rgen(?:es)?|margins?)(?![\p{L}])/iu;
const incisoSinMargen = (inc) => {
  if (!MARGEN.test(inc)) return inc;
  const quedan = inc.split(/\s+(?:y|e|and)\s+/i).filter(p => !MARGEN.test(p));
  const r = quedan.join(/(?<![\p{L}])(?:and)(?![\p{L}])/i.test(inc) ? " and " : " y ").trim();
  return r.split(/\s+/).filter(Boolean).length < 3 ? "" : r;
};
export function sinMargenEnTexto(texto) {
  return quitarPorIncisos(texto, (s) => MARGEN.test(s), incisoSinMargen);
}
// Las cuatro tarjetas. Devuelve cuántas tocó; cada una queda con `_adv.margen_corregido`.
export function corregirMargenEnWhy(offers = []) {
  let n = 0;
  offers.forEach((o) => {
    if (!o || !o._adv || typeof o._adv.why_it_works !== "string") return;
    const nuevo = sinMargenEnTexto(o._adv.why_it_works);
    if (nuevo === o._adv.why_it_works) return;
    o._adv.why_it_works = nuevo; o._adv.margen_corregido = true; n += 1;
  });
  return n;
}

// s244 · generar-con-ia-lee-texto-negocio + advisor-contexto-horario. Lo que el dueño ya dejó en su perfil y el asesor no veía:
// sin fuente, 20/20 tarjetas inventaron; con el texto del negocio pegado, 0/4 (banco s244 §2). s241-D7: el texto del negocio vale
// como la web. Cada bloque va SOLO si existe. Lo usan los dos carriles (offer_advisor e ingest_offer_ideas).
function bloquesDelPerfil(perfil) {
  const p = perfil || {};
  const texto = sinAlcoholParaAsesor(textoDelNegocio(p.texto_negocio));   // s245 · sin las bebidas con alcohol
  const horario = horarioParaAsesor(p.business_hours_json);
  return [texto && `TEXTO DEL NEGOCIO: ${texto}`, horario && `HORARIO: ${horario}`].filter(Boolean);
}
// El perfil sale del que la pantalla ya tiene cargado; si no lo pasa, se pide UNA vez. Si falla (no es Merchant, red), el
// contexto sale como antes: sin perfil no se bloquea al asesor.
async function perfilParaAsesor(perfil) {
  if (perfil !== undefined) return perfil || {};
  try { return (await getMerchantProfile()) || {}; } catch (_) { return {}; }
}

// Arma el prompt rico que se manda como user_context (el WF solo lo escapa con JSON-safe).
// Trae el bloque de margen del rubro desde MarginProfile (Data API) y lo antepone al input del merchant.
// s244: después del margen van el texto del negocio y el horario del perfil (bloquesDelPerfil).
export async function buildAdvisorContext(business_type, user_context, lang, perfil, tamanos) {
  const rubro = ADVISOR_RUBRO_MAP[business_type] != null ? ADVISOR_RUBRO_MAP[business_type] : business_type;
  let block = "";
  if (rubro) {
    try {
      // s103: lookup vía WF read-only `get_margin_note` (gateado a Merchant, deployado s101/s102).
      // Se usa SOLO el notes del rubro (s244-D7: los números del margen ya no viajan); MarginProfile sigue Admin-only.
      // No-merchant (p.ej. admin probando el wizard) → success "no" → throw → catch → block vacío.
      const mp = await apiPostGuarded("/wf/get_margin_note", { business_type: rubro }, auth.getToken());
      block = mp?.notes || "";
    } catch (_) { /* sin bloque: el system prompt igual razona el margen */ }
  }
  // s186 · SONDA. El fallo de esta cadena es SILENCIOSO por diseño: sin fila de MarginProfile
  // el bloque sale vacío, el asesor razona a ciegas y en pantalla no se nota nada. La recon de
  // s185 tardó una sesión en encontrarlo. Se loguea el rubro con el que se buscó y si vino
  // bloque — dos datos que no son del comercio, y que convierten el smoke en algo medible.
  try {
    if (!block) console.warn("[asesor] SIN bloque de margen · rubro buscado: %s", rubro || "(vacío)");
    else console.info("[asesor] margen ok · rubro: %s", rubro);
  } catch (_) { /* una sonda jamás puede romper el flujo */ }
  return [
    `RUBRO: ${rubro || business_type}`,
    block,
    ...bloquesDelPerfil(await perfilParaAsesor(perfil)),
    (tamanos && tamanos.linea) || "",
    `INFO DEL COMERCIO: ${sinAlcoholParaAsesor(user_context)}`,   // s245 · sin las bebidas con alcohol
    `IDIOMA DE SALIDA: ${lang}`,
  ].filter(Boolean).join("\n");
}

// CARRIL RÁPIDO (DESBLOQUEADO): wizard de 3-4 preguntas → offer_advisor → 3-4 tarjetas.
// user_context = texto libre armado por el front con las respuestas del merchant.
// s244 · bogo-sin-fuente (banco del dueño, corridas 1–3: en La Viña sin web ni texto el 2x1 salió 4/4 sobre un ítem inventado,
// «Café de la casa»). El prompt no lo corrige, así que lo mira React: un 2x1 vale solo si su `item` aparece en las fuentes del
// negocio que el asesor recibió — el texto del negocio y lo que escribió el dueño (INFO DEL COMERCIO). Las notas del rubro NO son
// fuente. Comparación sin mayúsculas, sin tildes y con espacios normalizados. Solo marca (`_adv.item_sin_fuente`): no borra ni
// cambia la oferta. Solo en el carril offer_advisor: en ingest el SITIO lo lee Bubble y React no lo ve.
const sinMarcas = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim();
export function itemEnFuente(item, fuente) {
  const i = sinMarcas(item);
  return !!i && sinMarcas(fuente).includes(i);
}
export function marcarItemsSinFuente(offers = [], fuente = "") {
  let n = 0;
  offers.forEach((o) => {
    const adv = (o && o._adv) || {};
    if (adv.offer_type !== "bogo") return;
    if (itemEnFuente(adv.item, fuente)) return;
    adv.item_sin_fuente = true;
    n += 1;
  });
  return n;
}

export async function getOfferAdvice({ business_type, user_context, lang = "es", perfil, tamanos: tamanosDados }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  // El perfil se resuelve UNA vez: lo usan el contexto y el control del 2x1 (las fuentes son su texto + lo que escribió el dueño).
  const p = await perfilParaAsesor(perfil);
  const fuente = [textoDelNegocio(p.texto_negocio), user_context || ""].filter(Boolean).join("\n");
  const tamanos = conBogoDeLaFuente(tamanosDados, fuente);   // s245 · el 2x1 de la tarjeta 3, elegido de la fuente
  // El WF ya NO compone el prompt (solo escapa con JSON-safe) → lo arma el front con el margen del rubro.
  const composed = await buildAdvisorContext(business_type || "", user_context || "", lang, p, tamanos);
  // s241 · el mismo corte que ingestOfferIdeas (pase s241 §3, Cowork): sin él, con la IA lenta, la conexión moría a los
  // ~60 s sin bytes y Chrome reenviaba el POST → Bubble cobraba dos generaciones y al front no le llegaba ninguna (#1124).
  const corte = new AbortController();
  const reloj = setTimeout(() => corte.abort(), INGEST_CORTE_MS);
  try {
    const resp = await apiPostGuarded(
      "/wf/offer_advisor",
      { business_type: business_type || "", user_context: composed, lang },
      userToken,
      corte.signal
    );
    const r = shapeAdvisorResponse(resp, lang);
    r.numeros_corregidos = r.tarjetas ? aplicarTamanos(r.offers, tamanos, lang, fuente) : 0;   // s244-D7: antes del control del 2x1 (que mira el bogo final)
    r.franjas_corregidas = r.tarjetas ? ajustarFranjas(r.offers, p.business_hours_json, lang) : 0;   // s245: después de TAMAÑOS (rehace el título)
    r.promesas_corregidas = r.tarjetas ? corregirPromesas(r.offers, lang) : 0;   // s246: sin «próxima visita» ni «sin cupón»
    r.proyecciones_corregidas = r.tarjetas ? corregirProyecciones(r.offers, tamanos, lang) : 0;   // s246: con los números finales
    r.margenes_corregidos = r.tarjetas ? corregirMargenEnWhy(r.offers) : 0;   // s247: el why no nombra el margen
    r.items_sin_fuente = marcarItemsSinFuente(r.offers, fuente);
    return r;
  } catch (e) {
    if (e && e.name === "AbortError") {
      const err = new Error("El asesor sigue pensando del lado del servidor");
      err.code = "ADVISOR_TIMEOUT";
      throw err;
    }
    throw e;
  } finally {
    clearTimeout(reloj);
  }
}

// ---- s189-G · LA URL DEL SITIO SE GUARDA LIMPIA ------------------------------
// Medido en pantalla el 05/09: el alta mostró
// `https://www.restaurantdepot.com/?utm_source=listings…`. O sea que el `websiteUri` que
// devuelve Places YA TRAE parámetros de campaña, y `MerchantPartner.website` se venía
// guardando con la UTM adentro sin que nadie pegara nada — no era solo un riesgo de
// copiar/pegar del comercio, era el camino automático.
// Por qué importa: `website` es la clave de la que cuelga el guard de idempotencia del
// ingest (`ingested_url is url`, s186-D1) y la que dice si dos altas son del mismo sitio.
// Dos altas del mismo negocio con `gclid` distinto se ven como dos sitios distintos: el
// guard no matchea y se vuelve a pagar Firecrawl + Claude (lección #644).
// Qué saca: SOLO parámetros de campaña conocidos. No toca el host, ni el path, ni la
// barra final, ni el esquema, ni ningún otro query param — un `?mesa=2` es del sitio, no
// del anuncio, y borrarlo sería inventar otra URL.
// Dónde vive: ACÁ, no en las pantallas. Mismo criterio que el trim del ingest — si cada
// pantalla normalizara por su cuenta, la consistencia sería una convención y no un hecho.
// Cómo lo hace: cirugía sobre el query string, y NO `new URL()`. URL() normaliza de más
// —le agrega la barra al path vacío, baja el host a minúsculas, punycodea el dominio— y
// eso reescribe URLs que estaban bien. Acá, si no hay ningún parámetro de campaña, sale
// EL MISMO string que entró: el comercio que tipeó `tunegocio.com` sin esquema lo recupera
// tal cual, y un texto que no es una URL tampoco se rompe.
// s239 · + `igsh`/`vrfl` (compartir de Instagram) y `dd_referrer` (Yelp): los trajeron los links reales que pegó Ali.
const TRACKING_PARAM_RE = /^(utm_[a-z_]*|gclid|gclsrc|dclid|gbraid|wbraid|gad_source|gad_campaignid|fbclid|msclkid|ttclid|twclid|yclid|igshid|igsh|vrfl|dd_referrer|mc_cid|mc_eid|_gl|srsltid)$/i;
export function normalizeWebsiteUrl(raw) {
  const txt = String(raw == null ? "" : raw).trim();
  if (!txt) return "";
  const q = txt.indexOf("?");
  if (q === -1) return txt;                       // sin query string: no hay nada que sacar
  // El `?` antes del `#` es query; después del `#` es parte del fragmento (rutas con
  // hash de una SPA) y ahí no se toca nada.
  const hash = txt.indexOf("#");
  if (hash !== -1 && hash < q) return txt;
  const base = txt.slice(0, q);
  const resto = txt.slice(q + 1);
  const corte = resto.indexOf("#");
  const query = corte === -1 ? resto : resto.slice(0, corte);
  const frag = corte === -1 ? "" : resto.slice(corte);   // incluye el `#`
  const pares = query.split("&").filter(Boolean);
  if (!pares.length) return txt;
  const quedan = pares.filter(par => {
    const k = par.split("=")[0];
    let nombre = k;
    try { nombre = decodeURIComponent(k.replace(/\+/g, " ")); } catch (e) { /* %  suelto: se usa crudo */ }
    return !TRACKING_PARAM_RE.test(nombre);
  });
  if (quedan.length === pares.length) return txt; // no se sacó ninguno → se devuelve TAL CUAL
  return base + (quedan.length ? `?${quedan.join("&")}` : "") + frag;
}

// CARRIL URL/MENÚ (BLOQUEADO por Firecrawl/D10): si el WF no existe o falla, lanza
// un error con code="INGEST_UNAVAILABLE" para que la UI caiga al carril de preguntas.
//
// s186 · SE FUE EL PARÁMETRO `doc`, y con él el único camino muerto que tenía esta función.
// Este WF declara CUATRO params en el export 75 —`url` (REQUIRED), `business_type`,
// `user_context`, `lang`— y `doc` no era uno: el front serializaba el PDF del menú a data
// URL y lo mandaba para que Bubble lo descartara en silencio (mismo caso que `place_id` en
// s172, documentado más abajo). Un parámetro que el otro lado no declara no falla: se
// evapora, que es peor.
// El menú ahora NO pasa por acá: se lee en el navegador (`leerPdf.js`) y su texto viaja
// como `user_context` por `offer_advisor`, que sí lo declara y lo usa. Ver `ingest-doc-param-ausente`.
// s239 · W7/W16: `user_context` opcional (el WF lo declara desde siempre; nadie lo mandaba). Sin él, igual que antes.
export const INGEST_CORTE_MS = 50000;
// s240 · `solo_leer` (export 153, `SPEC_s240_ingest_offer_ideas_v2`): Firecrawl + guardar `ingested_*` y volver, sin IA
// ni cupo (5–11 s). Devuelve la respuesta tal cual — `{ success, code, chars }`, `code` "" o "CACHED" — y no propuestas.
export async function ingestOfferIdeas({ business_type, url, lang = "es", user_context = "", solo_leer = false, perfil, tamanos: tamanosDados }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  // asesor-category-align (s73): el carril ingest hace el lookup del MarginProfile
  // SERVER-SIDE (business_type = business_type) → hay que mandar el RUBRO ya mapeado,
  // no la categoría cruda del option set (Restaurant ≠ Restaurante). Espeja el mapeo
  // que el carril wizard hace en buildAdvisorContext (ADVISOR_RUBRO_MAP).
  const rubro = ADVISOR_RUBRO_MAP[business_type] != null ? ADVISOR_RUBRO_MAP[business_type] : business_type;
  // s186 · LA URL SE NORMALIZA ACÁ Y EN NINGÚN OTRO LADO. El guard de idempotencia
  // (s186-D1) compara `ingested_url is url` contra la url CRUDA del parámetro: si dos
  // llamadas mandan la misma dirección escrita distinto, el guard no matchea y se
  // vuelve a pagar Firecrawl + Claude. Los tres llamadores mandan cosas de origen
  // distinto —Places en el alta, el perfil guardado en el aterrizaje, y un campo que
  // el comercio TIPEA en el alta de oferta—, y ese último puede traer espacios
  // pegados de un copiar/pegar. Recortar en la función que hace la llamada es lo
  // único que garantiza que los tres manden el mismo texto: si cada pantalla
  // normalizara por su cuenta, la consistencia sería una convención, no un hecho.
  // s189-G: al trim se le suma sacar los parámetros de campaña. Misma razón que el trim
  // —que las tres pantallas manden EXACTAMENTE el mismo texto— llevada al caso que medimos:
  // la URL de Places ya viene con `utm_source` adentro, así que sin esto el guard de
  // idempotencia comparaba dos strings que nunca iban a ser iguales.
  const urlLimpia = normalizeWebsiteUrl(url);
  // s244 · el mismo texto del negocio y horario que el carril offer_advisor (bloquesDelPerfil), delante de lo que mande la
  // pantalla. El step de Bubble lo pega como INPUT. `solo_leer` no llama a la IA: ahí no va nada ni se pide el perfil.
  // Con el perfil dado no hay `await`: el POST sale en el mismo tick que antes y el corte de 50 s mide solo la lectura.
  const p = (solo_leer || perfil !== undefined) ? (perfil || {}) : await perfilParaAsesor(perfil);
  // s245 · el 2x1 de la tarjeta 3 sale del texto del negocio y de lo que escribió el dueño; la web la lee Bubble (React no la ve).
  const fuente = solo_leer ? "" : [textoDelNegocio(p.texto_negocio), user_context].filter(Boolean).join("\n");
  const tamanos = solo_leer ? tamanosDados : conBogoDeLaFuente(tamanosDados, fuente);
  // s244-D7 · la línea TAMAÑOS también en ingest (el step bTIPi la pega como INPUT).
  const contexto = solo_leer ? user_context
    : [...bloquesDelPerfil(p), (tamanos && tamanos.linea) || "", sinAlcoholParaAsesor(user_context)].filter(Boolean).join("\n");   // s245 · sin alcohol
  // s240 · EL CORTE A 50 s. Medido en version-test (pase s240 §4): con la config de hoy (Sonnet, 12 propuestas)
  // ninguna lectura que llega a la IA baja de 65 s, y algo entre el navegador y Bubble cierra la conexión a los
  // ~60 s sin bytes. Chrome reenvía solo ese POST → Bubble corre el WF DOS veces (2 Firecrawl + 2 Anthropic) y al
  // front no le llega ninguna. Cortando nosotros antes, no hay reenvío: Bubble ya recibió el pedido y lo termina
  // igual (guarda `ingested_text` y `last_advisor_json` para Admin/Otto). Al front le llega INGEST_TIMEOUT.
  const corte = new AbortController();
  const reloj = setTimeout(() => corte.abort(), INGEST_CORTE_MS);
  try {
    const resp = await apiPostGuarded(
      "/wf/ingest_offer_ideas",
      { business_type: rubro || "", url: urlLimpia, lang, ...(contexto ? { user_context: contexto } : {}), ...(solo_leer ? { solo_leer: true } : {}) },
      userToken,
      corte.signal
    );
    if (solo_leer) return resp || {};
    const r = shapeAdvisorResponse(resp, lang);
    r.numeros_corregidos = r.tarjetas ? aplicarTamanos(r.offers, tamanos, lang, fuente) : 0;   // s253: el 2x1 de la IA, contra la fuente
    r.franjas_corregidas = r.tarjetas ? ajustarFranjas(r.offers, p.business_hours_json, lang) : 0;
    r.promesas_corregidas = r.tarjetas ? corregirPromesas(r.offers, lang) : 0;
    r.proyecciones_corregidas = r.tarjetas ? corregirProyecciones(r.offers, tamanos, lang) : 0;
    r.margenes_corregidos = r.tarjetas ? corregirMargenEnWhy(r.offers) : 0;
    return r;
  } catch (e) {
    if (e && e.name === "AbortError") {
      const err = new Error("La lectura sigue en curso del lado del servidor");
      err.code = "INGEST_TIMEOUT";
      throw err;
    }
    // 404 (WF no existe todavía) o fallo del scrape → fallback al wizard.
    // s176 FIX 1: apiPostGuarded ya deja el error_code real del WF en e.code
    // (GENERATION_LIMIT, QUOTA_EXCEEDED, NOT_MERCHANT...). Aplastarlo todo a
    // INGEST_UNAVAILABLE hacía que un cupo agotado se mostrara como "no podemos leer
    // tu sitio" — el comercio reintentaba con el cupo ya gastado. Solo se rebautiza
    // el caso sin código (WF ausente / error de red).
    const err = new Error(e.message || "Ingest no disponible");
    err.code = e.code || "INGEST_UNAVAILABLE";
    throw err;
  } finally {
    clearTimeout(reloj);
  }
}

// s240 · `wizard-web-al-perfil-sin-pisar`. El link que el dueño da en el wizard («¿Dónde te encontramos en internet?»)
// va a su Perfil solo si ese campo está vacío. `update_merchant_profile` pisa TODOS sus campos, así que se lee el perfil
// y se reenvía entero (lo mismo que hace «Guardar» en Editar Perfil): `get_merchant_profile` devuelve los 25 campos que el
// WF escribe y Bubble omite los vacíos. Instagram va a `instagram`; cualquier otro link, a `website`.
export const campoDeLaWeb = (url) => (/(^|\/\/|\.)instagram\.com\b/i.test(String(url || "")) ? "instagram" : "website");
export async function guardarWebSiFalta(url) {
  const limpia = normalizeWebsiteUrl(url);
  if (!limpia) return false;
  const p = await getMerchantProfile();
  if (!p) return false;
  const campo = campoDeLaWeb(limpia);
  if (String(p[campo] || "").trim()) return false;   // lo suyo manda
  await updateMerchantProfile({ ...p, [campo]: limpia });
  return true;
}

// s241 · T1/T4 (export 157) · lo que el dueño dice en el alta cuando no da web: «No tengo web» y/o el texto de su negocio (menú,
// servicios, lo de su Instagram). Mismo patrón que guardarWebSiFalta: se lee el perfil y se reenvía entero. Va ANTES de
// generate_merchant_description, que lee `texto_negocio` del comercio (Cowork, pase s241). Devuelve si escribió algo.
export async function guardarTextoNegocio({ sin_web, texto_negocio } = {}) {
  const texto = textoDelNegocio(texto_negocio);
  if (!texto && sin_web !== true) return false;
  const p = await getMerchantProfile();
  if (!p) return false;
  await updateMerchantProfile({ ...p, ...(sin_web === true && !String(p.website || "").trim() ? { sin_web: true } : {}), ...(texto ? { texto_negocio: texto } : {}) });
  return true;
}

// ---- BORRADOR DE PROPUESTAS DEL ASESOR (s169 · s159-D3 + fix ratificado s132) ----
// Escribe MerchantPartner.last_advisor_json con el sobre que arma el front (generación
// + cuáles marcó el comercio). Ownership del lado de Bubble: el WF busca la fila por
// owner_user = Current User, igual que offer_advisor — el front no manda merchant_id.
//
// ⚠️ NUNCA LANZA. Mientras el WF `save_advisor_draft` no exista en Bubble, el POST
// devuelve 404 y esto responde { ok:false, reason:"WF_MISSING" } en silencio: el
// comercio no puede ver un error por una pieza de backend que todavía no se construyó.
// El día que el WF exista, empieza a persistir sin tocar React.
export async function saveAdvisorDraft(advisor_draft_json) {
  const userToken = auth.getToken();
  if (!userToken) return { ok: false, reason: "NO_TOKEN" };
  try {
    await apiPostGuarded(
      "/wf/save_advisor_draft",
      { advisor_draft_json: advisor_draft_json || "" },
      userToken
    );
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: e.code || "SAVE_FAILED" };
  }
}

// ============================================
// USER PROFILE
// ============================================

export async function getUserProfile() {
  const userToken = auth.getToken();
  if (!userToken) return null;
  const data = await apiPost("/wf/get_user_profile", {}, userToken);
  return data?.response || null;
}

// End-user editable fields on the AccountPage. WF persists via Make changes
// to Current User. Probed in F-09 retest: success returns { success: true }.
export async function updateUserProfile({ name, beneficiary2_name, preferred_language, phone }) {
  // ONB-1: phone se guarda en User.phone (dia 1, sin verificar). El WF update_user_profile
  // debe aceptar el param `phone` (Make changes to Current User's phone).
  return apiPostGuarded("/wf/update_user_profile", {
    name, beneficiary2_name, preferred_language, phone,
  });
}

// ETAPA-0 (s97): la PUERTA post-login — canjea un código de invitación para el
// usuario YA logueado (influencer / regalo / LITE de prueba / VIP). Contrato del
// Return (memoria apply-access-code-return-contract): `success` ("yes"/"no") +
// `error` (key ÚNICA con el código: CODE_ALREADY_APPLIED | INVALID_CODE |
// CODE_MISCONFIGURED | CODE_FULL | CODE_EXPIRED) — NO error_code/error_message.
// Éxito devuelve { tier, vip_expires_at }. Sincroniza nxt_tier en localStorage
// (mismo criterio que loginUser/socialLogin).
//
// s186 · CONTRATO EN CONSTRUCCIÓN (bloque D de `SPEC_s185_flujo_enganche.md`): el
// Return final tiene que sumar `enganche_code` y `enganche_plan_id` para que el
// front pueda armar el checkout del canal influencer sin pedirle un segundo código
// a la persona. En el export 75 —que es la rama Main, no solo producción— el Step
// del Return devuelve exactamente tres cosas: success, tier y vip_expires_at. La
// respuesta se devuelve entera (`return resp`), así que el día que los campos
// existan llegan solos: no hay que tocar esta función.
export async function applyAccessCode(access_code) {
  const userToken = auth.getToken();
  const idem = (window.crypto?.randomUUID && window.crypto.randomUUID())
    || `aac-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const data = await apiPost("/wf/apply_access_code", { access_code, idempotency_key: idem }, userToken);
  const resp = data?.response || {};
  const ok = resp.success === "yes" || resp.success === true;
  if (!ok) {
    const err = new Error(resp.error || "INVALID_CODE");
    err.code = resp.error || "INVALID_CODE";
    throw err;
  }
  const tierUpper = String(resp.tier || "").toUpperCase();
  if (tierUpper === "VIP" || tierUpper === "LITE") localStorage.setItem("nxt_tier", tierUpper);
  return resp; // { success: "yes", tier, vip_expires_at }
}

// ETAPA-1 (s98): cola de callback — el prospecto que vio el preview de beneficios
// deja su numero y la operadora lo llama. Escribe al buzon ConsumerWaitlist
// (WF create_consumer_waitlist, YA existente y expuesto: name/email/whatsapp
// REQUIRED + source opcional). Idempotente por email: si el email ya esta
// anotado, el WF devuelve success=true sin duplicar (Step 0) — para el usuario
// es indistinguible ("listo, te llamamos"), que es el comportamiento deseado.
export async function createConsumerWaitlist({ name, email, whatsapp, source }) {
  return apiPostGuarded("/wf/create_consumer_waitlist", {
    name: name || email || "",
    email,
    whatsapp,
    source: source || "app_preview",
  });
}

// Detaches a Stripe PaymentMethod (via Bubble WF that wraps Stripe detach +
// removes from User). NOTE — backend WF currently returns {success: "yes"}
// regardless of whether the pm existed; this guard cannot detect that case.
// True confirmation lives in the post-call refresh of get_payment_methods.
export async function deletePaymentMethod(payment_method_id) {
  return apiPostGuarded("/wf/delete_payment_method", { payment_method_id });
}

// ============================================
// MERCHANT PORTAL
// ============================================

export async function getMerchantProfile() {
  const userToken = auth.getToken();
  if (!userToken) return null;
  const data = await apiPost("/wf/get_merchant_profile", {}, userToken);
  return data?.response || null;
}

// s218 · v3 (export 119, SPEC_s218_get_merchant_stats_v3.md): `since` / `prev_since` opcionales (fechas ISO).
// Sin ninguno = desde siempre (las 11 claves v2 no cambian). React manda SIEMPRE los dos cuando hay período:
// prev_since vacío con since lleno = todo lo anterior a since. Claves nuevas: visits, unique_members,
// returning_members, sales_estimate_usd, sales_real_usd, sales_real_count, discount_usd, active_now, prev_visits.
export async function getMerchantStats(periodo = null) {
  const userToken = auth.getToken();
  if (!userToken) return null;
  const body = periodo && periodo.since ? { since: periodo.since, prev_since: periodo.prev_since || "" } : {};
  const data = await apiPost("/wf/get_merchant_stats", body, userToken);
  return data?.response || null;
}

// s218 · get_merchant_redemptions v2 (export 119): los canjes del comercio, del más nuevo al más viejo, paginados
// con first_item / last_item (desde 1). `redemptions_json` es TEXTO; cada fila:
// { at (ms), offer, benefit, min_spend, member (nombre de pila o ""/null), code, bill ("" si no hay), by_role
// (owner|staff), by_name }. Una fila rota no tira la pantalla: se descarta.
export async function getMerchantRedemptions(first_item = 1, last_item = 100) {
  const userToken = auth.getToken();
  if (!userToken) return { filas: [], total: 0, has_more: false };
  const data = await apiPost("/wf/get_merchant_redemptions", { first_item, last_item }, userToken);
  const r = data?.response || {};
  let filas = [];
  try { const v = JSON.parse(r.redemptions_json || "[]"); filas = Array.isArray(v) ? v : []; } catch (e) { filas = []; }
  return {
    filas: filas.filter(f => f && typeof f === "object").map(f => ({
      ...f,
      at: Number(f.at) || 0,
      benefit: Number(f.benefit) || 0,
      min_spend: Number(f.min_spend) || 0,
      bill: Number(f.bill) > 0 ? Number(f.bill) : 0,
      member: f.member || "",
      by_name: f.by_name || "",
    })),
    total: Number(r.total) || 0,
    has_more: r.has_more === true || r.has_more === "yes",
  };
}

// ---- MERCHANT PROFILE UPDATE (B4.39 / 8.14 · M2 s79 · Places s109) ----
// Backend update_merchant_profile: ownership = Current User's merchant_profile (IDOR cerrado, v22).
// ⚠️ El WF SOBRESCRIBE cada campo mapeado con el valor del param (Step 0) → mandamos TODOS los
// campos (cargados desde get_merchant_profile) para no blanquear ninguno al guardar.
// Params en Live (23, registro s108): description_es/en, phone, address, business_hours, city,
// state, zip, zone, whatsapp, delivery_available/free/min_amount, business_hours_json, category,
// google_maps_url, website, instagram, lat, lng, neighborhood, address_full, business_type.
// `business_type` y `business_name` (tanda s109) son de escritura CONDICIONAL (only-when
// not-empty): mandarlos vacíos NO blanquea. Todos los demás se pisan → el pass-through en
// MerchantProfileEdit es obligatorio. Total params: 25 (+`place_id`, s172 — requiere el param
// declarado en el WF; si Bubble no lo declara, la clave se descarta EN SILENCIO).
export async function updateMerchantProfile(p = {}) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const body = {
    description_es: p.description_es || "",
    description_en: p.description_en || "",
    phone: p.phone || "",
    address: p.address || "",
    business_hours: p.business_hours || "",
    city: p.city || "",
    state: p.state || "",
    zip: p.zip || "",
    zone: p.zone || "",
    whatsapp: p.whatsapp || "",
    // NO omitir estas dos claves ni mandarlas como null.
    // Un checkbox no tiene estado "vacio": el false es SIEMPRE deliberado.
    // Si se omiten, el :defaulting to de Bubble las repone con el valor viejo
    // y el comercio no puede apagar el delivery nunca mas.
    // El :defaulting to sobra del lado de Bubble - ticket propio (s161).
    delivery_available: p.delivery_available === true,
    delivery_free: p.delivery_free === true,
    business_hours_json: p.business_hours_json || "",
    category: p.category || "",
    google_maps_url: p.google_maps_url || "",
    // s189-G: se guarda sin parámetros de campaña. Los dos escritores de este campo
    // pasan por acá — el alta (que manda el `websiteUri` de Places, ya sucio de origen)
    // y el campo SITIO WEB de Editar Perfil (que el comercio pega de la barra).
    website: normalizeWebsiteUrl(p.website),
    instagram: p.instagram || "",
    neighborhood: p.neighborhood || "",
    address_full: p.address_full || "",
    business_type: p.business_type || "",
    business_name: p.business_name || "",
  };

  // s161 F-5: lat / lng / delivery_min_amount se agregan SOLO si hay valor de origen.
  // El WF hace `param :defaulting to <valor existente>`, y ese :defaulting to dispara
  // unicamente con vacio: mandar 0 no es "no tengo dato", es "escribi 0" -> pisaba la
  // coordenada real del alta Places. Omitir la clave es lo que significa "no cambies
  // este campo".
  //
  // OJO con delivery_min_amount: el form distingue "" (vacio) de "0" (cero deliberado)
  // - App.jsx:4592 lo inicializa en "" y App.jsx:4627 lo hidrata en "" cuando es null.
  // El `Number(...) || 0` anterior COLAPSABA los dos a 0. Aca se omite solo el vacio;
  // un "0" escrito a proposito se manda como 0 y se escribe. No reintroducir el `|| 0`.
  const vacio = (v) => v === "" || v === null || v === undefined;
  if (!vacio(p.lat) && Number.isFinite(Number(p.lat))) body.lat = Number(p.lat);
  if (!vacio(p.lng) && Number.isFinite(Number(p.lng))) body.lng = Number(p.lng);
  if (!vacio(p.delivery_min_amount) && String(p.delivery_min_amount).trim() !== ""
      && Number.isFinite(Number(p.delivery_min_amount))) {
    body.delivery_min_amount = Number(p.delivery_min_amount);
  }
  // s172: place_id con el MISMO patron de omision. Solo viaja desde el alta con Places
  // (App.jsx, 2a llamada encadenada), que es la unica pantalla que tiene el objeto det.
  // EDITAR PERFIL no conoce este campo: al no mandar la clave, el `:defaulting to` del WF
  // conserva el valor guardado y no hay forma de blanquearlo desde ahi.
  if (!vacio(p.place_id)) body.place_id = String(p.place_id);
  // s241 · T1/T4 (export 157): `sin_web` viaja solo si viene como booleano (Perfil y el reenvío de guardarWebSiFalta lo traen de
  // get_merchant_profile; el wizard lo pone). El texto del negocio, solo si hay: vacío = no tocar el guardado (como place_id).
  if (typeof p.sin_web === "boolean") body.sin_web = p.sin_web;
  else if (p.sin_web === "true" || p.sin_web === "false") body.sin_web = p.sin_web === "true";
  const textoNegocio = textoDelNegocio(p.texto_negocio);
  if (textoNegocio) body.texto_negocio = textoNegocio;

  // s226 · contacto-responsable-alta: el contacto viaja SOLO si viene `p.contacto`. Con `contact_save: true`
  // el Step bTJrh escribe los siete campos tal cual llegan (vacío = borra) y pone contact_updated_at.
  // Sin `contacto`, Perfil guarda como siempre y el contacto no se toca (smoke s226 §2.2).
  if (p.contacto) {
    const c = p.contacto;
    body.contact_save = true;
    CAMPOS_CONTACTO.forEach(k => {
      body[k] = k === "contact_decides" ? c[k] === true : String(c[k] ?? "").trim();
    });
  }

  // s230 · absorber (s229-D2): el WF ya devuelve un fallo lógico (`PLACE_ID_TAKEN`, HTTP 200 + success:false) y
  // `apiPost` lo dejaba pasar como éxito: el alta seguía al wizard con el perfil sin escribir. Guarded (L#83): el
  // fallo lógico lanza con `.code` = error_code y `.message` = error_message, como el resto de los WF del comercio.
  const data = await apiPostGuarded("/wf/update_merchant_profile", body, userToken);
  return data?.response || null;
}

// ============================================
// s226 · EL CONTACTO DEL RESPONSABLE (contacto-responsable-alta, PASE s226 §2.1)
// ============================================
// Campos privados de MerchantPartner: los ven el dueño y Admin («Owner sees own» / «Admin sees all»), nunca el
// público. Se escriben por update_merchant_profile, que en su Step 0 PISA el perfil con lo que recibe: por eso
// guardarContacto lee el perfil con get_merchant_profile, lo arma igual que Perfil (perfilParaGuardar) y lo manda
// completo con el contacto encima. Si no puede leer el perfil, no guarda: mejor no guardar que borrar.
export const CAMPOS_CONTACTO = ["contact_phone", "contact_role", "contact_decides", "decision_maker_name", "decision_maker_phone", "contact_best_time", "contact_channel"];

// El perfil como lo hidrata «Editar perfil» (MerchantProfileEdit.cargarPerfil), listo para updateMerchantProfile.
export function perfilParaGuardar(p = {}) {
  const num = (v) => (v != null && v !== "") ? v : "";
  return {
    description_es: p.description_es || "", description_en: p.description_en || "",
    phone: p.phone || "", address: p.address || "", business_hours: p.business_hours || "",
    category: p.category || "", city: p.city || "", state: p.state || "", zip: p.zip || "",
    zone: p.zone || "", whatsapp: p.whatsapp || "",
    delivery_available: p.delivery_available === true, delivery_free: p.delivery_free === true,
    delivery_min_amount: num(p.delivery_min_amount) === "" ? "" : String(p.delivery_min_amount),
    business_hours_json: p.business_hours_json || "",
    google_maps_url: p.google_maps_url || "", website: p.website || "", instagram: p.instagram || "",
    lat: num(p.lat), lng: num(p.lng),
    neighborhood: p.neighborhood || "", address_full: p.address_full || "",
    business_type: p.business_type || "", business_name: p.business_name || "",
  };
}

// Lee el contacto del comercio por la Data API. `lleno` sale de contact_updated_at: es lo único que distingue
// «no lo llenó» de «lo llenó con todo vacío» (y `contact_decides` sin llenar llega como false).
export async function leerContacto(merchant_id) {
  const m = await leerComercioCrudo(merchant_id);
  return contactoDe(m);
}
export function contactoDe(m = {}) {
  const c = {};
  CAMPOS_CONTACTO.forEach(k => { c[k] = k === "contact_decides" ? m[k] === true : String(m[k] ?? ""); });
  c.contact_updated_at = String(m.contact_updated_at || "");
  c.lleno = !!c.contact_updated_at;
  return c;
}

// Guarda el contacto del comercio del usuario (el dueño). Devuelve el contacto releído (o null si la relectura falla).
export async function guardarContacto(contacto) {
  const p = await getMerchantProfile().catch(() => null);
  if (!p) throw errorFicha("PERFIL_NO_LEIDO");
  await updateMerchantProfile({ ...perfilParaGuardar(p), contacto });
  const mid = String(p.merchant_id || "").trim();
  return mid ? leerContacto(mid).catch(() => null) : null;
}

// Admin: el nombre del responsable (User.name del dueño). null si no se puede leer.
export async function nombreDeUsuario(user_id) {
  const id = String(user_id || "").trim();
  if (!id) return null;
  try {
    const data = await apiGet(`/obj/user/${encodeURIComponent(id)}`, auth.getToken());
    return String(data?.response?.name || "").trim() || null;
  } catch (e) { return null; }
}

// ---- helper: File -> base64 SIN el prefijo data: ----
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || "");
      const comma = result.indexOf(",");
      resolve(comma >= 0 ? result.slice(comma + 1) : result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// s184 - ACHICAR ANTES DE SUBIR. Sin esto la galeria no es viable: una foto de
// celular pesa 3-8 MB, y como Bubble recibe los archivos en base64 (ver
// fileToBase64) cada una viaja un 33% mas gorda. Seis fotos serian ~50 MB de JSON
// en un solo perfil, desde el telefono de un comercio, probablemente con datos
// moviles. Redimensionadas a 1600px de lado largo y JPEG 0.82 quedan en 200-400 KB
// cada una: la misma galeria pasa a pesar ~2 MB.
//
// 1600 no es un numero magico: el mosaico de /m/:id muestra la pieza mas grande a
// 820 CSS px, que en una pantalla retina son 1640 fisicos. Por encima de eso el
// visitante descarga pixeles que no va a ver.
//
// Si algo falla -navegador viejo, archivo raro, un HEIC que el canvas no decodifica-
// devuelve el archivo ORIGINAL en vez de romper la subida. Mejor una foto pesada
// que ninguna.
const FOTO_LADO_MAX = 1600;
const FOTO_CALIDAD = 0.82;

export function achicarImagen(file, ladoMax = FOTO_LADO_MAX) {
  return new Promise((resolve) => {
    if (!file || !String(file.type || "").startsWith("image/")) return resolve(file);
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const escala = Math.min(1, ladoMax / Math.max(img.width, img.height));
      // Ya es chica: no se re-comprime. Recomprimir un JPEG que ya paso por otro
      // encoder solo agrega artefactos sin ahorrar nada que valga la pena.
      if (escala === 1) return resolve(file);
      try {
        const c = document.createElement("canvas");
        c.width = Math.round(img.width * escala);
        c.height = Math.round(img.height * escala);
        const ctx = c.getContext("2d");
        ctx.drawImage(img, 0, 0, c.width, c.height);
        c.toBlob(
          (blob) => {
            if (!blob || blob.size >= file.size) return resolve(file);   // no mejoro: original
            const nombre = String(file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
            resolve(new File([blob], nombre, { type: "image/jpeg" }));
          },
          "image/jpeg",
          FOTO_CALIDAD,
        );
      } catch (e) {
        resolve(file);
      }
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}

// ===========================================================================
// s200-D1 · EL RECORTE, Y POR QUE VIVE EN EL CLIENTE
// ---------------------------------------------------------------------------
// Bubble no expone los parametros de imgix por URL: su documentacion solo cubre
// `?ignore_imgix=true` (manual.bubble.io/help-guides/data/images). No hay, entonces,
// redimensionado del lado del servidor que podamos pedirle a una foto ya subida. Todo
// el tratamiento pasa antes de subir, en el navegador del comercio, como ya lo hace
// achicarImagen — esto agrega lo que le faltaba: el ENCUADRE.
//
// Por que encuadrar y no solo achicar: la app tiene cinco marcos (tarjeta, hero, mosaico,
// grilla del panel, vista previa) y cada foto llegaba con la proporcion que traia. De ahi
// las bandas grises y los recortes que cortan texto. Si la foto sale SIEMPRE con la misma
// proporcion, los cinco marcos reciben lo mismo y el problema no existe.
//
// El limite de 5 MB se chequea ANTES de abrir el encuadrador: el navegador no puede
// achicar un archivo que no logra decodificar, y un HEIC de 12 MB en un telefono viejo
// tumba la pestana.
export const FOTO_PESO_MAX = 5 * 1024 * 1024;

// s200-D1 · cuantas fotos entran en la galeria de un negocio. El numero tambien vive en
// Bubble (`add_merchant_photo` rechaza con GALLERY_FULL a partir de la decima): aca esta
// para que el front no deje ni empezar a subir la once, no para reemplazar ese guard.
// El front que confia en su propio tope es el front que se salta por la API.
export const GALERIA_TOPE = 10;

// s200 · EL TECHO DE PESO. 1600px a calidad 0.82 deja una foto normal en 200-400 KB, pero
// «normal» no es una garantia: una foto con mucho detalle (una parrilla llena, una vidriera
// con reflejos) se va bastante mas arriba, y esa foto viaja por el dato movil del comercio
// y despues por el de cada socio que abre el catalogo. Asi que el peso deja de ser una
// consecuencia y pasa a ser un objetivo: si el primer intento se pasa, se recodifica con
// menos calidad hasta entrar. Mejor una foto un punto menos nitida que una galeria de 4 MB.
export const FOTO_PESO_OBJETIVO = 320 * 1024;
const CALIDADES = [FOTO_CALIDAD, 0.72, 0.62];

// ¿Este navegador sabe CODIFICAR webp en un canvas? No alcanza con que sepa mostrarlo:
// Safari muestra webp desde la 14 pero recien codifica desde la 16.4, y antes de eso
// `toBlob("image/webp")` devolvia PNG EN SILENCIO — o sea, el «ahorro» habria multiplicado
// el peso por cinco sin avisar. Por eso se prueba de verdad, una sola vez.
let _sabeWebp = null;
function puedeCodificarWebp() {
  if (_sabeWebp !== null) return _sabeWebp;
  try {
    const c = document.createElement("canvas");
    c.width = 1; c.height = 1;
    _sabeWebp = c.toDataURL("image/webp").indexOf("data:image/webp") === 0;
  } catch (e) {
    _sabeWebp = false;
  }
  return _sabeWebp;
}

// El EXIF no se lee a mano: createImageBitmap con `imageOrientation: "from-image"` ya lo
// aplica. Sin eso, una foto vertical de iPhone (orientacion 6) se encuadra acostada y el
// comercio ve una vista previa que no es la que va a subir. Si el navegador no soporta el
// segundo argumento, cae a <img>, que en los navegadores de 2026 tambien honra el EXIF.
async function decodificarImagen(file) {
  try {
    if (typeof createImageBitmap === "function") {
      return await createImageBitmap(file, { imageOrientation: "from-image" });
    }
  } catch (e) { /* Safari viejo: el segundo argumento no existe. Cae al <img>. */ }
  return await new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(null); };   // HEIC que no abre
    img.src = url;
  });
}

// `area` viene del encuadrador (react-easy-crop, `croppedAreaPixels`) y esta en pixeles de
// la imagen YA girada. Por eso el recorte se hace en dos lienzos: uno con la imagen girada
// entera, y del segundo sale el recorte escalado a la salida canonica.
//
// Devuelve null si algo falla, a diferencia de achicarImagen (que devuelve el original).
// La diferencia es a proposito: subir el original sin recortar rompe la promesa del marco
// unico, que es justamente lo que este lote viene a arreglar. Mejor decirlo que colarlo.
export async function recortarImagen(file, area, opciones = {}) {
  const {
    ladoMax = FOTO_LADO_MAX,
    rotacion = 0,
    tipo = "image/jpeg",
    calidad = FOTO_CALIDAD,
  } = opciones;
  if (!file || !area || !(area.width > 0) || !(area.height > 0)) return null;
  const fuente = await decodificarImagen(file);
  if (!fuente) return null;
  try {
    const ancho = fuente.naturalWidth || fuente.width;
    const alto = fuente.naturalHeight || fuente.height;
    const giro = ((Number(rotacion) || 0) % 360 + 360) % 360;
    const acostada = giro % 180 !== 0;

    const girado = document.createElement("canvas");
    girado.width = acostada ? alto : ancho;
    girado.height = acostada ? ancho : alto;
    const g = girado.getContext("2d");
    g.translate(girado.width / 2, girado.height / 2);
    g.rotate(giro * Math.PI / 180);
    g.drawImage(fuente, -ancho / 2, -alto / 2);

    const escala = Math.min(1, ladoMax / Math.max(area.width, area.height));
    const salida = document.createElement("canvas");
    salida.width = Math.max(1, Math.round(area.width * escala));
    salida.height = Math.max(1, Math.round(area.height * escala));
    salida.getContext("2d").drawImage(
      girado, area.x, area.y, area.width, area.height,
      0, 0, salida.width, salida.height,
    );

    // El PNG se respeta tal cual: es para el logo, donde puede haber transparencia y donde
    // la calidad no es un numero que se pueda bajar. Todo lo demas sale webp si el navegador
    // sabe codificarlo, y si no, jpeg.
    const esPng = tipo === "image/png";
    const tipoFinal = esPng ? tipo : (puedeCodificarWebp() ? "image/webp" : "image/jpeg");

    let blob = null;
    for (const q of (esPng ? [calidad] : CALIDADES)) {
      // eslint-disable-next-line no-await-in-loop
      blob = await new Promise((r) => salida.toBlob(r, tipoFinal, q));
      if (!blob || esPng || blob.size <= FOTO_PESO_OBJETIVO) break;
    }
    if (!blob) return null;

    const ext = esPng ? "png" : (tipoFinal === "image/webp" ? "webp" : "jpg");
    const base = String(file.name || "foto").replace(/\.[^.]+$/, "");
    return new File([blob], `${base}-nxt.${ext}`, { type: tipoFinal });
  } catch (e) {
    return null;
  } finally {
    if (fuente && typeof fuente.close === "function") fuente.close();
  }
}

// s184 - GALERIA DEL COMERCIO. Las fotos DEL LOCAL, distintas del logo y de la foto
// de cada oferta. Alimentan el mosaico de /m/:id, que existe desde s183 y nunca
// pudo dibujar nada: 0 de 13 comercios tienen fotos porque NINGUN workflow escribia
// `gallery_list_image` — el camino no existia.
//
// Contrato acordado con Bubble (ver SPEC_s184_wf_galeria_comercio.md): una foto por
// llamada, no un lote en un solo request. El comercio elige varias y el front sube
// de a una. Es mas lento pero es lo correcto acá: si la cuarta falla, las tres
// primeras ya estan guardadas y se reintenta esa sola. Un lote atomico de 6 fotos
// que se cae en la ultima obliga a repetir todo desde una conexion movil.
//
// GALERIA_HABILITADA seguia el patron de OFFER_EDIT_MAINTENANCE: mientras el WF no
// existiera en Live, el control no se dibujaba — un control que no guarda es peor que
// no tenerlo.
//
// ENCENDIDA (s186) DESPUES DEL DEPLOY DE BUBBLE que puso `add_merchant_photo` y
// `remove_merchant_photo` en Live. Con esto aparece «FOTOS DE TU LOCAL» en el Perfil
// del comercio — que es donde vive, NO en el alta de oferta: son las fotos del local,
// distintas del logo (la marca) y de la foto de cada oferta (el plato). Alimentan el
// mosaico de /m/:id, que existe desde s183 y nunca pudo dibujar nada.
// Su smoke es el S2 y no se podia correr con esto apagado: la pantalla no existia.
export const GALERIA_HABILITADA = true;

// s186 - ATERRIZAJE POST-ALTA DEL COMERCIO. Con esto en `true`, el alta manda al
// comercio a /merchant/bienvenida en vez del dashboard.
//
// ENCENDIDO (Ali, 30/08) DESPUES DE SACARLE LA LLAMADA AL INGEST. La primera version
// se gateaba contra el deploy del guard de idempotencia (s186-D1) porque re-llamaba a
// `ingestOfferIdeas`, y sin guard eso podia pagar Firecrawl y Claude dos veces. La
// pantalla ahora SOLO LEE el perfil: sin llamada no hay doble cobro posible, y el gate
// contra Bubble deja de tener sentido. Lo que habilito el encendido no fue una
// decision: fue sacarle la unica parte que costaba dinero.
export const ATERRIZAJE_HABILITADO = true;

// s189-D - LA PANTALLA DE FUENTES, entre el alta y la generacion. Con esto en `true`
// el alta manda a /merchant/tu-negocio en vez de disparar el asesor a ciegas.
//
// QUE CAMBIA: hoy el alta dispara el ingest fire-and-forget con la URL que dio Google
// y manda a esperar. Si el sitio no tiene precios —el caso normal en peluqueria y spa—
// se paga Firecrawl, se gasta 1 de las 10 generaciones, y salen doce ideas genericas
// que son lo primero que el comercio ve de nosotros. Con la pantalla, el comercio dice
// de donde salen sus precios y que dias quiere ofrecer ANTES de que se gaste nada.
//
// POR QUE TIENE FLAG: es una pantalla OBLIGATORIA en el momento de mayor abandono del
// embudo. La cuenta ya esta creada cuando aparece, asi que abandonar ahi no pierde el
// comercio —pierde la generacion, que hoy se gasta igual y peor—, pero si mide mal se
// apaga desde aca y el alta vuelve al recorrido anterior sin tocar una linea.
export const FUENTES_HABILITADA = true;

// s189-G - LA DESCRIPCION ESCRITA POR EL ASISTENTE, desde el texto del sitio del comercio.
//
// 🔴 NACE EN `false` Y NO ES PRUDENCIA: HOY EL WF LE CONTESTARIA `NOT_ADMIN` AL COMERCIO.
//
// El WF `generate_merchant_description` YA EXISTE en Bubble — 10 steps, param `merchant_id`,
// dos llamadas al asesor (ES y EN) sobre `ingested_text`, y un Make changes que escribe
// `description_es` / `description_en` (BUBBLE_SCHEMA.md:1203). Lo construyo la sala del 29/08
// y quedo, textual, «Main, no deployado, no corrido»
// (`claude/RESULTADOS_s184_sala_descripciones_y_claims.md:7`).
//
// FALTAN TRES COSAS, TODAS DEL LADO DE BUBBLE, Y NINGUNA ES DE ESTE ARCHIVO:
//   1. La guarda del step 1 es `Current User's role ≠ Admin` → NOT_ADMIN. Tiene que pasar a
//      admitir tambien al DUEÑO: `… AND el owner_user del MerchantPartner ≠ Current User`.
//   2. Hay que VERIFICAR que el step 9 escriba corriendo como comercio y no como admin. La
//      privacy rule «Owner sees own» de MerchantPartner tiene `modify_api` en OFF y la spec
//      dejo `Ignore privacy rules` apagado a proposito. Se prueba, no se deduce.
//   3. Deploy: el WF esta en Main y el front apunta a `version-live`.
//
// POR QUE ESTA CONSTRUIDO IGUAL: para que el dia que Bubble este listo esto sea UN BOOLEANO
// y no un lote. Es el mismo patron de GALERIA_HABILITADA, que espero al deploy de
// `add_merchant_photo`, y de FUENTES_HABILITADA.
//
// ⚠️ AL ENCENDERLO, MIRAR UNA COSA: el WF **guarda solo** (step 9). O sea que la descripcion
// queda escrita en la ficha ANTES de que el comercio la lea. El copy lo dice con todas las
// letras («ya quedo guardada, cambiala si quieres») porque mentirle sobre eso es peor que el
// comportamiento. Si algun dia se quiere que no guarde hasta que el comercio apruebe, eso es
// un parametro nuevo en el WF, no un cambio de pantalla.
// s191 · ENCENDIDO. Ali deployo Main -> Live el 07/09 («Web deployment successful»),
// que es la unica condicion que este flag estaba esperando. Cableado verificado antes de
// encender: el WF devuelve `code: "NO_INGESTED"` cuando el comercio no tiene sitio leido
// (steps 4/5) y `pedirDescripcion` atrapa EXACTAMENTE ese codigo, muestra el aviso y salta
// al campo del sitio web; una respuesta vacia tambien tiene su mensaje propio.
// Para apagarlo, `false` y listo: no hay nada mas que revertir.
export const DESCRIPCION_IA_HABILITADA = true;

export async function agregarFotoComercio(file) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const chica = await achicarImagen(file);
  const contents = await fileToBase64(chica);
  const data = await apiPost("/wf/add_merchant_photo", {
    photo: { filename: chica.name, contents, private: false },
  }, userToken);
  const resp = data?.response || null;
  // s200 · MISMO PATRON QUE redeemCoupon (L#83): el WF devuelve HTTP 200 incluso cuando
  // rechaza, asi que el unico que sabe si entro es el cuerpo. Hasta hoy esto devolvia el
  // objeto tal cual y la pantalla lo trataba como exito: con el guard GALLERY_FULL que
  // Bubble suma hoy, la foto 11 habria dibujado una vista previa optimista de algo que
  // nunca se guardo.
  if (resp && resp.success === false) {
    const err = new Error(resp.error_message || "No se pudo agregar la foto");
    err.code = resp.error_code || "ADD_PHOTO_FAILED";
    throw err;
  }
  return resp;
}

// s203 · «Hacer portada». `set_gallery_cover(photo_url)` con la sesión del comercio: pone esa
// foto primera y deja las demás en su orden. Verificado en Live con el export 90 (smoke F1 s203:
// 8 → 8, sin duplicados). `photo_url` va COMO ESTÁ EN LA BASE («//…cdn.bubble.io/…»): el WF
// compara con «This image's URL», y así se probó. Errores: NO_MERCHANT · PHOTO_NOT_FOUND.
export async function setGalleryCover(photo_url) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  return apiPostGuarded("/wf/set_gallery_cover", { photo_url }, userToken);
}

export async function quitarFotoComercio(photo_url) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const data = await apiPost("/wf/remove_merchant_photo", { photo_url }, userToken);
  return data?.response || null;
}

// ---- MERCHANT LOGO UPDATE (8.15) ----
// Bubble Workflow API: archivos como { filename, contents(base64 sin prefijo), private }.
// File-param confirmado vs BUBBLE_SCHEMA: `logo` (image).
export async function updateMerchantLogo(file) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const contents = await fileToBase64(file);
  const data = await apiPost("/wf/update_merchant_logo", {
    logo: { filename: file.name, contents, private: false },
  }, userToken);
  return data?.response || null;
}

// ============================================
// MEMBERSHIP (DECISIÓN-A / D74)
// ============================================

// Lee los planes de membresía vía Data API. s101: /beneficios es POST-LOGIN → lee con el
// TOKEN DEL USUARIO (regla privacy "Logged-in users": Find ON, 14 campos View). Ya NO usa ADMIN_TOKEN.
// activeOnly=true para la vista del consumidor (solo planes activos); false para el admin (todos).
// Orden por display_order asc. `active`/`featured` vuelven como boolean desde la Data API.
export async function getMembershipPlans({ activeOnly = true } = {}) {
  const data = await apiGet("/obj/membershipplan?limit=100", auth.getToken());
  let plans = data?.response?.results || [];
  if (activeOnly) plans = plans.filter((p) => p.active === true || p.active === "yes");
  return plans
    .slice()
    .sort((a, b) => (a.display_order || 0) - (b.display_order || 0));
}

// Admin edita precio/destacado/activo de un plan. WF admin-gated `update_membership_plan`.
// Guards devuelven success "no"/error_code (apiPostGuarded lo captura); éxito → success "yes".
export async function updateMembershipPlan({ plan_id, price_usd, featured, active }) {
  return apiPostGuarded("/wf/update_membership_plan", { plan_id, price_usd, featured, active });
}

// ============================================
// ADMIN: DISCOUNT CODES (motor de descuentos de membresía · s73)
// ============================================
// DiscountCode NO es enumerable por Data API (privacy: /obj/discountcode -> 404) ->
// la lista admin va por WF admin-gated `get_discount_codes` (no por /obj). Normalizamos
// por si el WF devuelve la lista bajo distintas claves.
export async function getDiscountCodes() {
  const data = await apiPost("/wf/get_discount_codes", {}, auth.getToken());
  const resp = data?.response;
  const list =
    (Array.isArray(resp) && resp) ||
    resp?.codes || resp?.discount_codes || resp?.results || resp?.list || [];
  return Array.isArray(list) ? list : [];
}

// Crea un código de descuento de membresía (admin-gated). WF `create_discount_code`.
// Params (s62): code, discount_percent, expires_at (date), discount_mode
// ("percent"|"fixed_price"), fixed_price, max_redemptions, no_expiry (yes/no),
// audience ("new"|"renewal"|"both"), plan_scope (MembershipPlan list; vacío = global),
// campaign. expires_at va como epoch ms (Bubble date via API). plan_scope como array de
// unique ids, se omite si vacío -> global. Éxito -> { success:"yes", code, discount_code_id }.
export async function createDiscountCode({
  code, discount_mode = "percent", discount_percent = 0, fixed_price, is_multiuse,
  expires_at, no_expiry, audience = "both", plan_scope, campaign, max_redemptions,
}) {
  const body = {
    code: (code || "").trim().toUpperCase(),
    discount_mode,
    discount_percent: Number(discount_percent) || 0,
    audience,
  };
  if (discount_mode === "fixed_price") body.fixed_price = Number(fixed_price) || 0;
  // s186 · multiuso (param 11 del WF, export 75). Es LA pieza que destraba el canal
  // influencer: hasta s185 el código se quemaba en el primer canje (`is_used = true`)
  // y la segunda persona que lo usaba ya no encontraba la rama de precio fijo.
  // Se manda solo cuando es true — un false explícito no aporta nada sobre el
  // default y el param es Optional.
  if (is_multiuse === true) body.is_multiuse = true;
  if (expires_at != null) body.expires_at = expires_at; // epoch ms
  if (no_expiry) body.no_expiry = "yes";
  if (campaign && campaign.trim()) body.campaign = campaign.trim();
  if (max_redemptions != null && max_redemptions !== "") body.max_redemptions = Number(max_redemptions);
  if (Array.isArray(plan_scope) && plan_scope.length) body.plan_scope = plan_scope; // vacío = global
  return apiPostGuarded("/wf/create_discount_code", body);
}

// Desactiva un código (active=no). WF admin-gated `deactivate_discount_code`.
// Usa `discount_code_id` = el _id de la fila de getDiscountCodes.
export async function deactivateDiscountCode(discount_code_id) {
  return apiPostGuarded("/wf/deactivate_discount_code", { discount_code_id });
}

// Valida un código de descuento contra un plan (READ-ONLY, no cobra). WF `validate_discount_code`.
// Devuelve `valid` ("yes"/"no") + error_code si es inválido
// (PLAN_NOT_FOUND/PLAN_INACTIVE/CODE_NOT_FOUND/CODE_INACTIVE/CODE_USED/CODE_EXPIRED).
// En éxito: { valid:"yes", original_price, discount_percent, plan_label, duration_months, ... }.
// NOTA: el WF NO devuelve final_price (Bubble no soporta math anidada) → lo computa el front
// con computeMembershipPrice. El cobro real lo recomputa server-side FIX-9 (lección 8.4).
export async function validateDiscountCode({ plan_id, code }) {
  const userToken = auth.getToken();
  if (!userToken) throw new Error("No token");
  const data = await apiPost("/wf/validate_discount_code", { plan_id, code }, userToken);
  const resp = data?.response;
  if (!resp || resp.valid === "no" || resp.valid === false || resp.error_code) {
    const err = new Error(resp?.error_message || "Código inválido");
    err.code = resp?.error_code || "INVALID_CODE";
    throw err;
  }
  return resp;
}

// Precio con descuento, computado en el front (solo para mostrar). El cobro real lo recomputa
// FIX-9 server-side desde el plan en la DB (lección 8.4: el cliente nunca manda el precio).
export function computeMembershipPrice(original_price, discount_percent) {
  const base = Number(original_price) || 0;
  const pct = Number(discount_percent) || 0;
  const price = base * (1 - pct / 100);
  return Math.round(price * 100) / 100;
}

// ============================================
// ADMIN API
// ============================================

export async function getAdminStats() {
  const [users, offers, coupons, merchants] = await Promise.all([
    apiGet("/obj/user?limit=1", auth.getToken()),
    apiGet("/obj/offer?limit=1", auth.getToken()),
    apiGet("/obj/couponinstance?limit=1", auth.getToken()),
    apiGet("/obj/merchantpartner?limit=1", auth.getToken()),
  ]);
  return {
    total_users: (users?.response?.count || 0) + (users?.response?.remaining || 0),
    total_offers: (offers?.response?.count || 0) + (offers?.response?.remaining || 0),
    total_coupons: (coupons?.response?.count || 0) + (coupons?.response?.remaining || 0),
    total_merchants: (merchants?.response?.count || 0) + (merchants?.response?.remaining || 0),
  };
}

export async function getPendingOffers() {
  const data = await apiGet(
    '/obj/offer?constraints=[{"key":"status","constraint_type":"equals","value":"Pending"}]&limit=100',
    auth.getToken()
  );
  return (data?.response?.results || []).map(normalizeOffer);
}

export async function getAllOffers() {
  const data = await apiGet("/obj/offer?limit=100", auth.getToken());
  return (data?.response?.results || []).map(normalizeOffer);
}

// s223 · 2b · ¿el comercio ya tiene alguna oferta, en cualquier estado? Decide si el alta abre el wizard de la
// primera oferta. Misma lectura que getAllOffers (Data API con la sesión, «Merchant sees own offers»), pero con el
// filtro por comercio: getAllOffers trae las 100 primeras de TODA la base y las del comercio pueden no estar ahí.
// Devuelve el número (count + remaining); si la lectura falla, tira y el alta sigue como antes.
export async function contarOfertasDelComercio(merchantId) {
  if (!merchantId) throw new Error("NO_MERCHANT");
  const constraints = JSON.stringify([{ key: "merchant", constraint_type: "equals", value: merchantId }]);
  const data = await apiGet(`/obj/offer?constraints=${encodeURIComponent(constraints)}&limit=1`, auth.getToken());
  const r = data?.response;
  if (!r || !Array.isArray(r.results)) throw new Error("OFFERS_NOT_READ");
  return (Number(r.count) || 0) + (Number(r.remaining) || 0);
}

export async function approveOffer(offer_id) {
  return apiPostGuarded("/wf/approve_offer", { offer_id });
}

// s203 · «Quitar foto» del operador (mitad de `boton-hacer-portada-y-quitar-foto-operador`).
// `admin_remove_merchant_photo(merchant_id, photo_url)`: Admin u Operator; verificado en Live
// con sesión (smoke s203 §3-3 NOT_OPERATOR y §3-4 remaining 8). `photo_url` va TAL CUAL la
// devuelve la base («//…cdn.bubble.io/…»): el WF compara con «This image's URL», y así se probó.
// Responde { success, message, gallery_urls, remaining }; errores NOT_OPERATOR · MERCHANT_NOT_FOUND.
export async function adminRemoveMerchantPhoto(merchant_id, photo_url) {
  return apiPostGuarded("/wf/admin_remove_merchant_photo", { merchant_id, photo_url });
}

// s216 · «Agregar foto» del operador (otra mitad de `operador-agregar-foto-y-logo`; el logo no).
// `operator_add_photo(merchant_id, photo)`: Admin u Operator, ignora privacy (export 110, S6/S6b).
// Suma la foto a la galería y, si la oferta no tiene foto válida, también la pone en `Offer.image`.
// `photo` llega ya encuadrada (EncuadrarFoto → recortarImagen); va como el `photo` de seed_merchant.
// Responde { success, gallery_urls }; errores NOT_OPERATOR · MERCHANT_NOT_FOUND · GALLERY_FULL (10).
export async function operatorAddPhoto(merchant_id, photo) {
  const archivo = await archivoParaWf(photo, true);
  return apiPostGuarded("/wf/operator_add_photo", { merchant_id, photo: archivo });
}

// s216 · deploy D (export 113) · el logo y el estado de vitrina de un sembrado, después de sembrar.
// operator_add_logo(merchant_id, logo:image) → { success, logo_url } · NOT_OPERATOR · MERCHANT_NOT_FOUND.
// El logo llega ya encuadrado (512 px; PNG queda PNG por la transparencia).
export async function operatorAddLogo(merchant_id, logo) {
  const archivo = await archivoParaWf(logo, false);
  return apiPostGuarded("/wf/operator_add_logo", { merchant_id, logo: archivo });
}
// operator_set_beta_state(merchant_id, demo|borroso|visible) → { success, beta_state } · NOT_OPERATOR ·
// MERCHANT_NOT_FOUND · NOT_SEEDED · PHOTO_REQUIRED (visible sin foto; trae error_message).
export async function operatorSetBetaState(merchant_id, beta_state) {
  return apiPostGuarded("/wf/operator_set_beta_state", { merchant_id, beta_state });
}

// ============================================
// s216 · EMPLEADOS QUE VALIDAN (Ola 2, deploy B, export 111 · PLAN_s215_empleados_validar.md)
// El dueño invita por correo; el empleado (rol `MerchantStaff`, `User.staff_of` = el comercio) solo
// valida códigos con `redeem_coupon`. Los WFs de dueño lo rechazan solos (no tiene merchant_profile).
// ============================================
// invite_staff(email, name?) → { success, staff_user_id } · NOT_OWNER · INVALID_EMAIL ·
// EMAIL_ALREADY_EXISTS (con error_message) · TOO_MANY_STAFF (tope 10). Reinvitar a un empleado propio
// lo reactiva y le reenvía el enlace (sirve como «Reenviar»).
export async function inviteStaff(email, name) {
  const body = { email: String(email || "").trim().toLowerCase() };
  if (name && String(name).trim()) body.name = String(name).trim();
  return apiPostGuarded("/wf/invite_staff", body);
}
// list_staff() → [{ id, name, email, active, invited_at (ms) }], más nuevos primero · NOT_OWNER.
export async function listStaff() {
  const r = await apiPostGuarded("/wf/list_staff", {});
  const lista = jsonTexto(r?.staff_json, []);
  return Array.isArray(lista) ? lista : [];
}
// remove_staff(staff_user_id) → { success } · NOT_OWNER · STAFF_NOT_FOUND. No borra: staff_active = no.
export async function removeStaff(staff_user_id) {
  return apiPostGuarded("/wf/remove_staff", { staff_user_id });
}
// El comercio del empleado, para nombrarlo en su pantalla. `staff_of` sale de su propio User
// («User's own data»); el nombre, de la ficha pública (solo si está aprobado). Sin dato → null.
export async function getStaffMerchantName() {
  const uid = auth.getUserId();
  if (!uid) return null;
  try {
    const u = await apiGet(`/obj/user/${uid}`, auth.getToken());
    const id = u?.response?.staff_of;
    if (!id) return null;
    const m = await apiGetPublic(`/obj/merchantpartner/${id}`);
    return m?.response?.business_name || null;
  } catch (e) {
    return null;
  }
}

// s221-D1 · las ofertas aprobadas del comercio del EMPLEADO, para que el validador sepa si un cupón es de %
// (cuenta obligatoria). Mismo canal público que getMerchantOffers (regla «Public sees approved»).
export async function getStaffMerchantOffers() {
  const uid = auth.getUserId();
  if (!uid) return [];
  const u = await apiGet(`/obj/user/${uid}`, auth.getToken());
  const id = u?.response?.staff_of;
  return id ? getMerchantOffers(id) : [];
}

// La galería de UN comercio, para el operador. Con su sesión (el admin ve todo por la Data
// API); si con sesión no llega nada, el canal anónimo (regla «Public sees approved»).
export async function getMerchantGallery(merchant_id) {
  const lista = (d) => { const g = d?.response?.gallery; return Array.isArray(g) ? g : (g ? [g] : []); };
  const conSesion = lista(await apiGet(`/obj/merchantpartner/${merchant_id}`, auth.getToken()));
  if (conSesion.length) return conSesion;
  return lista(await apiGetPublic(`/obj/merchantpartner/${merchant_id}`));
}

// s203 (auditoría s203): `reject_offer` NO está expuesto (registro 88: «🔒 interno»), así que
// el botón «Rechazar» del admin respondía error y no rechazaba nada. Va por
// `admin_set_offer_status` action=reject (expuesto, admin-gated): Rejected + correo al comercio.
// is_active: el reject de admin_set_offer_status cambia SOLO el status (registro, Step 6), así que la oferta queda con
// el is_active que tenía. Una Pending nace con false y sigue en false (es lo que se vio en la relectura de s226, las 8
// eran Pending); una Approved rechazada queda en true. No importa para el catálogo, que filtra por status = approved
// (s161 F-2), pero queda dicho. (s227 · `comentario-rejectoffer-is-active`.)
export async function rejectOffer(offer_id, reason = "") {
  return adminSetOfferStatus(offer_id, "reject", reason);
}

// A3 (s79): admin marca/desmarca una oferta como destacada (WF admin-only set_offer_featured).
export async function setOfferFeatured(offer_id, featured) {
  return apiPostGuarded("/wf/set_offer_featured", { offer_id, featured });
}

// C.2/F-16: admin moderates an already-Approved offer.
// action: "unpublish" (Approved → Pending) | "reject" (Approved → Rejected, sends send_offer_rejected email).
// WF is admin-gated (Current User's role is Admin); error_code ∈ NOT_ADMIN | OFFER_NOT_FOUND.
export async function adminSetOfferStatus(offer_id, action, reason) {
  return apiPostGuarded("/wf/admin_set_offer_status", { offer_id, action, reason });
}

// s126 Fase C: el admin agenda el cobro de la cuota de programa acumulada de un
// merchant (wrapper admin-gated `admin_charge_merchant` -> Schedule de
// charge_merchant_take). El WF de cobro corre agendado con guards SILENCIOSOS:
// billing_active!=yes | accum vacio o <$15 | sin tarjeta guardada | ya hubo un
// cobro Charged en las ultimas 24h -> en cualquiera de esos casos termina sin
// cobrar. La respuesta solo confirma el AGENDADO ({ success, scheduled });
// el resultado real queda en MerchantCharges. error_code: NOT_ADMIN.
export async function adminChargeMerchant(merchant_id) {
  return apiPostGuarded("/wf/admin_charge_merchant", { merchant: merchant_id });
}

// s233 · paginado (apiGetTodo): con limit=100 a secas, el User 101 en adelante no aparecía en /admin/users.
export async function getAllUsers() {
  return apiGetTodo("/obj/user", auth.getToken());
}

export async function blockUser(user_id) {
  return apiPostGuarded("/wf/block_user", { user_id });
}

export async function unblockUser(user_id) {
  return apiPostGuarded("/wf/unblock_user", { user_id });
}

// s52: admin promueve/degrada admins (modelo "admins iguales"). WF admin-gated
// `set_user_role`, togglea Admin ↔ EndUser únicamente (Merchant se maneja aparte).
// Guards (apiPostGuarded los captura): NOT_ADMIN | USER_NOT_FOUND | INVALID_ROLE |
// CANNOT_DEMOTE_SELF (anti-lockout: un admin no puede quitarse el rol a sí mismo,
// lo que también protege al último admin). Éxito → { success: "yes", new_role }.
export async function setUserRole(user_id, new_role) {
  return apiPostGuarded("/wf/set_user_role", { user_id, new_role });
}

// X.38: admin approves a Lead/PendingReview merchant (MerchantPartner status → Approved).
// WF admin-gated (Current User's role is Admin); error_code ∈ NOT_ADMIN | MERCHANT_NOT_FOUND.
// On success resp = { success: true, new_status: "Approved" }.
export async function approveMerchant(merchant_id) {
  return apiPostGuarded("/wf/approve_merchant", { merchant_id });
}

// s189-G: le pide al asistente la descripcion del comercio a partir del `ingested_text` que
// dejo Firecrawl al leer su sitio. El WF escribe `description_es` y `description_en` EL MISMO
// (step 9) y los devuelve, asi que la respuesta no es solo un acuse: es el texto.
// Codigos de error del WF: NOT_ADMIN (hoy le pega a todo comercio, ver el flag) · NOT_FOUND ·
// NO_INGESTED (no hay sitio leido — el caso normal del comercio sin web).
// Exito → { success: "yes", description_es, description_en }.
export async function generateMerchantDescription(merchant_id) {
  return apiPostGuarded("/wf/generate_merchant_description", { merchant_id });
}

// X.38: admin rejects a merchant (status → Rejected). Same guards as approveMerchant.
export async function rejectMerchant(merchant_id) {
  return apiPostGuarded("/wf/reject_merchant", { merchant_id });
}

export async function createAccessCode({ code, tier_to_assign, notes, max_coupons, vip_max_active, duration_months, is_multiuse, max_signups, label, enganche_code, plan_to_grant, grant_credits_override, expires_at, owner_user_id, commission_pct, hold_days, audience }) {
  // X.23 s30: max_coupons (LITE) y vip_max_active (VIP) ahora se mandan y el WF los persiste
  // en el AccessCode; signup_api (Step 4) los copia al User → el guard LITE deja de tratar vacío como 0.
  // M-10 s52: duration_months (meses del VIP por código). El WF create_access_code lo persiste y
  // signup_api lo consume (vip_expires_at = ahora +months(duration_months), default 12 si vacío).
  // INF-3 s57: is_multiuse + max_signups (cupo) + label (etiqueta del influencer) para códigos
  // de influencer multiuso. Backward-compatible: si no se pasan, el WF los trata como single-use
  // legacy (is_multiuse default = no). Requiere los campos N1 en AccessCode (NARANJA).
  return apiPostGuarded("/wf/create_access_code", {
    code, tier_to_assign, notes, max_coupons, vip_max_active, duration_months,
    is_multiuse, max_signups, label,
    // s186 · el enganche del canal influencer (param 17 del WF, export 75). Es el
    // código del DiscountCode de precio fijo que le toca a quien entre por este
    // AccessCode. Se manda solo si tiene valor: el param es Optional y mandarlo
    // vacío escribiría un texto vacío sobre uno ya cargado.
    // ⚠️ La línea del Create de este campo la repuso Ali A MANO en s185 — la sala
    // había reportado escribirla y nunca existió. Si el enganche llega vacío al
    // AccessCode, ese Create es el primer lugar donde mirar, no este archivo.
    ...(enganche_code ? { enganche_code } : {}),
    // ETAPA-2 (s99): expires_at (date, opcional) — urgencia-por-codigo. El param YA existe
    // en el WF create_access_code y se persiste; signup_api/apply_access_code lo respetan (CODE_EXPIRED).
    ...(expires_at ? { expires_at } : {}),
    // s82 gifting: plan_to_grant (unique id del MembershipPlan) otorga el plan al aplicar el
    // codigo; grant_credits_override (number, LEGACY Fase B — apagada por Modelo A s121/s122). Ambos opcionales.
    ...(plan_to_grant ? { plan_to_grant } : {}),
    ...((grant_credits_override != null && grant_credits_override !== "") ? { grant_credits_override: Number(grant_credits_override) } : {}),
    // s220 · el código del ALIADO: dueño (User con rol Influencer), % de comisión y días de retención
    // (hold_days, param nuevo del 124). Solo Admin: si los manda una Operadora el WF responde
    // OPERATOR_PARAM_NOT_ALLOWED. Con tier_to_assign "NONE" el código no da tier (solo atribución y
    // descuento) y apply_access_code no le toca el tier a quien ya lo tiene.
    ...(owner_user_id ? { owner_user_id } : {}),
    ...((commission_pct != null && commission_pct !== "") ? { commission_pct: Number(commission_pct) } : {}),
    ...((hold_days != null && hold_days !== "") ? { hold_days: Number(hold_days) } : {}),
    // s220 · "member" | "merchant". Sin mandarlo queda vacío (pasa en el registro de miembros igual que
    // "member"); se manda para que los datos queden parejos y los de comercio se distingan.
    ...(audience ? { audience } : {}),
  });
}

// M-9 s52: admin promueve un usuario existente LITE→VIP. WF admin-gated promote_to_vip:
// setea tier=VIP + vip_expires_at (ahora +months(duration_months)) + event_date + membership_started_at.
// Guards (apiPostGuarded los captura): NOT_ADMIN | USER_NOT_FOUND. Éxito → { success:"yes", ... }.
// s220-D6 · export 125: `plan_name` opcional («Aliado NXT» · «Invitado VIP» · «Travel Guest»; sin él, «Travel Guest»).
// El Return trae `membership_plan`. Un nombre fuera de la lista → PLAN_NAME_INVALID.
export async function promoteToVip({ user_id, duration_months, event_date, plan_name }) {
  return apiPostGuarded("/wf/promote_to_vip", { user_id, duration_months, event_date, ...(plan_name ? { plan_name } : {}) });
}

// INF (s111): reporte agregado por código de influencer. WF admin-only get_influencer_stats
// (ignore-privacy; agrega sobre Users ajenos). Devuelve SOLO agregados, nunca identidad:
// { success, registered, first_activations, first_fees_cents, signups_counter, code_label,
//   max_signups, expires_at }. first_fees_cents en CENTAVOS -> dividir /100 en el front.
export async function getInfluencerStats(code) {
  return apiPostGuarded("/wf/get_influencer_stats", { code });
}

// INF self-serve (s113): panel del PROPIO influencer. WF get_my_influencer_stats
// (auth · ignore-privacy · 0 params; deriva el codigo de AccessCode.owner_user =
// Current User, patron get_merchant_stats). Devuelve success + agregados + 3 listas
// SIN identidad (registration_dates / activation_dates / activation_fees_cents).
// Guards: success="no" + error in {NOT_INFLUENCER, NO_CODE}. first_fees_cents en CENTAVOS.
export async function getMyInfluencerStats() {
  const userToken = auth.getToken();
  if (!userToken) return null;
  const data = await apiPost("/wf/get_my_influencer_stats", {}, userToken);
  return data?.response || null;
}

// s220 · el panel del aliado (/aliados). Contrato: claude/influencer/CONTRATO_s218_panel_influencer_para_code.md,
// con dos cambios de s220: el error viene en `error_code` (antes `error`) y commission_pct /
// commission_months / hold_days salen del código MÁS RECIENTE del aliado. Errores (err.code):
// NOT_INFLUENCER · NO_CODE · WF_NOT_DEPLOYED (404: el 124 todavía no está en esa versión de Bubble).
// Bubble omite las claves vacías: `commission_months` ausente = sin tope; `total_paid_usd` ausente = 0.
// Los dos JSON (`members_json`, `plans_json`, `payouts_json`) vienen como TEXTO: se parsean aquí,
// con try/catch — un texto raro deja la lista vacía, no la pantalla en blanco.
function parsearLista(texto) {
  if (!texto) return [];
  try { const v = JSON.parse(texto); return Array.isArray(v) ? v : []; } catch (e) { return []; }
}

export async function getMyInfluencerPanel() {
  const r = await postWfBeta("/wf/get_my_influencer_panel", {}, true);
  return { ...r, members: parsearLista(r.members_json), plans: parsearLista(r.plans_json) };
}

export async function getMyInfluencerPayouts() {
  const r = await postWfBeta("/wf/get_my_influencer_payouts", {}, true);
  return { ...r, total_paid_usd: Number(r.total_paid_usd) || 0, payouts: parsearLista(r.payouts_json) };
}

// s233 · paginado igual que getAllUsers.
export async function getAllAccessCodes() {
  return apiGetTodo("/obj/accesscode", auth.getToken());
}

// ETAPA-2 (s99): consola Operadora — lista SOLO los codigos creados por la usuaria logueada.
// Data API /obj/accesscode con TOKEN DE USUARIO: la privacy rule "Creator" de AccessCode
// (This AccessCode's Creator is Current User, Find ON, View 11 campos) filtra server-side.
// Un Admin por esta via tambien ve solo los suyos; el rollup completo sigue siendo
// getAllAccessCodes (token de admin logueado + regla "Admin sees all").
export async function getMyAccessCodes() {
  const userToken = auth.getToken();
  if (!userToken) return [];
  const rows = await apiGetTodo("/obj/accesscode", userToken);   // s233 · paginado: más de 100 códigos propios
  return rows.sort((x, y) => new Date(y["Created Date"] || 0) - new Date(x["Created Date"] || 0));
}

// ETAPA-2 (s99): etiquetar el resultado comercial de un codigo. WF nuevo set_outcome
// (server-side; gates: NOT_AUTHORIZED [ni Admin ni Operator] | CODE_NOT_FOUND |
// INVALID_OUTCOME | NOT_YOURS [Operator solo etiqueta los propios; Admin cualquiera]).
// outcome ∈ {pending, sold, invited, discount, free_close} (option set CodeOutcome).
export async function setOutcome(access_code_id, outcome) {
  return apiPostGuarded("/wf/set_outcome", { access_code_id, outcome });
}

// s184 · EL TECHO DE LA FRANJA (D17 opcion a) — construido, hoy inerte.
// Lee `wallet_credits` de los MembershipPlan para poder decir «$X de $TECHO».
//
// Tres cosas que este canal impone, y que explican la forma rara de la funcion:
//  1. NO es publico. La regla `everyone` de membershipplan tiene todo OFF (anonimo
//     recibe 0 planes, verificado). La lectura va con el token del miembro.
//  2. La regla de logged-in declara `view_fields` con 14 campos y `wallet_credits`
//     NO esta entre ellos: hasta que Ali tilde el campo, la clave llega AUSENTE.
//     Ausente y vacio se tratan igual — sin techo, no se dibuja nada.
//  3. El User NO guarda que plan compro (`confirm_membership_purchase` escribe
//     tier, vip_expires_at y vip_max_active, nunca una referencia al plan). Asi
//     que no se puede preguntar «el techo DE SU plan». Salida: si todos los planes
//     que traen techo coinciden en el valor, ese es el techo; si difieren, no hay
//     forma de saber cual le toca y se devuelve null antes que mostrar uno ajeno.
//     Ver la nota del reporte s184: lo mas simple es cargar el MISMO valor en los 4.
export async function getTechoDeCatalogo() {
  const token = auth.getToken();
  if (!token) return null;
  try {
    const data = await apiGet("/obj/membershipplan?limit=20", token);
    const planes = data?.response?.results || [];
    const techos = planes
      .filter(p => p && p.active !== false)
      .map(p => Number(p.wallet_credits))
      .filter(n => isFinite(n) && n > 0);
    if (!techos.length) return null;                       // el caso de HOY
    return techos.every(t => t === techos[0]) ? techos[0] : null;
  } catch (e) {
    return null;   // el techo es un adorno: si falla, la franja sigue mostrando el ahorro
  }
}

// s184 - LO QUE EL MIEMBRO PAGO POR SU MEMBRESIA. Cierra s183-D16, que quedo
// decidida y sin construir: el payback sale de `amount_paid_membership` leido de
// la fila propia por `/obj/user`, y NUNCA de `get_user_savings` (admin-only).
//
// Por que se puede leer sin tocar Bubble: la privacy rule «User's own data»
// (`<injected> equals CurrentUser`) tiene view_all + search_for y NO declara
// `view_fields`, asi que el miembro logueado recibe su fila completa — este campo
// incluido. `everyone` tiene todo OFF, de modo que la busqueda solo puede devolver
// la fila propia. Verificado en runtime: /obj/user anonimo devuelve 0 registros.
//
// Devuelve null cuando no hay dato, y el llamador no dibuja nada. Un cero aca no
// es «pago cero»: es «no sabemos», y son cosas distintas.
export async function getPagoDeMembresia() {
  const token = auth.getToken();
  const id = auth.getUserId();
  if (!token || !id) return null;
  try {
    const data = await apiGet(`/obj/user/${id}`, token);
    const v = Number(data?.response?.amount_paid_membership);
    return isFinite(v) && v > 0 ? v : null;
  } catch (e) {
    return null;   // el payback es un extra: si falla, la pantalla sigue entera
  }
}

// s223 · el admin trae TODAS las filas, no las 100 primeras: la Data API pagina de a 100 (cursor + remaining) y los
// filtros del admin solo pueden encontrar lo que se cargó. Tope de seguridad: 50 páginas (5.000 filas).
async function apiGetTodo(path, token) {
  const out = [];
  let cursor = 0;
  for (let pagina = 0; pagina < 50; pagina++) {
    const sep = path.includes("?") ? "&" : "?";
    const data = await apiGet(`${path}${sep}limit=100&cursor=${cursor}`, token);
    const r = data?.response;
    if (!r || !Array.isArray(r.results)) break;
    out.push(...r.results);
    if (!r.remaining || !r.results.length) break;
    cursor += r.results.length;
  }
  return out;
}

// Solo lo usa el admin (Comercios, Ofertas, Herramientas).
export async function getAllMerchants() {
  return apiGetTodo("/obj/merchantpartner", auth.getToken());
}

// s223 · las ofertas para el admin, todas (getAllOffers sigue en 100: la usan pantallas del comercio con su sesión).
export async function getAllOffersAdmin() {
  return (await apiGetTodo("/obj/offer", auth.getToken())).map(o => normalizeOffer(o));
}

// s233 · paginado: con limit=100 a secas, el Dashboard (tasa de canje, ingreso estimado) y el CSV contaban solo 100 cupones.
export async function getAllCoupons() {
  return apiGetTodo("/obj/couponinstance", auth.getToken());
}

// ============================================
// B5.1 — ASSISTANT ADMIN (entrenamiento del asesor)
// ============================================
// Lecturas vía Data API (/obj, token de admin logueado); escrituras vía WFs admin-gated.
// NOTA: nombres de params de los WF asumidos = nombres de campo del diseño (§3).
// Si algún WF usa otro nombre, es un ajuste de 1 línea por función.

export async function getAssistantConfig() {
  const data = await apiGet("/obj/assistantconfig?limit=1", auth.getToken());
  return (data?.response?.results || [])[0] || null;
}

export async function updateAssistantConfig(payload) {
  return apiPostGuarded("/wf/update_assistant_config", payload);
}

export async function getAssistantScenarios() {
  const data = await apiGet("/obj/assistantscenario?limit=100", auth.getToken());
  return data?.response?.results || [];
}

export async function createAssistantScenario(payload) {
  return apiPostGuarded("/wf/create_assistant_scenario", payload);
}

export async function updateAssistantScenario(payload) {
  return apiPostGuarded("/wf/update_assistant_scenario", payload);
}

export async function getMarginProfiles() {
  const data = await apiGet("/obj/marginprofile?limit=100", auth.getToken());
  return data?.response?.results || [];
}

export async function createMarginProfile(payload) {
  return apiPostGuarded("/wf/create_margin_profile", payload);
}

export async function updateMarginProfile(payload) {
  return apiPostGuarded("/wf/update_margin_profile", payload);
}

// ============================================
// MOCK OFFERS (fallback for dev)
// ============================================

export const MOCK_OFFERS = [
  // s194 L1 · dos fixtures del formato único (offer_type "umbral") para el smoke local: la
  // API real no tiene ninguna hasta que un comercio cargue la primera. Una XL y una
  // Destacada ($50 si gastas $100). Mismos tres campos que escribe el alta.
  {
    _id: "u1",
    offer_type: "umbral",
    title_es: "Recibe $30 si gastas $60",
    description_es: "Cena en el local. La cuenta debe superar $60 antes de impuestos y propina.",
    benefit_value_usd: 30, min_consumption: 60, regular_price: 60,
    category: "Restaurant",
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&h=400&fit=crop",
    merchant_name: "La Ventana Brickell",
    neighborhood: "Brickell",
    valid_days: "Lun,Mar,Mie,Jue,Vie",
    valid_time_start: "18:00",
    valid_time_end: "23:00",
    cooldown_days: 90,
    rules_text_es: "El mínimo se cuenta antes de impuestos y propina\nAplica a comida y bebidas sin alcohol; el alcohol suma al mínimo pero no lleva descuento\nUna oferta por socio, sin límite de mesa: cada socio cumple su propio mínimo\nRepetible cada 90 días en el mismo local\nSolo en el local, salvo que la ficha diga otra cosa\nNo combinable con otras promociones\nLa propina se calcula sobre el total sin descuento",
  },
  {
    _id: "u2",
    offer_type: "umbral",
    title_es: "Recibe $50 si gastas $100",
    description_es: "Menú degustación. La cuenta debe superar $100 antes de impuestos y propina.",
    benefit_value_usd: 50, min_consumption: 100, regular_price: 100,
    category: "Salon_Spa",
    image: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&h=400&fit=crop",
    merchant_name: "Aura Spa Coral Gables",
    neighborhood: "Coral Gables",
    valid_days: "Mar,Mie,Jue,Vie,Sab",
    valid_time_start: "",
    valid_time_end: "",
    cooldown_days: 90,
  },
  {
    _id: "m1",
    title_es: "Cocktail de Bienvenida + Vista Rooftop",
    description_es: "Disfruta un cocktail signature con vista al skyline de Brickell.",
    benefit_value_usd: 35,
    category: "Bar_Rooftop",
    image: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=600&h=400&fit=crop",
    merchant_name: "Brickell Social Club",
    neighborhood: "Brickell",
    valid_days: "Jue – Sáb",
    valid_time_start: "6:00 PM",
    valid_time_end: "11:00 PM",
    cooldown_days: 90,
  },
  {
    _id: "m2",
    title_es: "Facial Express + Mini Masaje",
    description_es: "30 min facial hidratante + 15 min masaje relajante.",
    benefit_value_usd: 65,
    category: "Salon_Spa",
    image: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=600&h=400&fit=crop",
    merchant_name: "Glow Studio Miami",
    neighborhood: "Wynwood",
    valid_days: "Lun – Vie",
    valid_time_start: "10:00 AM",
    valid_time_end: "6:00 PM",
    cooldown_days: 90,
  },
  {
    _id: "m3",
    title_es: "Cena para Dos — Entrante + Plato Fuerte",
    description_es: "Menú especial de 2 tiempos para dos personas en Azul Brickell.",
    benefit_value_usd: 80,
    category: "Restaurant",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=600&h=400&fit=crop",
    merchant_name: "Azul Brickell",
    neighborhood: "Brickell",
    valid_days: "Mar – Dom",
    valid_time_start: "6:00 PM",
    valid_time_end: "10:00 PM",
    cooldown_days: 90,
  },
  {
    _id: "m4",
    title_es: "Tour Bahía de Miami — 2 Personas",
    description_es: "Recorrido de 90 min por la Bahía de Biscayne con bebida incluida.",
    benefit_value_usd: 95,
    category: "Experience",
    image: "https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=600&h=400&fit=crop",
    merchant_name: "Miami Bay Tours",
    neighborhood: "Downtown",
    valid_days: "Sáb – Dom",
    valid_time_start: "10:00 AM",
    valid_time_end: "4:00 PM",
    cooldown_days: 90,
  },
  {
    _id: "m5",
    title_es: "Manicure + Pedicure Gel Premium",
    description_es: "Servicio completo de uñas gel con diseño a elección.",
    benefit_value_usd: 45,
    category: "Nail_Lash",
    image: "https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&h=400&fit=crop",
    merchant_name: "Luxe Nails Coral Gables",
    neighborhood: "Coral Gables",
    valid_days: "Lun – Sáb",
    valid_time_start: "9:00 AM",
    valid_time_end: "7:00 PM",
    cooldown_days: 90,
  },
  {
    _id: "m6",
    title_es: "Caja Regalo Gourmet — 20% Off",
    description_es: "Selección curada de productos artesanales locales. Ideal para regalo corporativo o personal.",
    benefit_value_usd: 55,
    category: "Gifts",
    image: "https://images.unsplash.com/photo-1549465220-1a8b9238cd48?w=600&h=400&fit=crop",
    merchant_name: "The Gift Box Miami",
    neighborhood: "South Miami",
    valid_days: "Lun – Dom",
    valid_time_start: "10:00 AM",
    valid_time_end: "8:00 PM",
    cooldown_days: 90,
  },
];
// ============================================
// GOOGLE PLACES (New) — alta v2 s109 (diseño s103 §3)
// ============================================
// REST directo a places.googleapis.com: la key está restringida a SOLO Places API (New)
// (el widget de Maps JavaScript NO funcionaría con esa restricción — decisión, no accidente).
// Key: browser key restringida por referrer (app.nxtreserve.com + netlify) + API + quota cap.
// Vive en Netlify env REACT_APP_GOOGLE_PLACES_KEY (no es secreto tipo sk_live: la protección
// ES la restricción). Session token + field mask mínimo → costo por alta en centavos; el free
// tier (Enterprise 1.000 calls/mes, modelo post-marzo-2025) cubre el pre-launch de sobra.
// TOS (regla dura s99/s103): NO GUARDAR rating / total_reviews / fotos de Google.
// s172-D1 + s181-F1: el rating y las reseñas SÍ se piden EN VIVO para mostrarlos (de Google
// al navegador y mueren ahí) — ver placeRating/placeReviews más abajo. Guardarlos sigue
// prohibido: ni campo de Bubble, ni localStorage, ni estado global.
const PLACES_KEY = process.env.REACT_APP_GOOGLE_PLACES_KEY || "";
export const placesEnabled = () => !!PLACES_KEY;

// Field mask mínimo del MVP. Sin rating/reviews/photos (TOS).
//
// s189-A · TRES CAMPOS MÁS, SIN SUBIR EL SKU. `nationalPhoneNumber`, `websiteUri` y
// `regularOpeningHours` ya son Enterprise, así que esta llamada YA paga tier Enterprise:
// agregar dos campos Pro (`primaryType`, `primaryTypeDisplayName`) y uno Enterprise
// (`priceLevel`) no mueve la factura, porque el tier lo fija el campo más caro pedido.
//   · primaryType            → el tipo PRINCIPAL que designa Google. Es lo que reemplaza a
//                              adivinar por orden de reglas en guessTaxonomyFromPlaceTypes.
//   · primaryTypeDisplayName → el nombre legible de ese tipo, para mostrárselo al comercio
//                              y que confirme mirando, no por inercia.
//   · priceLevel             → único uso: desempatar casual vs fine dining en Restaurant.
// ⛔ `editorialSummary` NO: es Enterprise + Atmosphere y ESE sí sube el tier.
// ⛔ TOS: `primaryTypeDisplayName` y `priceLevel` son contenido de Places — se muestran en
//    vivo y NO se guardan en Bubble. Lo que se guarda es NUESTRO `business_type`, derivado
//    y confirmado por el comercio. Mismo criterio que rating/reviews (s172-D1).
const PLACES_FIELD_MASK = [
  "id", "displayName", "formattedAddress", "addressComponents", "location",
  "googleMapsUri", "nationalPhoneNumber", "websiteUri", "regularOpeningHours", "types",
  "primaryType", "primaryTypeDisplayName", "priceLevel",
].join(",");

// Autocomplete (New). Bias a Miami (50km), solo US. Devuelve [{place_id, main, secondary}].
// Filtramos client-side a placePrediction (negocios/lugares; sin filtro de tipo server-side
// para no excluir negocios con primaryType raro).
export async function placesAutocomplete(input, sessionToken) {
  if (!PLACES_KEY || !input || input.trim().length < 3) return [];
  const res = await fetch("https://places.googleapis.com/v1/places:autocomplete", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Goog-Api-Key": PLACES_KEY },
    body: JSON.stringify({
      input: input.trim(),
      sessionToken: sessionToken || undefined,
      includedRegionCodes: ["us"],
      locationBias: { circle: { center: { latitude: 25.7617, longitude: -80.1918 }, radius: 50000.0 } },
    }),
  });
  if (!res.ok) throw new Error("PLACES_AUTOCOMPLETE_FAILED");
  const data = await res.json();
  return (data.suggestions || [])
    .map(s => s.placePrediction)
    .filter(Boolean)
    .map(p => ({
      place_id: p.placeId,
      main: (p.structuredFormat && p.structuredFormat.mainText && p.structuredFormat.mainText.text) || (p.text && p.text.text) || "",
      secondary: (p.structuredFormat && p.structuredFormat.secondaryText && p.structuredFormat.secondaryText.text) || "",
    }));
}

// Place Details (New). El sessionToken CIERRA la sesión de autocomplete (facturación por sesión).
// s216 · la siembra en LOTE trae de Google solo dónde está el lugar: la dirección y las coordenadas
// (el pin del mapa de Explorar). Máscara MÍNIMA a propósito: es una llamada por fila (~100 en un lote).
// [VERIFICAR] SKU: location y formattedAddress deberían caer en Place Details Essentials.
// Sin clave, sin place_id o si Google falla → null: la fila se siembra igual, sin estos datos.
// La dirección de Google sin el país del final («…, FL 33135, EE. UU.» / «, USA»).
export const sinPais = (dir) => String(dir || "").replace(/,\s*(EE\.\s?UU\.|EEUU|USA|United States)\s*$/i, "");
export async function placeUbicacion(placeId) {
  if (!PLACES_KEY || !placeId) return null;
  try {
    const res = await fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}`, {
      // s218 · + addressComponents (código postal, ciudad y barrio para seed_merchant v2). [VERIFICAR] SKU: sigue
      // siendo Place Details Essentials.
      headers: { "X-Goog-Api-Key": PLACES_KEY, "X-Goog-FieldMask": "location,formattedAddress,addressComponents" },
    });
    if (!res.ok) return null;
    const d = await res.json();
    const lat = d?.location?.latitude, lng = d?.location?.longitude;
    const comp = (tipo) => { const c = (d?.addressComponents || []).find(x => (x.types || []).includes(tipo)); return c ? (c.longText || c.shortText || "") : ""; };
    return {
      lat: Number.isFinite(lat) ? lat : "",
      lng: Number.isFinite(lng) ? lng : "",
      // s217 · Google cierra la dirección con el país («…, FL 33135, EE. UU.» / «, USA»): en una ficha de Miami sobra.
      address: sinPais(d?.formattedAddress),
      zip: comp("postal_code"),
      city: comp("locality") || comp("postal_town") || comp("administrative_area_level_2"),
      neighborhood: comp("neighborhood") || comp("sublocality_level_1") || comp("sublocality"),
    };
  } catch (e) {
    return null;
  }
}

// s217 · «Completar con Google» del lote: el precio del lugar. Probado 06/10 con dos restaurantes de Doral:
// Bulla trajo priceRange $30–90 y priceLevel MODERATE; Pisco y Nazca no trajo ninguno de los dos. Google lo
// da solo en una parte de los lugares. [VERIFICAR] SKU: priceRange/priceLevel caen en Place Details Enterprise.
// Devuelve { desde, hasta, nivel, telefono } (vacíos si no hay) o null si Google falla.
export async function placePrecio(placeId) {
  if (!PLACES_KEY || !placeId) return null;
  try {
    const res = await fetch(`https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}`, {
      // s218 · + websiteUri: también es Enterprise, así que no sube el SKU de esta llamada.
      headers: { "X-Goog-Api-Key": PLACES_KEY, "X-Goog-FieldMask": "priceRange,priceLevel,nationalPhoneNumber,websiteUri" },
    });
    if (!res.ok) return null;
    const d = await res.json();
    const n = (p) => { const v = Number(p?.units); return Number.isFinite(v) && v > 0 ? v : ""; };
    return {
      desde: n(d?.priceRange?.startPrice),
      hasta: n(d?.priceRange?.endPrice),
      nivel: d?.priceLevel || "",
      telefono: d?.nationalPhoneNumber || "",
      web: d?.websiteUri || "",
    };
  } catch (e) {
    return null;
  }
}

export async function placeDetails(placeId, sessionToken) {
  if (!PLACES_KEY || !placeId) return null;
  const url = `https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}` +
    (sessionToken ? `?sessionToken=${encodeURIComponent(sessionToken)}` : "");
  const res = await fetch(url, {
    headers: { "X-Goog-Api-Key": PLACES_KEY, "X-Goog-FieldMask": PLACES_FIELD_MASK },
  });
  if (!res.ok) throw new Error("PLACES_DETAILS_FAILED");
  return await res.json();
}

// ---- s181 ficha v2 · RATING DE GOOGLE EN VIVO (s172-D1 extendida a la oferta) ----
// Place Details (New) con field mask MÍNIMO. Dos llamadas distintas por diseño:
//   placeRating  → rating,userRatingCount,googleMapsUri   (UNA por carga de ficha)
//   placeReviews → + reviews                               (solo al tocar «Ver reseñas»)
// `reviews` es el SKU caro (Enterprise + Atmosphere): por eso nunca va en la primera.
// languageCode = idioma del miembro, para que el texto de las reseñas venga en su idioma.
// Nada de esto se guarda (TOS): se muestra con atribución y muere con la ficha.
const PLACES_RATING_MASK = "rating,userRatingCount,googleMapsUri";
const PLACES_REVIEWS_MASK = "rating,userRatingCount,googleMapsUri,reviews";
async function placeFetch(placeId, mask, lang) {
  const url = `https://places.googleapis.com/v1/places/${encodeURIComponent(placeId)}?languageCode=${lang === "en" ? "en" : "es"}`;
  const res = await fetch(url, { headers: { "X-Goog-Api-Key": PLACES_KEY, "X-Goog-FieldMask": mask } });
  if (!res.ok) throw new Error("PLACES_DETAILS_FAILED");
  return await res.json();
}
export async function placeRating(placeId, lang = "es") {
  if (!PLACES_KEY || !placeId) return null;
  const d = await placeFetch(placeId, PLACES_RATING_MASK, lang);
  if (typeof d?.rating !== "number") return null;
  return { rating: d.rating, count: Number(d.userRatingCount) || 0, mapsUri: d.googleMapsUri || "" };
}
// s241 · T2 (decisión de Ali, 25/10): la consola de Otto MUESTRA en vivo el resumen editorial y las reseñas de Google, con su
// atribución, para la llamada. No van a la IA ni se guardan (condiciones de Google: no cachear su contenido; s172-D1). Misma
// llamada que la ficha (Enterprise + Atmosphere) + `editorialSummary`.
export async function placeVistaParaOtto(placeId, lang = "es") {
  if (!PLACES_KEY || !placeId) return null;
  const d = await placeFetch(placeId, `${PLACES_REVIEWS_MASK},editorialSummary`, lang);
  return { ...formaResenas(d), resumen: d?.editorialSummary?.text || "" };
}
export async function placeReviews(placeId, lang = "es") {
  if (!PLACES_KEY || !placeId) return null;
  return formaResenas(await placeFetch(placeId, PLACES_REVIEWS_MASK, lang));
}
function formaResenas(d) {
  const reviews = (Array.isArray(d?.reviews) ? d.reviews : []).map(r => ({
    autor: r?.authorAttribution?.displayName || "",
    autorUri: r?.authorAttribution?.uri || "",
    foto: r?.authorAttribution?.photoUri || "",
    rating: Number(r?.rating) || 0,
    cuando: r?.relativePublishTimeDescription || "",
    texto: r?.text?.text || r?.originalText?.text || "",
    uri: r?.googleMapsUri || "",
  }));
  return { rating: typeof d?.rating === "number" ? d.rating : null, count: Number(d?.userRatingCount) || 0, mapsUri: d?.googleMapsUri || "", reviews };
}

// Merchant Signup — alta v2 s109: +business_type (param 8 del WF, rubro fino del asesor)
// T5a s129: +referral_code (param 9 del WF, funnel influencers C-1 v2 — atribución no bloqueante)
export async function signupMerchant({ email, password, name, business_name, category, address, phone, business_type, referral_code, terms_version }) {
  // s232 · terminos-condiciones-merchant: `terms_version` solo si el front lo manda (ver confirmOffer).
  const cuerpo = { email, password, name, business_name, category, address, phone, business_type: business_type || "", referral_code: (referral_code || "").trim() };
  if (terms_version) cuerpo.terms_version = terms_version;
  const res = await fetch(`${API_BASE}/wf/signup_merchant`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cuerpo)
  });
  const data = await res.json();
  if (!res.ok) {
    const msg = data?.body?.message || data?.message || 'Error al registrar';
    throw new Error(msg);
  }
  const resp = data?.response || data;
  // s175 FIX 1: signup_merchant devuelve HTTP 200 TAMBIEN en fallo logico (steps 0-1 del WF,
  // export 66): success viene como el STRING "no" (no un booleano) + error_code EMAIL_ALREADY_EXISTS
  // + error_message ya redactado en espanol. Sin este chequeo, res.ok=true y user_id=undefined
  // hacian caer al throw generico de abajo y el comercio veia "No se recibio user_id del servidor"
  // cuando lo que pasaba es que ya tenia cuenta. Mismo patron que redeemCoupon: mensaje del WF
  // tal cual (no traducimos aca), codigo en err.code para que la UI pueda ramificar.
  if (resp?.success === "no") {
    const err = new Error(resp?.error_message || 'Error al registrar');
    err.code = resp?.error_code || 'SIGNUP_MERCHANT_FAILED';
    throw err;
  }
  const userId = resp.user_id;
  // Fallback: 200 con exito pero sin id (no deberia pasar, pero no navegamos a ciegas).
  if (!userId) throw new Error('No se recibió user_id del servidor');

  const loginRes = await fetch(`${API_BASE}/wf/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  const loginData = await loginRes.json();
  if (!loginRes.ok) throw new Error('Cuenta creada pero error al iniciar sesión');
  const loginResp = loginData?.response || loginData;
  const token = loginResp.token;

  if (token) {
    localStorage.setItem('nxt_token', token);
    localStorage.setItem('nxt_user_id', userId);
    localStorage.setItem('nxt_tier', 'Merchant');
    localStorage.setItem('nxt_role', 'Merchant');
  }
  return { success: true, token, user_id: userId, role: 'Merchant' };
}

// ============================================
// VITRINA BETA (s195 · s194-D21/D22) — CONTRATO PROVISIONAL
// ============================================
// Las salas de s195 (seed_merchant · get_beta_catalog · invite_merchant) se construyen en
// Main SIN deploy. Hasta que Ali deploye y re-exporte, en Live estos WFs NO EXISTEN, y este
// archivo apunta a Live (API_BASE). Tres reglas de este bloque:
//  1. Una función por WF y UN SOLO lugar donde se lee el JSON-en-texto que devuelve Bubble
//     (parseBetaCatalog / parseSeededList). Si una sala vuelve con otro nombre de campo, el
//     cambio es un diff de pocas líneas acá, no en las pantallas.
//  2. Los fixtures existen SOLO en desarrollo: CRA reemplaza NODE_ENV al compilar y la rama
//     muerta no llega al bundle. En producción un WF ausente responde 404 → err.code
//     WF_NOT_DEPLOYED y la pantalla muestra su estado neutro. Nunca un fixture (#707).
//  3. get_beta_catalog e invite_merchant desde la vitrina van SIN Authorization aunque haya
//     un token guardado en el navegador: son NOAUTH y la puerta «comercio» se registra por
//     la AUSENCIA de sesión de operador. «Aprobó» desde el panel de Otto SÍ manda el token
//     (puerta «operador»). Los otros cuatro (seed · adopt · list · confirm) son con auth.
// Los otros tres WFs (adopt_merchant · get_seeded_merchants · confirm_offer) nacieron como
// PEDIDOS de Code (PLAN_s195 §4) y ya son salas escritas y linteadas (tanda 2, 17/09):
// PROMPT_EXT_s195_{adopt_merchant,get_seeded_merchants,confirm_offer}_build.md. El contrato de
// abajo es el de esas salas, salvo lo que cambien sus RESULTADOS. Tampoco existen en Live aún.

export const BETA_FIXTURES = process.env.NODE_ENV === "development";
// Dos tokens de fixture (≥ 20 caracteres, que es el guard del WF): uno con zona y otro sin.
export const BETA_FIXTURE_TOKEN = "FIXTURE-DEMO-0000000000000000000";
export const BETA_FIXTURE_TOKEN_SIN_ZONA = "FIXTURE-SINZONA-00000000000000000";

const urlHttps = (u) => { const s = String(u || ""); return s.startsWith("//") ? "https:" + s : s; };
const jsonTexto = (txt, porDefecto) => {
  if (txt == null || txt === "") return porDefecto;
  if (typeof txt !== "string") return txt;
  try { const v = JSON.parse(txt); return v == null ? porDefecto : v; } catch (e) { return porDefecto; }
};
const numero = (v) => { const n = Number(v); return isFinite(n) ? n : 0; };

// POST a un WF con la política de error de este bloque. `conToken` decide si viaja la sesión.
async function postWfBeta(endpoint, body, conToken) {
  const headers = { "Content-Type": "application/json" };
  if (conToken) {
    const t = auth.getToken();
    if (!t) { const e = new Error("No token"); e.code = "NO_SESSION"; throw e; }
    headers.Authorization = `Bearer ${t}`;
  }
  const res = await fetch(`${API_BASE}${endpoint}`, { method: "POST", headers, body: JSON.stringify(body) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.body?.message || data?.message || `Error ${res.status}`);
    // Bubble responde 404 NOT_FOUND para un WF que no existe en esa rama: es el caso
    // «todavía no deployado», y las pantallas lo tratan distinto de un error genérico.
    err.code = res.status === 404 ? "WF_NOT_DEPLOYED" : (data?.body?.status || `HTTP_${res.status}`);
    throw err;
  }
  const resp = data?.response;
  if (!resp || resp.success === false || resp.success === "no" || resp.error_code) {
    const err = new Error(resp?.error_message || resp?.error_code || `${endpoint} failed`);
    err.code = resp?.error_code || "OPERATION_FAILED";
    err.merchant_id = resp?.merchant_id || null;   // ALREADY_SEEDED trae el id del existente
    throw err;
  }
  return resp;
}

// Imagen para un parámetro `image` de un WF: mismo sobre que update_merchant_logo /
// add_merchant_photo ({filename, contents base64 sin prefijo, private}). La foto se achica
// como en la galería; el logo va tal cual.
async function archivoParaWf(file, achicar) {
  if (!file) return undefined;
  const f = achicar ? await achicarImagen(file) : file;
  const contents = await fileToBase64(f);
  return { filename: f.name, contents, private: false };
}

// ============================================
// s222 · lote 2a · LA FICHA DEL COMERCIO (`save_merchant_ficha`, export 127)
// ============================================
// El WF escribe SIEMPRE sus ocho campos (Steps 6-7): un param que no viaja BORRA ese campo. Y ningún WF los
// devuelve (get_merchant_profile no los trae). Por eso hay UN solo camino para escribirlos: guardarFicha lee los
// ocho por la Data API (privacy «Owner sees own» / «Admin sees all»), pone lo nuevo encima y manda el juego
// completo. Si no puede leerlos, NO llama al WF: mejor no guardar que borrar.
// ⚠️ La Data API omite los campos vacíos… y también los que la privacy esconde: los dos se ven igual. Que el
// dueño y el admin reciben los ocho se comprobó en test (R1 del pase s222); si una regla cambia, esto borraría.
// El Operator no tiene regla propia sobre MerchantPartner: la consola de Otto solo lo usa con `recienSembrado` (s224).
export const CAMPOS_FICHA = ["menu_url", "menu_file", "ficha_json", "auto_gratuity", "reservation_url", "wizard_json", "business_goals", "avg_ticket_usd"];
const errorFicha = (code, message) => { const e = new Error(message || code); e.code = code; return e; };
export const tieneMenu = (m) => !!(m && (String(m.menu_url || "").trim() || String(m.menu_file || "").trim()));
// Bubble guarda los archivos como «//s3…» sin protocolo.
export const urlMenu = (v) => urlHttps(String(v || "").trim());
// El tope del PDF: viaja en base64 dentro del JSON (un 33 % más gordo), desde el teléfono del comercio.
export const MENU_PDF_PESO_MAX = 5 * 1024 * 1024;

async function leerComercioCrudo(merchant_id) {
  const id = String(merchant_id || "").trim();
  const token = auth.getToken();
  if (!id || !token) throw errorFicha("FICHA_NO_LEIDA");
  let data = null;
  try {
    const res = await fetch(`${API_BASE}/obj/merchantpartner/${encodeURIComponent(id)}`, { headers: getHeaders(token) });
    if (res.ok) data = await res.json();
  } catch (e) { data = null; }
  const m = data?.response;
  if (!m || m._id !== id) throw errorFicha("FICHA_NO_LEIDA");
  return m;
}
const fichaDe = (m) => {
  const ficha = {};
  CAMPOS_FICHA.forEach(k => {
    const v = m[k];
    if (v !== undefined && v !== null && v !== "") ficha[k] = v;
  });
  return ficha;
};

export async function leerFicha(merchant_id) {
  return fichaDe(await leerComercioCrudo(merchant_id));
}

// s223 · 2b · el wizard de la primera oferta: la misma lectura (una sola), más el `place_id` para pedirle a Google
// el rango de precio (placePrecio). El dueño ve todos sus campos («Owner sees own» no declara view_fields).
// Solo lectura: el place_id no entra a guardarFicha.
export async function leerFichaYLugar(merchant_id) {
  const m = await leerComercioCrudo(merchant_id);
  // s223 · `galeria`: cuántas fotos tiene ya la galería del comercio, para no ofrecer más de las que caben (GALERIA_TOPE).
  const galeria = Array.isArray(m.gallery) ? m.gallery.filter(Boolean).length : 0;
  return { ficha: fichaDe(m), place_id: String(m.place_id || "").trim(), galeria };
}

// La foto del menú va por el mismo camino que toda imagen (regla s206): recortarImagen → 1600 px, techo de peso,
// WebP. El área es la imagen ENTERA: un menú no se encuadra (se cortarían precios).
async function menuImagenParaWf(file) {
  if (file.size > FOTO_PESO_MAX) throw errorFicha("MENU_FILE_TOO_BIG");
  const fuente = await decodificarImagen(file);
  if (!fuente) throw errorFicha("MENU_FILE_UNREADABLE");
  const area = { x: 0, y: 0, width: fuente.naturalWidth || fuente.width, height: fuente.naturalHeight || fuente.height };
  if (typeof fuente.close === "function") fuente.close();
  const chica = await recortarImagen(file, area);
  if (!chica) throw errorFicha("MENU_FILE_UNREADABLE");
  return { filename: chica.name, contents: await fileToBase64(chica), private: false };
}
async function menuArchivoParaWf(file) {
  const tipo = String(file?.type || "");
  if (tipo.startsWith("image/")) return menuImagenParaWf(file);
  if (tipo === "application/pdf") {
    if (file.size > MENU_PDF_PESO_MAX) throw errorFicha("MENU_FILE_TOO_BIG");
    return { filename: file.name || "menu.pdf", contents: await fileToBase64(file), private: false };
  }
  throw errorFicha("MENU_FILE_TYPE");
}

// guardarFicha(cambios, merchant_id?)
// · sin merchant_id: el comercio del usuario (el dueño); con merchant_id: Admin u Operator (si no, NOT_OPERATOR).
// · `cambios`: solo las claves de CAMPOS_FICHA. `menu_file` puede ser un File (foto o PDF); `menu_url` tiene que
//   ser https://. Una clave con null BORRA ese campo (a propósito).
// Devuelve la ficha releída después de guardar (null si la relectura falla: lo guardado, guardado está).
// s224 · `{ recienSembrado: true }` (solo con merchant_id): el comercio que el wizard de la consola acaba de sembrar
// en esta misma pantalla. El Operator NO puede leerlo (MerchantPartner no tiene regla para él: la Data API responde
// como si no existiera), pero no hace falta: seed_merchant no escribe ninguno de los ocho campos salvo
// `avg_ticket_usd`, que el wizard manda igual. Así que el juego completo es lo que viene en `cambios`. No vale para
// un comercio sembrado antes ni tocado por el dueño: ahí borraría. Devuelve null (no hay cómo releer).
export async function guardarFicha(cambios = {}, merchant_id, { recienSembrado = false } = {}) {
  const conId = String(merchant_id || "").trim();
  if (recienSembrado && !conId) throw errorFicha("FICHA_NO_LEIDA");
  let mid = conId;
  if (!mid) {
    const p = await getMerchantProfile().catch(() => null);
    mid = String(p?.merchant_id || "").trim();
  }
  const actual = recienSembrado ? {} : await leerFicha(mid);   // si falla, tira FICHA_NO_LEIDA y no se escribe nada
  const nuevo = {};
  for (const k of Object.keys(cambios)) {
    if (!CAMPOS_FICHA.includes(k)) continue;
    const v = cambios[k];
    if (k === "menu_url" && v !== null) {
      // s233 · menu-http-a-https (prueba con Pera Soho): Google guarda muchas webs como «http://…» y «Usar mi página» las
      // pegaba así; el link se rechazaba por no ser https. Un http:// se sube a https:// en lugar de rechazarlo.
      const u = String(v || "").trim().replace(/^http:\/\//i, "https://");
      if (!/^https:\/\/[^\s/]+\.[^\s]+$/i.test(u)) throw errorFicha("MENU_URL_INVALID");
      nuevo[k] = u;
    } else if (k === "menu_file" && v && typeof v === "object") {
      nuevo[k] = await menuArchivoParaWf(v);
    } else {
      nuevo[k] = v;
    }
  }
  const juego = { ...actual, ...nuevo };
  const body = conId ? { merchant_id: conId } : {};
  CAMPOS_FICHA.forEach(k => {
    const v = juego[k];
    if (v === null || v === undefined || v === "") return;
    // El archivo que ya estaba vuelve como su URL (Bubble acepta una URL en un parámetro file).
    body[k] = (k === "menu_file" && typeof v === "string") ? urlMenu(v) : v;
  });
  await apiPostGuarded("/wf/save_merchant_ficha", body);
  if (recienSembrado) return null;
  return leerFicha(mid).catch(() => null);
}

// ---- get_beta_catalog (NOAUTH) ----
// El único lugar donde se lee own_json / visible_json / borroso_json. Devuelve objetos
// planos con las URLs ya en https y los números ya numéricos.
export function parseBetaCatalog(resp) {
  const norm = (m) => (m && typeof m === "object") ? {
    ...m,
    logo: urlHttps(m.logo),
    photo: urlHttps(m.photo),                       // PEDIDO (PLAN §4): hoy el WF no lo manda
    benefit_value_usd: numero(m.benefit_value_usd),
    min_consumption: numero(m.min_consumption),
  } : null;
  const own = norm(jsonTexto(resp?.own_json, null));
  const visibles = jsonTexto(resp?.visible_json, []);
  const borrosos = jsonTexto(resp?.borroso_json, []);
  return {
    own,
    visibles: Array.isArray(visibles) ? visibles.map(norm).filter(Boolean) : [],
    borrosos: Array.isArray(borrosos) ? borrosos.map(norm).filter(Boolean) : [],
    count_total: numero(resp?.count_total),
    count_zone: numero(resp?.count_zone),
  };
}

export async function getBetaCatalog(t) {
  const token = String(t || "").trim();
  if (!token) { const e = new Error("INVALID_TOKEN"); e.code = "INVALID_TOKEN"; throw e; }
  if (BETA_FIXTURES && (token === BETA_FIXTURE_TOKEN || token === BETA_FIXTURE_TOKEN_SIN_ZONA)) {
    return parseBetaCatalog(fixtureBetaCatalog(token === BETA_FIXTURE_TOKEN_SIN_ZONA));
  }
  const resp = await postWfBeta("/wf/get_beta_catalog", { t: token }, false);
  return parseBetaCatalog(resp);
}

// ---- invite_merchant (NOAUTH; con sesión de Operator/Admin registra la puerta «operador») ----
// Sirve para «Quiero estar» (vitrina, sin token), «Aprobó» (panel, con token) y «Reenviar»
// (la misma llamada con el mismo correo). Devuelve { merchant_id, door, email_step }.
export async function inviteMerchant({ t, owner_email, owner_name, comoOperador = false }) {
  const token = String(t || "").trim();
  const correo = String(owner_email || "").trim().toLowerCase();
  if (BETA_FIXTURES && (token === BETA_FIXTURE_TOKEN || token === BETA_FIXTURE_TOKEN_SIN_ZONA)) {
    return fixtureInvite(correo, comoOperador);
  }
  return postWfBeta("/wf/invite_merchant", { t: token, owner_email: correo, owner_name: owner_name || "" }, comoOperador);
}

// ---- s213 · lote B+C (export 95): plan, destacados y plazo ----
// `seed_merchant`, `adopt_merchant` y `operator_update_offer` reciben `plan` (el Display del option
// set OfferPlan: cita · pareja · amigos · familia · consentirte · despues_trabajo), `highlight_1..3_es`
// y `cooldown_days` (solo 1, 7, 15, 30, 60 o 90: si no, INVALID_COOLDOWN). Todos opcionales: lo que no
// tiene valor NO viaja (en operator_update_offer, «lo que no viene, no cambia»).
export const PLAZOS_COOLDOWN = [1, 7, 15, 30, 60, 90];
function sumarParamsLoteBC(body, p) {
  if (p.plan) body.plan = p.plan;
  [1, 2, 3].forEach(i => {
    const h = String(p[`highlight_${i}_es`] || "").trim();
    if (h) body[`highlight_${i}_es`] = h;
  });
  if (numero(p.cooldown_days) > 0) body.cooldown_days = numero(p.cooldown_days);
  return body;
}
// s217 · 2bis (export 114, contratos en RESPUESTA_COWORK_s217_2bis_ofertas_por_horario.md): horario de la
// oferta, mismo formato que create_offer — días «Lun,Mar,…» (coma sola, sin tilde) y horas «HH:MM».
// Lo vacío no viaja: en seed_merchant queda todo el día; en operator_update_offer los días no cambian.
// s222 · lote 2a · el canal de canje (export 127): solo uno de los tres valores viaja; lo demás, nada (sin la clave,
// operator_update_offer no lo cambia y operator_add_offer lo deja vacío = el del rubro). Así la UI nunca puede
// provocar REDEMPTION_CHANNEL_INVALID.
export const CANALES_VALIDOS = ["dine_in", "takeout", "appointment"];
function sumarCanal(body, p) {
  const c = String(p.redemption_channel || "").trim();
  if (CANALES_VALIDOS.includes(c)) body.redemption_channel = c;
  return body;
}
function sumarHorario(body, p) {
  const dias = String(p.valid_days || "").trim();
  if (dias) body.valid_days = dias;
  if (String(p.valid_time_start || "").trim()) body.valid_time_start = String(p.valid_time_start).trim();
  if (String(p.valid_time_end || "").trim()) body.valid_time_end = String(p.valid_time_end).trim();
  return body;
}
// Solo en desarrollo, cuando el WF no existe (404): el mismo guard que la sala.
function fixtureCooldown(body) {
  if (body.cooldown_days !== undefined && !PLAZOS_COOLDOWN.includes(body.cooldown_days)) {
    const e = new Error("INVALID_COOLDOWN"); e.code = "INVALID_COOLDOWN"; throw e;
  }
}

// ---- seed_merchant (auth · Operator o Admin) ----
// `logo` y `photo` llegan como File del input; el resto son los params de la sala tal cual.
// s224-D1 · export 131: la oferta es opcional. Sin `offer_title_es` no viaja NADA de la oferta (ni el monto, ni el
// plazo, ni el horario) y el Step 8 no crea ninguna; `offer_id` vuelve vacío. El wizard de la consola siembra así y
// crea las ofertas después con operatorAddOffer. Con título, viaja como siempre (el lote y la siembra clásica).
// s233 · envía el horario del negocio a seed_merchant (en Live desde el 19/10, Cowork).
export const SEED_CON_HORARIO = true;
// s241 · T4 · el texto del negocio (lo que pega el dueño u Otto): sin espacios de más y con el tope que lee la IA (4 000).
export const TEXTO_NEGOCIO_MAX = 4000;
export const textoDelNegocio = (t) => String(t || "").replace(/\r\n/g, "\n").replace(/[ \t]+\n/g, "\n").trim().slice(0, TEXTO_NEGOCIO_MAX);

// s251 · etiquetas-fase-minima (`claude/CONTRATO_s251_etiquetas_fase_minima.md`). No se muestran ni filtran todavía (s238-D7).
// `tags_json` puede llegar vacío, cortado o mal formado: se valida y se normaliza, y lo que no sirve se descarta sin frenar nada.
const TAGS_LISTAS = ["especialidades", "como_vende", "plataformas", "promos_publicas", "senales"];
const TAGS_MAX_POR_LISTA = 5;
const tagNormal = (v) => (typeof v === "string" ? sinTilde(v).replace(/\s+/g, " ") : "");
export function tagsDeIa(texto) {
  let j;
  try { j = JSON.parse(String(texto || "")); } catch (e) { return ""; }
  if (!j || typeof j !== "object" || Array.isArray(j) || j.v !== 1) return "";
  const limpio = { v: 1, subrubro: tagNormal(j.subrubro) };
  TAGS_LISTAS.forEach(k => {
    limpio[k] = Array.isArray(j[k]) ? [...new Set(j[k].map(tagNormal).filter(Boolean))].slice(0, TAGS_MAX_POR_LISTA) : [];
  });
  const c = Number(j.confianza);
  limpio.confianza = Number.isFinite(c) ? Math.min(1, Math.max(0, c)) : 0;
  return JSON.stringify(limpio);
}

export async function seedMerchant(p = {}) {
  const conOferta = !!String(p.offer_title_es || "").trim();
  const body = {
    business_name: p.business_name, category: p.category, beta_state: p.beta_state,
    neighborhood: p.neighborhood || "", zone: p.zone || "", address: p.address || "",
    phone: p.phone || "", instagram: p.instagram || "", place_id: p.place_id || "",
    google_maps_url: p.google_maps_url || "", description_es: p.description_es || "",
  };
  if (conOferta) { body.offer_title_es = p.offer_title_es; body.benefit_value_usd = numero(p.benefit_value_usd); }
  if (numero(p.avg_ticket_usd) > 0) body.avg_ticket_usd = numero(p.avg_ticket_usd);
  if (conOferta && numero(p.min_consumption) > 0) body.min_consumption = numero(p.min_consumption);
  // s236-D6 · seed_merchant en porcentaje (Live 21/10, Cowork): `offer_type: "percent"` + `discount_pct` (≥ 20), con
  // `benefit_value_usd` = el tope. Sin porcentaje no viaja ninguno de los dos: la oferta nace «umbral» como siempre.
  // Errores nuevos: OFFER_PCT_TOO_LOW (vacío o < 20) · OFFER_TYPE_INVALID (otro tipo).
  if (conOferta && String(p.offer_type || "").toLowerCase() === "percent") {
    body.offer_type = "percent";
    body.discount_pct = numero(p.discount_pct);
  }
  // s224 · export 132: el tipo de negocio (eje del asesor; «Comida rápida» = Restaurant + comida_rapida_qsr). Vacío no viaja.
  const tipo = String(p.business_type || "").trim();
  if (tipo) body.business_type = tipo;
  // s218 · siembra v2 (sala N3, export 117): cuatro parámetros opcionales. Lo vacío no viaja.
  ["zip", "city", "address_full", "website"].forEach(k => {
    const v = String(p[k] || "").trim();
    if (v) body[k] = v;
  });
  // s241 · T1/T4 (export 157): «No tiene web» y el texto que dio el dueño (menú, servicios, lo que dictó). Con `sin_web` no viaja
  // `website` (el WF también lo apaga si llega una web: D2). El texto, recortado como en la IA de la siembra; vacío no viaja.
  if (p.sin_web === true && !body.website) body.sin_web = true;   // D2: si hay web, la web gana
  const textoNegocio = textoDelNegocio(p.texto_negocio);
  if (textoNegocio) body.texto_negocio = textoNegocio;
  const tags = tagsDeIa(p.tags_json);
  if (tags) body.tags_json = tags;
  // s233 · siembra-horario-negocio: el horario de apertura de Google, igual que lo guarda el alta del dueño
  // (`update_merchant_profile`: `business_hours` = texto de Google · `business_hours_json` = el del editor). Cowork sumó
  // los dos params a `seed_merchant` (19/10, mismo mapeo que `update_merchant_profile`); la bandera queda para apagarlo
  // de un toque si el WF cambia.
  if (SEED_CON_HORARIO) {
    ["business_hours", "business_hours_json"].forEach(k => {
      const v = String(p[k] || "").trim();
      if (v) body[k] = v;
    });
  }
  // s216 · coordenadas de Google (deploy A, S8: params `lat`/`lng` opcionales → lat_number/lng_number).
  // Un 0 o un texto no es una coordenada: no se manda, y el comercio queda sin pin (como antes).
  const lat = Number(p.lat), lng = Number(p.lng);
  if (p.lat !== "" && p.lng !== "" && Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0) {
    body.lat = lat; body.lng = lng;
  }
  const logo = await archivoParaWf(p.logo, false);
  const photo = await archivoParaWf(p.photo, true);
  if (logo) body.logo = logo;
  if (photo) body.photo = photo;
  if (conOferta) {
    sumarParamsLoteBC(body, p);
    sumarHorario(body, p);   // s217 · export 114 (S1)
  }
  try {
    return await postWfBeta("/wf/seed_merchant", body, true);
  } catch (e) {
    if (BETA_FIXTURES && e.code === "WF_NOT_DEPLOYED") { fixtureCooldown(body); return fixtureSeed(body); }
    throw e;
  }
}

// ---- suggest_seed_offer (auth · Operator o Admin) — s233, PEDIDO A COWORK, todavía NO existe en Bubble ----
// La IA propone, ANTES de sembrar (no hay merchant_id), qué pedir y «Lo esencial» de la oferta genérica, con lo que
// la siembra ya sabe del lugar. Solo sugiere: no crea ni escribe nada. Otto lo confirma o corrige en la llamada.
// Entra: business_name, category, business_type, neighborhood, website, place_id, horario_google (texto). Lo vacío no viaja.
// Sale: { success: "yes", que_pedir_es, esencial_es, instagram }. Errores: NOT_OPERATOR · WF_NOT_DEPLOYED (404).
// s233 · en Live (v3, Cowork). `instagram` = el usuario sin @ que trae la web (vacío si no lo tiene).
// s233 · v4 (PEDIDO A COWORK, puede no estar todavía): `servicios_json` (texto JSON: [{ nombre, dias, ini, fin }],
// días «Lun,Mar,Mie,…» sin tilde, horas «HH:MM» 24 h), `franja_sugerida` (el `nombre` de uno de esos servicios) y
// `tip_es` (una o dos frases para Otto). Lo que no venga o no se entienda se descarta: el front sigue con lo de v3.
// s241 · RED DE SEGURIDAD de la IA de la siembra (banco de casos, S2). Bubble parte el texto de la IA en 6 trozos por POSICIÓN
// (`|~|`): qué pedir · lo esencial · instagram · servicios (JSON) · franja · tip. Medido en Live con `raw_ia` (export #156,
// Hibachi Miami + web): la IA OMITIÓ el trozo 1 y todo corrió un lugar — «Qué pedir» recibió la descripción y el Instagram, el
// JSON de los servicios. Aquí: (1) si viene `raw_ia`, se parte de nuevo; con 5 trozos y el 1.º con cara de «Lo esencial»
// («Aplica a…»), falta «Qué pedir» y se reacomoda; (2) sin `raw_ia`, la misma huella en los campos de Bubble se reacomoda igual;
// (3) cada campo se valida: un Instagram que no es un usuario, unos servicios que no son JSON o una franja que es una frase se
// descartan. Mejor vacío que cruzado: Otto lo completa a mano.
const TROZOS_SIEMBRA = ["que_pedir_es", "esencial_es", "instagram", "servicios_json", "franja_sugerida", "tip_es"];
const pareceEsencial = (s) => /^aplica a /i.test(String(s || "").trim());
// Una línea que la IA escribió para sí misma (el conteo de delimitadores o de segmentos, o un ✓ suelto), no para el comercio.
const esLineaDeConteo = (l) => /delimitador|segmentos?\b/i.test(l) || /^\s*✓\s*$/.test(l);
export function partesDeSiembra(r = {}) {
  let t = Object.fromEntries(TROZOS_SIEMBRA.map(k => [k, String(r[k] || "").trim()]));
  const crudo = String(r.raw_ia || "");
  // s241 · humo en producción (Hibachi Miami, tipo de Google «car_repair», sin web): la IA se NEGÓ con un párrafo sin ningún
  // `|~|` («No puedo completar esta solicitud…»), que Bubble pone entero en «Qué pedir». Sin delimitadores no hay respuesta.
  if (crudo.trim() && !crudo.includes("|~|")) return Object.fromEntries(TROZOS_SIEMBRA.map(k => [k, ""]));
  if (crudo.includes("|~|")) {
    // s241 · corrida 2 (prompt v4.8, export 157): la orden «cuenta los |~| antes de responder» hizo que la IA ESCRIBIERA el
    // conteo («Contando delimitadores: 5|~|✓ …»): un trozo de más al principio, o el conteo en lugar de «Qué pedir». Las líneas
    // de conteo se borran y, si sobra un trozo vacío al principio, se quita.
    const trozos = crudo.split("|~|").map(x => x.split("\n").filter(l => !esLineaDeConteo(l)).join("\n").trim());
    // s251 · el 7.º trozo son las etiquetas (export 167): se saca antes de contar. Sin esto, con «Qué pedir» vacío la respuesta
    // normal se tomaba por la del conteo y todo corría un lugar: lo esencial en «Qué pedir» y las etiquetas en el tip.
    if (trozos[trozos.length - 1].startsWith("{")) trozos.pop();
    if (trozos.length === 7 && !trozos[0]) trozos.shift();
    if (trozos.length === 5 && pareceEsencial(trozos[0])) trozos.unshift("");
    if (trozos.length === 6) t = Object.fromEntries(TROZOS_SIEMBRA.map((k, i) => [k, trozos[i]]));
  } else if (pareceEsencial(t.que_pedir_es) && !pareceEsencial(t.esencial_es)) {
    t = { que_pedir_es: "", esencial_es: t.que_pedir_es, instagram: t.esencial_es, servicios_json: t.instagram,
      franja_sugerida: t.servicios_json, tip_es: t.franja_sugerida };
  }
  const usuario = t.instagram.replace(/^@/, "");
  const esJson = (s) => { try { return Array.isArray(JSON.parse(s)); } catch (e) { return false; } };
  return {
    que_pedir_es: pareceEsencial(t.que_pedir_es) || esLineaDeConteo(t.que_pedir_es) ? "" : t.que_pedir_es,
    esencial_es: t.esencial_es,
    instagram: /^[A-Za-z0-9._]{1,30}$/.test(usuario) ? usuario : "",
    servicios_json: t.servicios_json && esJson(t.servicios_json) ? t.servicios_json : "",
    franja_sugerida: t.franja_sugerida.length <= 30 && !/[.{[]/.test(t.franja_sugerida) ? t.franja_sugerida : "",
    tip_es: t.tip_es,
  };
}

export async function suggestSeedOffer(p = {}) {
  const body = {};
  // s241 · + google_type (export 155) · + los 6 datos de Google de T2 (export 157; formatos en datosGoogleParaIa).
  ["business_name", "category", "business_type", "neighborhood", "website", "place_id", "horario_google", "google_type",
    "google_types", "google_price", "google_rating", "google_resumen", "google_resenas", "google_sirve"].forEach(k => {
    const v = String(p[k] || "").trim();
    if (v) body[k] = v;
  });
  // s241 · T1/T4: con «No tiene web» no viaja `website` (0 Firecrawl, la IA entra en «sin web confirmado»). El texto del negocio
  // vale como la web (v4.8, Cowork).
  if (p.sin_web === true && !body.website) body.sin_web = true;   // D2: si hay web, la web gana
  const textoNegocio = textoDelNegocio(p.texto_negocio);
  if (textoNegocio) body.texto_negocio = textoNegocio;
  const r = await postWfBeta("/wf/suggest_seed_offer", body, true);
  const t = partesDeSiembra(r);
  return { que_pedir_es: t.que_pedir_es, esencial_es: t.esencial_es, instagram: t.instagram,
    servicios: serviciosDeIa(t.servicios_json, t.franja_sugerida), tip_es: t.tip_es, tags_json: tagsDeIa(r.tags_json) || tagsDeIa(String(r.raw_ia || "").split("|~|").pop()),
    // s234 · siembra-logo-desde-web (export 145): candidatos en el orden de Cowork, logo_url || logo_url_alt || favicon_url.
    // og_image_url NO es logo (es la foto social). Solo http(s): un data-URI o una ruta relativa no se pueden traer.
    logos: [...new Set([r.logo_url, r.logo_url_alt, r.favicon_url].map(u => String(u || "").trim()).filter(u => /^https?:\/\//i.test(u)))] };
}

// s233 · v4: los servicios del negocio que leyó la IA (almuerzo, happy hour, cena…) → franjas para «Cuándo vale».
// Tolerante: JSON roto, horas mal escritas o días desconocidos se descartan (mejor ninguna franja que una inventada).
const DIAS_IA = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"];
// `sinTilde` (arriba, :975) ya pasa a minúsculas y recorta.
// s233 · franjas-dias-tokens (Cowork, prueba con Pera Soho): el contrato pide «Lun,Mar,Mie,…» pero la IA puede escribir
// los días de otra forma. Se aceptan: con o sin tilde («Mié»/«Mie»), nombres completos («miércoles»), inglés («Wed»),
// rangos («Lun-Vie», «Lun–Vie», «lunes a viernes», «Mon to Fri», incluso «Vie-Dom» que da la vuelta), «fines de semana»
// y «todos los días». Devuelve los tokens en orden («Lun,Mar,…»), "" = todos los días, o null si no se entiende.
// Antes: un rango daba solo el primer día y el inglés o «fines de semana» daban "" (= todos los días).
const DIA_POR_PREFIJO = { lun: 0, mon: 0, mar: 1, tue: 1, mie: 2, wed: 2, jue: 3, thu: 3, vie: 4, fri: 4, sab: 5, sat: 5, dom: 6, sun: 6 };
function diasDeIa(texto) {
  const t = sinTilde(String(texto || "")).replace(/\s+/g, " ").trim();
  if (!t) return "";
  if (/todos|diario|cada dia|toda la semana|every ?day|daily|7 dias/.test(t)) return "";
  const idx = new Set();
  let entendi = false;
  const dia = (p) => { const k = String(p || "").trim().slice(0, 3); return k in DIA_POR_PREFIJO ? DIA_POR_PREFIJO[k] : -1; };
  // «fin(es) de semana» / «weekend(s)» = sábado y domingo; se saca antes de partir el resto.
  const sinFinde = t.replace(/fin(es)? de semana|weekends?/g, () => { idx.add(5); idx.add(6); entendi = true; return ","; });
  sinFinde.split(/\s*(?:,|;|\/|&|\by\b|\band\b)\s*/).forEach(pieza => {
    if (!pieza) return;
    const r = /^(.+?)\s*(?:-|–|—|\ba\b|\bal\b|\bto\b|\bthrough\b|\bthru\b)\s*(.+)$/.exec(pieza);
    if (r) {
      const a = dia(r[1]), b = dia(r[2]);
      if (a < 0 || b < 0) return;
      for (let i = a; ; i = (i + 1) % 7) { idx.add(i); if (i === b) break; }
      entendi = true;
    } else {
      const d = dia(pieza);
      if (d >= 0) { idx.add(d); entendi = true; }
    }
  });
  if (!entendi) return null;
  if (idx.size === 7) return "";
  return DIAS_IA.filter((_, i) => idx.has(i)).join(",");
}
function serviciosDeIa(json, sugerida) {
  let lista;
  try { lista = typeof json === "string" ? JSON.parse(json || "[]") : json; } catch (e) { return []; }
  if (!Array.isArray(lista)) return [];
  const hora = (h) => { const m = /^(\d{1,2}):(\d{2})$/.exec(String(h || "").trim()); return m && +m[1] < 24 && +m[2] < 60 ? `${m[1].padStart(2, "0")}:${m[2]}` : ""; };
  const nombreSug = sinTilde(sugerida || "");
  return lista.map((s, i) => {
    const nombre = String(s?.nombre || "").trim();
    const ini = hora(s?.ini), fin = hora(s?.fin);
    if (!nombre || !ini || !fin) return null;
    const dias = diasDeIa(s?.dias);
    if (dias === null) return null;   // s233 · días que no se entienden: fuera (antes quedaban vacíos = todos los días)
    return { key: `ia-${i}`, nombre: nombre.slice(0, 24), ini, fin, dias,
      sugerida: !!nombreSug && sinTilde(nombre) === nombreSug };
  }).filter(Boolean).slice(0, 6);
}

// ---- adopt_merchant (auth · Operator o Admin) — sala s195 (tanda 2) ----
// Devuelve { merchant_id, offer_id, beta_token }. `offer_id` viene VACÍO si el comercio ya tenía
// una umbral (Step 10 no corre); `beta_token` viene siempre (se relee tras el Step 5).
// Errores: NOT_OPERATOR · MERCHANT_NOT_FOUND.
export async function adoptMerchant(p = {}) {
  const body = {
    merchant_id: p.merchant_id, beta_state: p.beta_state,
    offer_title_es: p.offer_title_es, benefit_value_usd: numero(p.benefit_value_usd),
  };
  if (numero(p.min_consumption) > 0) body.min_consumption = numero(p.min_consumption);
  if (numero(p.avg_ticket_usd) > 0) body.avg_ticket_usd = numero(p.avg_ticket_usd);
  if (p.description_es) body.description_es = p.description_es;
  // s213 · si el comercio ya tenía una oferta, adopt NO crea otra y estos valores no se escriben
  // (offer_id vacío): se corrigen después con operatorUpdateOffer.
  sumarParamsLoteBC(body, p);
  try {
    return await postWfBeta("/wf/adopt_merchant", body, true);
  } catch (e) {
    if (BETA_FIXTURES && e.code === "WF_NOT_DEPLOYED") {
      fixtureCooldown(body);
      const r = fixtureSeed({ ...body, business_name: p.business_name || "(adoptado)" });
      // Fixture: un comercio cuyo id empieza por "fx-conoferta" ya tenía oferta → offer_id vacío.
      return String(p.merchant_id || "").startsWith("fx-conoferta") ? { ...r, offer_id: "" } : r;
    }
    throw e;
  }
}

// ---- operator_update_offer (auth · Admin u Operator) — s213, sala S2, export 95 ----
// Corrige plan, destacados y plazo de una oferta sembrada o adoptada sin pedirle nada al dueño.
// Lo que no viene, no cambia (el WF hace `:defaulting to` del valor actual). Devuelve { success, offer_id }.
// Errores: NOT_OPERATOR · OFFER_NOT_FOUND · INVALID_COOLDOWN.
// s217 · export 114 (S2): también `offer_title_es`, `benefit_value_usd`, `min_consumption` y el horario. Si
// viene CUALQUIERA de esos y la oferta no está Pending → OFFER_NOT_PENDING; monto ≤ 0 → OFFER_BENEFIT_INVALID.
export async function operatorUpdateOffer(p = {}) {
  const body = sumarParamsLoteBC({ offer_id: String(p.offer_id || "").trim() }, p);
  if (!body.offer_id) { const e = new Error("OFFER_NOT_FOUND"); e.code = "OFFER_NOT_FOUND"; throw e; }
  if (String(p.offer_title_es || "").trim()) body.offer_title_es = String(p.offer_title_es).trim();
  if (numero(p.benefit_value_usd) > 0) body.benefit_value_usd = numero(p.benefit_value_usd);
  if (numero(p.min_consumption) > 0) body.min_consumption = numero(p.min_consumption);
  sumarHorario(body, p);
  sumarCanal(body, p);   // s222 · con la oferta fuera de Pending → OFFER_NOT_PENDING (export 127)
  // s227 · export 138 (param #13, `bTJtF`): la foto de la oferta. Una URL (la galería del comercio) o
  // { filename, contents, private } (una nueva). Vacía no viaja y la foto queda como está.
  if (p.image && (typeof p.image === "string" ? p.image.trim() : p.image.contents)) body.image = p.image;
  try {
    return await postWfBeta("/wf/operator_update_offer", body, true);
  } catch (e) {
    if (BETA_FIXTURES && e.code === "WF_NOT_DEPLOYED") {
      fixtureCooldown(body);
      if (body.offer_id.startsWith("fx-noexiste")) { const x = new Error("OFFER_NOT_FOUND"); x.code = "OFFER_NOT_FOUND"; throw x; }
      return { success: true, offer_id: body.offer_id };
    }
    throw e;
  }
}

// ---- s227-D1 · verificación del correo del dueño (OTP) ----
// `send_email_otp` (sin params) y `verify_email_otp` (`code`), build de Cowork en Main (pase s227). Devuelven la
// respuesta TAL CUAL, sin tirar por `error_code`: la pantalla del código decide qué hacer con cada uno
// (OTP_TOO_SOON no es un error, ALREADY_VERIFIED es «ya está», OTP_INVALID trae `attempts_left`). Solo tiran si no
// hay sesión, si la red falla o si Bubble responde HTTP de error (WF_NOT_DEPLOYED si el WF no existe en esa rama).
async function postWfOtp(endpoint, body) {
  const t = auth.getToken();
  if (!t) { const e = new Error("No token"); e.code = "NO_SESSION"; throw e; }
  const res = await fetch(`${API_BASE}${endpoint}`, {
    method: "POST", headers: { "Content-Type": "application/json", Authorization: `Bearer ${t}` }, body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.body?.message || data?.message || `Error ${res.status}`);
    err.code = res.status === 404 ? "WF_NOT_DEPLOYED" : (data?.body?.status || `HTTP_${res.status}`);
    throw err;
  }
  const r = data?.response || {};
  const si = (v) => v === true || v === "yes" || v === "true";
  // s228 · export 140: verify_email_otp también trae por qué no se aprobó solo (tiene_place_id · correo_personal · web_google).
  // Sin esos campos (antes del 140) quedan en null y la pantalla usa el texto de siempre.
  const siONull = (v) => (v === undefined || v === null || v === "" ? null : si(v));
  return { ...r, ok: si(r.success) && !r.error_code, error_code: r.error_code || "", verified: si(r.verified), auto_approved: si(r.auto_approved),
    tiene_place_id: siONull(r.tiene_place_id), correo_personal: siONull(r.correo_personal), web_google: String(r.web_google || "").trim(),
    attempts_left: r.attempts_left === undefined || r.attempts_left === null || r.attempts_left === "" ? null : Number(r.attempts_left) };
}
export async function sendEmailOtp() {
  return postWfOtp("/wf/send_email_otp", {});
}
export async function verifyEmailOtp(code) {
  return postWfOtp("/wf/verify_email_otp", { code: String(code || "").replace(/\D/g, "").slice(0, 6) });
}
// s228 · `cambiar-correo-registro` (pedido a Cowork, pase s228): el dueño cambia su correo de registro por el de su
// empresa. Devuelve { ok, email } o error_code ∈ NOT_MERCHANT · INVALID_EMAIL · SAME_EMAIL · EMAIL_ALREADY_EXISTS ·
// CHANGE_RATE_LIMIT. No manda el código: después se llama sendEmailOtp. Sin el WF en esa versión → WF_NOT_DEPLOYED.
export async function changeRegistrationEmail(new_email) {
  return postWfOtp("/wf/change_registration_email", { new_email: String(new_email || "").trim().toLowerCase() });
}

// ---- operator_add_offer (auth · Operator o Admin) — s217, sala S3, export 114 ----
// Otra oferta (otra franja: almuerzo, cena, lounge…) para un comercio sembrado. Nace Pending. Devuelve
// { success, offer_id, merchant_id }. Errores: NOT_OPERATOR · MERCHANT_NOT_FOUND · NOT_SEEDED ·
// MERCHANT_REJECTED · INVALID_COOLDOWN · OFFER_BENEFIT_INVALID · TOO_MANY_OFFERS (≥ 4 sin archivar).
// No copia foto, destacados ni descripción de la siembra (s227: la foto de la oferta viaja en `image`, abajo).
export async function operatorAddOffer(p = {}) {
  const body = {
    merchant_id: String(p.merchant_id || "").trim(),
    offer_title_es: String(p.offer_title_es || "").trim(),
    benefit_value_usd: numero(p.benefit_value_usd),
  };
  if (!body.merchant_id) { const e = new Error("MERCHANT_NOT_FOUND"); e.code = "MERCHANT_NOT_FOUND"; throw e; }
  if (numero(p.min_consumption) > 0) body.min_consumption = numero(p.min_consumption);
  // s221-D1 · export 125: «percent» con `discount_pct` (≥ 20) y `benefit_value_usd` = el tope; Bubble deriva
  // `regular_price`. Sin `offer_type` queda «umbral», como siempre.
  if (p.offer_type === "percent") {
    body.offer_type = "percent";
    body.discount_pct = numero(p.discount_pct);
    delete body.min_consumption;
  }
  // s224 · el 2×1 (Steps 20-23 y 28, export 131): `unit_price` > 0 o OFFER_PRICE_INVALID; Bubble pone el beneficio
  // = unit_price y `regular_price` = 2×. `benefit_value_usd` igual tiene que llegar > 0 (Step 10): va el mismo precio.
  if (p.offer_type === "bogo") {
    body.offer_type = "bogo";
    body.unit_price = numero(p.unit_price);
    body.benefit_value_usd = numero(p.unit_price);
    delete body.min_consumption;
  }
  sumarParamsLoteBC(body, p);
  sumarHorario(body, p);
  sumarCanal(body, p);   // s222 · export 127
  // s224 · export 133: `is_alcohol` (solo viaja si es sí) y `rules_text_es`, que REEMPLAZA entero las reglas que arma
  // Bubble (Step 31, después de los del % y del 2×1). Se manda el texto completo, igual que a create_offer; vacío no
  // viaja y quedan las de Bubble.
  if (p.is_alcohol === true) body.is_alcohol = true;
  const reglas = String(p.rules_text_es || "").trim();
  if (reglas) body.rules_text_es = reglas;
  // s227 · export 138 (param #15, `bTJtE`): la foto de la oferta, { filename, contents, private } como en create_offer.
  // Vacía no viaja y la oferta queda como antes (la tarjeta cae al logo).
  if (p.image && p.image.contents) body.image = p.image;
  return await postWfBeta("/wf/operator_add_offer", body, true);
}

// ---- get_seeded_merchants (auth · Operator o Admin) — sala s195 (tanda 2) ----
// Sin parámetros (no hay only_mine). Devuelve { count, list_json }; por item las fechas son texto
// ISO (o "" si vacías), los números ya vienen con 0 por defecto y offer_is_active es boolean.
// El único lugar donde se lee list_json. Error: NOT_OPERATOR.
export function parseSeededList(resp) {
  const lista = jsonTexto(resp?.list_json, []);
  return (Array.isArray(lista) ? lista : []).map(m => ({
    ...m,
    logo: urlHttps(m.logo),
    // s216 · deploy D (export 113): UN texto con las URLs separadas por «,» (vacío = sin fotos). Se
    // guardan TAL CUAL («//…»): admin_remove_merchant_photo compara contra esa forma (s203 §3-3).
    gallery_urls: String(m.gallery_urls || "").split(",").map(s => s.trim()).filter(Boolean),
    beta_opens_count: numero(m.beta_opens_count),
    invite_sent_count: numero(m.invite_sent_count),
    benefit_value_usd: numero(m.benefit_value_usd),
    min_consumption: numero(m.min_consumption),
    // s239 · seeded-merchants-offer-type-pct: claves nuevas (pedido a Cowork). Ausentes = como antes; no se inventan.
    ...("discount_pct" in m ? { discount_pct: numero(m.discount_pct) } : {}),
    ...("offer_type" in m ? { offer_type: String(m.offer_type || "").toLowerCase() } : {}),
    // s218 · mini CRM (export 117): las dos fechas de llamada llegan en milisegundos UNIX como texto
    // («"1791…"», vacío = nunca). Se pasan a número (0 = sin fecha) para comparar con «hoy».
    next_call_at: fechaMs(m.next_call_at),
    last_call_at: fechaMs(m.last_call_at),
  }));
}
// Milisegundos UNIX (número o texto) o ISO → número de ms; 0 si no hay fecha.
function fechaMs(v) {
  if (v === null || v === undefined || v === "") return 0;
  if (/^\d+$/.test(String(v).trim())) return Number(v);
  const t = new Date(v).getTime();
  return isFinite(t) ? t : 0;
}
export async function getSeededMerchants() {
  try {
    const resp = await postWfBeta("/wf/get_seeded_merchants", {}, true);
    return parseSeededList(resp);
  } catch (e) {
    if (BETA_FIXTURES && e.code === "WF_NOT_DEPLOYED") return parseSeededList(fixtureSeededList());
    throw e;
  }
}

// ---- get_catalogo_preapertura (sin login) — s227, `preinauguracion-todo-borroso`, export 139 (bTJtG) ----
// { abierto } y, cerrado, { count, tarjetas: [{ offer_id, rubro, zona, tipo, monto, pct, minimo }] }. Las tarjetas
// NO traen nombre, foto ni título. Si falla, quien llama toma el club como CERRADO.
export async function getCatalogoPreapertura() {
  const r = await postWfBeta("/wf/get_catalogo_preapertura", {}, false);
  const si = (v) => v === true || v === "yes" || v === "true";
  if (si(r?.abierto)) return { abierto: true, count: 0, tarjetas: [] };
  const lista = jsonTexto(r?.tarjetas_json, []);
  return {
    abierto: false,
    count: numero(r?.count_comercios),
    tarjetas: (Array.isArray(lista) ? lista : []).map(t => ({
      offer_id: String(t.offer_id || ""), rubro: String(t.rubro || ""), zona: String(t.zona || ""),
      tipo: String(t.tipo || ""), monto: numero(t.monto_usd), pct: numero(t.pct), minimo: numero(t.minimo),
    })).filter(t => t.offer_id),
  };
}

// ---- get_signups_to_verify (auth · Operator o Admin) — s227, `lista-por-verificar`, export 137 (bTJsz) ----
// Los self-serve sin aprobar (beta_state vacío, status ≠ Approved y ≠ Rejected), alta más vieja primero.
// `list_json` es TEXTO con un arreglo, como get_seeded_merchants. Los sí/no llegan "true"/"false"; las fechas de
// llamada en ms UNIX como texto y `created_at` en ISO. Error: NOT_OPERATOR.
export async function getSignupsToVerify() {
  const resp = await postWfBeta("/wf/get_signups_to_verify", {}, true);
  const lista = jsonTexto(resp?.list_json, []);
  const si = (v) => v === true || v === "true" || v === "yes";
  return (Array.isArray(lista) ? lista : []).map(m => ({
    ...m,
    created_at: fechaMs(m.created_at),
    last_call_at: fechaMs(m.last_call_at),
    next_call_at: fechaMs(m.next_call_at),
    email_verified: si(m.email_verified),
    contact_decides: si(m.contact_decides),
    offers_count: numero(m.offers_count),
  }));
}

// ---- confirm_offer (auth · dueño) — sala s195 (tanda 2) ----
// Pending → Approved + is_active, y el comercio Invitado → Approved. Decisión de Ali (17/09): la
// aprobación automática vale SOLO con el comercio en Invitado o ya Approved; Lead y PendingReview
// reciben NOT_INVITED y siguen por approve_merchant manual. Errores, en este orden de guards:
// OFFER_NOT_FOUND · NOT_OWNER · OFFER_NOT_PENDING · NOT_INVITED · OFFER_BENEFIT_INVALID.
// s217 · export 114 (S4): `skip_emails` = yes confirma sin mandar los correos. Con varias ofertas Pending,
// React confirma todas con skip_emails y la ÚLTIMA sin él → los dos correos salen una sola vez.
export async function confirmOffer(offer_id, { skipEmails = false, termsVersion = "" } = {}) {
  try {
    // s232 · terminos-condiciones-merchant: `terms_version` viaja solo cuando el front lo pide (TERMINOS_ALIADOS.enviarParam),
    // es decir, cuando Cowork haya agregado el parámetro a confirm_offer (SPEC_s232 §2). Hasta entonces el cuerpo no cambia.
    const cuerpo = skipEmails ? { offer_id, skip_emails: "yes" } : { offer_id };
    if (termsVersion) cuerpo.terms_version = termsVersion;
    return await postWfBeta("/wf/confirm_offer", cuerpo, true);
  } catch (e) {
    if (BETA_FIXTURES && e.code === "WF_NOT_DEPLOYED") return { success: true, offer_id, new_status: "Approved" };
    throw e;
  }
}

// ---- s218 · mini CRM de llamadas (export 117; salas N4/N5) — auth · Operator o Admin ----
// Contratos: claude/siembra/PEDIDO_CODE_s217_siembra_v2.md §3. `success` es yes/no y el error viene
// en `error_code` (postWfBeta ya cubre los dos). `outcome` y `pipeline_stage` viajan como CÓDIGO; la
// pantalla muestra las etiquetas (OUTCOMES_LLAMADA / ETAPAS_CRM en App.jsx).
// Errores comunes: NOT_OPERATOR · MERCHANT_NOT_FOUND.

// operator_log_call → { success, call_id }. Lo vacío no viaja: `next_call_at` sin valor deja el campo
// del comercio vacío (a propósito, en el WF), y `pipeline_stage` sin valor no cambia la etapa.
export async function operatorLogCall(p = {}) {
  const body = { merchant_id: String(p.merchant_id || "").trim(), outcome: String(p.outcome || "").trim() };
  ["spoke_with", "decision_maker", "approved_by", "notes", "pipeline_stage"].forEach(k => {
    const v = String(p[k] || "").trim();
    if (v) body[k] = v;
  });
  if (p.next_call_at) body.next_call_at = p.next_call_at;   // ISO 8601 (Bubble lo lee como date)
  return postWfBeta("/wf/operator_log_call", body, true);
}

// operator_discard_merchant → { success, merchant_id }. Deja el comercio en Rejected (etapa
// «descartado», beta demo) y archiva sus ofertas Pending. Errores extra: HAS_OWNER (ya tiene dueño)
// · NOT_YOURS (un Operator solo descarta lo que sembró él).
export async function operatorDiscardMerchant(merchant_id, reason) {
  return postWfBeta("/wf/operator_discard_merchant",
    { merchant_id: String(merchant_id || "").trim(), reason: String(reason || "").trim() }, true);
}

// s219 · check_place_id (auth · Operator o Admin): ¿ese place_id ya está en TODA la base? Se pregunta al elegir el
// lugar en Google, antes de llenar nada. Bubble omite las claves vacías: aquí salen como "". Si el WF no está en
// esta versión o falla, devuelve null y no frena nada (ALREADY_SEEDED de seed_merchant sigue de red).
export async function checkPlaceId(place_id) {
  const pid = String(place_id || "").trim();
  if (!pid) return null;
  try {
    const r = await postWfBeta("/wf/check_place_id", { place_id: pid }, true);
    return {
      place_id: pid,
      exists: r.exists === "yes",
      count: Number(r.count) || 0,
      merchant_id: r.merchant_id || "",
      business_name: r.business_name || "",
      status: r.status || "",
      beta_state: r.beta_state || "",
      seeded_by_me: r.seeded_by_me === "yes",
      discarded: r.discarded === "yes",
    };
  } catch (e) {
    return null;
  }
}

// get_call_log → lista de llamadas, la más nueva primero. `calls_json` es TEXTO con `called_at` y
// `next_call_at` en ms UNIX entre comillas; aquí salen como número (0 = sin fecha).
export async function getCallLog(merchant_id) {
  const resp = await postWfBeta("/wf/get_call_log", { merchant_id: String(merchant_id || "").trim() }, true);
  const lista = jsonTexto(resp?.calls_json, []);
  return (Array.isArray(lista) ? lista : []).map(c => ({
    ...c,
    called_at: fechaMs(c.called_at),
    next_call_at: fechaMs(c.next_call_at),
  }));
}

// ---- FIXTURES (solo desarrollo; ver BETA_FIXTURES) ----
// Reproducen la FORMA exacta del contrato (JSON como TEXTO, números formateados, URLs con
// «//») para que el parser de arriba se ejercite igual que con el WF real.
function fixtureBetaCatalog(sinZona) {
  const foto = (id) => `https://images.unsplash.com/${id}?w=600&h=400&fit=crop`;
  return {
    success: true,
    own_json: JSON.stringify({
      merchant_id: "fx-own", business_name: "La Ventana Brickell", category: "Restaurant",
      neighborhood: "Brickell", zone: sinZona ? "" : "Brickell",
      description_es: "Cocina de mercado con vista al río. Almuerzo ejecutivo y cena a la carta.",
      logo: "//placehold.co/200x200/png", beta_state: "demo", status: "Lead",
      offer_title: "Recibe $30 si gastas $60", benefit_value_usd: 30, min_consumption: 60,
    }),
    visible_json: JSON.stringify([
      { merchant_id: "fx-v1", business_name: "Aura Spa Coral Gables", logo: "//placehold.co/200x200/png",
        category: "Salon_Spa", neighborhood: "Coral Gables", offer_title: "Recibe $50 si gastas $100",
        benefit_value_usd: 50, min_consumption: 100, photo: foto("photo-1544161515-4ab6ce6db874") },
      { merchant_id: "fx-v2", business_name: "Dulce Wynwood", logo: "//placehold.co/200x200/png",
        category: "Sweets", neighborhood: "Wynwood", offer_title: "$10 para gastar",
        benefit_value_usd: 10, min_consumption: 10 },
    ]),
    borroso_json: JSON.stringify([
      { category: "Restaurant", neighborhood: "Brickell", benefit_value_usd: 20, min_consumption: 40 },
      { category: "Bar_Rooftop", neighborhood: "Downtown", benefit_value_usd: 30, min_consumption: 60 },
      { category: "Experience", neighborhood: "Little Havana", benefit_value_usd: 20, min_consumption: 40 },
    ]),
    count_total: 6,
    count_zone: sinZona ? 0 : 3,
  };
}
function fixtureInvite(correo, comoOperador) {
  const err = (code, msg) => { const e = new Error(msg || code); e.code = code; return e; };
  if (!correo.includes("@")) throw err("INVALID_EMAIL");
  if (correo.startsWith("otro@")) throw err("ALREADY_INVITED");
  if (correo.startsWith("existe@")) throw err("EMAIL_ALREADY_EXISTS", "Ya existe una cuenta con ese correo.");
  if (correo.startsWith("tope@")) throw err("TOO_MANY_INVITES");
  if (correo.startsWith("caido@")) throw err("WF_NOT_DEPLOYED");
  return { success: true, merchant_id: "fx-own", door: comoOperador ? "operador" : "comercio",
           email_step: correo.startsWith("sinmail@") ? "no" : "si" };
}
function fixtureSeed(body) {
  if (String(body.place_id || "").startsWith("ya-")) {
    const e = new Error("ALREADY_SEEDED"); e.code = "ALREADY_SEEDED"; e.merchant_id = "fx-existente"; throw e;
  }
  // Para el lote (tanda 2): un nombre que empiece por "ERROR" simula un fallo genérico del WF.
  if (String(body.business_name || "").toUpperCase().startsWith("ERROR")) {
    const e = new Error("Fallo simulado"); e.code = "OPERATION_FAILED"; throw e;
  }
  const n = Date.now().toString(36);
  return { success: true, merchant_id: `fx-${n}`, offer_id: `fxo-${n}`, beta_token: BETA_FIXTURE_TOKEN };
}
function fixtureSeededList() {
  const hace = (h) => new Date(Date.now() - h * 3600e3).toISOString();
  return {
    success: true, count: 3,
    list_json: JSON.stringify([
      { merchant_id: "fx-own", business_name: "La Ventana Brickell", category: "Restaurant", neighborhood: "Brickell",
        zone: "Brickell", beta_state: "demo", status: "Lead", beta_token: BETA_FIXTURE_TOKEN, seeded_at: hace(30),
        seeded_by_name: "Otto", beta_opens_count: 4, beta_first_open_at: hace(20), beta_last_open_at: hace(2),
        invited_at: "", invite_door: "", invite_sent_count: 0, owner_email: "",
        offer_id: "fxo-1", offer_title: "Recibe $30 si gastas $60", benefit_value_usd: 30, min_consumption: 60,
        offer_status: "Pending", offer_is_active: false },
      { merchant_id: "fx-v1", business_name: "Aura Spa Coral Gables", category: "Salon_Spa", neighborhood: "Coral Gables",
        zone: "Coral Gables", beta_state: "visible", status: "Invitado", beta_token: "FIXTURE-V1-000000000000000000000",
        seeded_at: hace(50), seeded_by_name: "Otto", beta_opens_count: 9, beta_first_open_at: hace(48), beta_last_open_at: hace(5),
        invited_at: hace(6), invite_door: "comercio", invite_sent_count: 1, owner_email: "duena@auraspa.com",
        offer_id: "fxo-2", offer_title: "Recibe $50 si gastas $100", benefit_value_usd: 50, min_consumption: 100,
        offer_status: "Pending", offer_is_active: false },
      { merchant_id: "fx-b1", business_name: "Rooftop Downtown", category: "Bar_Rooftop", neighborhood: "Downtown",
        zone: "Downtown", beta_state: "borroso", status: "Lead", beta_token: "FIXTURE-B1-000000000000000000000",
        seeded_at: hace(70), seeded_by_name: "Otto", beta_opens_count: 0, beta_first_open_at: "", beta_last_open_at: "",
        invited_at: "", invite_door: "", invite_sent_count: 0, owner_email: "",
        offer_id: "fxo-3", offer_title: "Recibe $30 si gastas $60", benefit_value_usd: 30, min_consumption: 60,
        offer_status: "Pending", offer_is_active: false },
    ]),
  };
}
